/* ========================================
   BK-MEDIA CUSTOM SCRIPTS
   ======================================== */

function initAudioPlayers() {
  document.querySelectorAll('.bk-media-audio-player:not([data-initialized])').forEach(function(player) {
    var audio = player.querySelector('.bk-media-audio-player__audio');
    var playBtn = player.querySelector('.bk-media-audio-player__play-btn');
    var playIcon = player.querySelector('.bk-media-audio-player__play-icon');
    var pauseIcon = player.querySelector('.bk-media-audio-player__pause-icon');
    var waveform = player.querySelector('.bk-media-audio-player__waveform');
    var bars = player.querySelectorAll('.bk-media-audio-player__waveform-bar');
    var durationEl = player.querySelector('.bk-media-audio-player__duration');
    if (!audio || !playBtn || !waveform) return;
    if (!audio.querySelector('source')) return;
    player.setAttribute('data-initialized', 'true');
    audio.load();

    function formatTime(seconds) {
      if (!isFinite(seconds) || isNaN(seconds)) return '0:00';
      var m = Math.floor(seconds / 60);
      var s = Math.floor(seconds % 60);
      return m + ':' + (s < 10 ? '0' : '') + s;
    }

    function updateDurationDisplay() {
      if (durationEl && audio.duration && isFinite(audio.duration)) {
        durationEl.textContent = formatTime(audio.duration);
      }
    }

    function stopAllOtherPlayers() {
      document.querySelectorAll('.bk-media-audio-player__audio').forEach(function(other) {
        if (other !== audio) {
          other.pause();
          var otherPlayer = other.closest('.bk-media-audio-player');
          if (otherPlayer) {
            var op = otherPlayer.querySelector('.bk-media-audio-player__play-icon');
            var oq = otherPlayer.querySelector('.bk-media-audio-player__pause-icon');
            if (op) op.style.display = '';
            if (oq) oq.style.display = 'none';
          }
        }
      });
    }

    function updateProgress() {
      if (!audio.duration || !isFinite(audio.duration)) return;
      var progress = (audio.currentTime / audio.duration) * 100;
      var waveformRect = waveform.getBoundingClientRect();
      var firstBar = bars[0];
      var barWithGap = 4;
      if (firstBar) {
        var barRect = firstBar.getBoundingClientRect();
        var gap = parseFloat(getComputedStyle(firstBar.parentElement).gap) || 2;
        barWithGap = barRect.width + gap;
      }
      var visibleCount = Math.max(1, Math.min(bars.length, Math.floor(waveformRect.width / barWithGap)));
      var playedBarsCount = (progress / 100) * visibleCount;
      var fullBars = Math.floor(playedBarsCount);
      var partialBarIndex = fullBars;
      var partialFill = playedBarsCount - fullBars;
      bars.forEach(function(bar, i) {
        bar.classList.remove('played', 'is-partially-active');
        if (i < fullBars) {
          bar.classList.add('played');
        } else if (i === partialBarIndex && partialFill > 0) {
          bar.classList.add('played', 'is-partially-active');
          bar.style.opacity = 0.3 + (0.7 * partialFill);
        } else {
          bar.style.opacity = '';
        }
      });
    }

    playBtn.addEventListener('click', function() {
      if (audio.paused) {
        stopAllOtherPlayers();
        audio.play().catch(function() {});
        setTimeout(updateDurationDisplay, 100);
        if (playIcon) playIcon.style.display = 'none';
        if (pauseIcon) pauseIcon.style.display = '';
      } else {
        audio.pause();
        if (playIcon) playIcon.style.display = '';
        if (pauseIcon) pauseIcon.style.display = 'none';
      }
    });

    playBtn.addEventListener('mouseenter', function() {
      audio.preload = 'auto';
    });

    audio.addEventListener('loadedmetadata', updateDurationDisplay);
    audio.addEventListener('durationchange', updateDurationDisplay);
    audio.addEventListener('canplay', updateDurationDisplay);
    audio.addEventListener('timeupdate', updateProgress);
    audio.addEventListener('ended', function() {
      if (playIcon) playIcon.style.display = '';
      if (pauseIcon) pauseIcon.style.display = 'none';
      bars.forEach(function(bar) {
        bar.classList.remove('played', 'is-partially-active');
        bar.style.opacity = '';
      });
    });

    waveform.addEventListener('click', function(e) {
      var rect = waveform.getBoundingClientRect();
      var clickPercentage = Math.max(0, Math.min(1, (e.clientX - rect.left) / rect.width));
      audio.currentTime = clickPercentage * audio.duration;
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAudioPlayers);
} else {
  initAudioPlayers();
}

document.addEventListener('product:rerender', function() {
  document.querySelectorAll('.bk-media-audio-player').forEach(function(p) {
    p.removeAttribute('data-initialized');
  });
  setTimeout(initAudioPlayers, 100);
});

document.addEventListener('shopify:section:load', function() {
  document.querySelectorAll('.bk-media-audio-player').forEach(function(p) {
    p.removeAttribute('data-initialized');
  });
  setTimeout(initAudioPlayers, 100);
});

/* ========================================
   ESTIMATED DELIVERY DATES
   ======================================== */

var bkMediaDeliveryMonths = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];
var bkMediaDeliveryDayNames = { 0: 'So.', 1: 'Mo.', 2: 'Di.', 3: 'Mi.', 4: 'Do.', 5: 'Fr.', 6: 'Sa.' };
var bkMediaDeliveryCutoffHour = 15;
var bkMediaDeliveryHolidayCache = {};

function bkMediaFetchPublicHolidays(year) {
  if (bkMediaDeliveryHolidayCache[year]) {
    return Promise.resolve(bkMediaDeliveryHolidayCache[year]);
  }
  return fetch('https://date.nager.at/api/v3/PublicHolidays/' + year + '/DE')
    .then(function (response) {
      if (!response.ok) throw new Error('holidays');
      return response.json();
    })
    .then(function (holidays) {
      var parsed = holidays
        .filter(function (holiday) {
          return holiday.types && holiday.types.indexOf('Public') !== -1;
        })
        .map(function (holiday) {
          return new Date(holiday.date);
        });
      bkMediaDeliveryHolidayCache[year] = parsed;
      return parsed;
    });
}

function bkMediaIsPublicHoliday(date, holidays) {
  return holidays.some(function (holiday) {
    return holiday.toDateString() === date.toDateString();
  });
}

function bkMediaIsShippingDay(date, holidays) {
  var day = date.getDay();
  return day >= 1 && day <= 5 && !bkMediaIsPublicHoliday(date, holidays);
}

function bkMediaNextShippingDay(date, holidays) {
  var next = new Date(date);
  next.setDate(next.getDate() + 1);
  while (!bkMediaIsShippingDay(next, holidays)) {
    next.setDate(next.getDate() + 1);
  }
  return next;
}

function bkMediaSkipNonDeliveryDays(date, holidays) {
  while (date.getDay() === 0 || bkMediaIsPublicHoliday(date, holidays)) {
    date.setDate(date.getDate() + 1);
  }
  return date;
}

function bkMediaApplyDeliveryFallback(root, fallbackText) {
  if (!fallbackText) return;
  var ship = root.querySelector('.ship_information');
  if (!ship) return;
  ship.textContent = '';
  var span = document.createElement('span');
  span.className = 'text-sm';
  span.textContent = fallbackText;
  ship.appendChild(span);
}

function bkMediaBuildInStockDeliveryHtml(root) {
  var idSuffix = root.getAttribute('data-id') || '';
  var prefix = root.getAttribute('data-in-stock-prefix') || '';
  var estimatePrefix = root.getAttribute('data-estimate-prefix') || '';
  var joiner = root.getAttribute('data-date-joiner') || '';
  return (
    '<span class="main-shipping">' + prefix + '</span>' +
    estimatePrefix +
    ' <strong><span class="fromDate' + idSuffix + '"></span> ' + joiner + ' <span class="toDate' + idSuffix + '"></span></strong>'
  );
}

function bkMediaSetDeliveryOutOfStock(root) {
  var ship = root.querySelector('.ship_information');
  if (!ship) return;
  var text = root.getAttribute('data-out-of-stock-text') || '';
  root.classList.add('is-out-of-stock');
  root.removeAttribute('data-delivery-estimates');
  root.setAttribute('data-in-stock', 'false');
  ship.innerHTML = '<span class="main-shipping main-shipping--out-of-stock">' + text + '</span>';
}

function bkMediaSetDeliveryInStock(root) {
  var ship = root.querySelector('.ship_information');
  if (!ship) return;
  root.classList.remove('is-out-of-stock');
  root.setAttribute('data-delivery-estimates', '');
  root.setAttribute('data-in-stock', 'true');
  ship.innerHTML = bkMediaBuildInStockDeliveryHtml(root);
  bkMediaRunDeliveryEstimateForRoot(root);
}

function bkMediaUpdateDeliveryStockRoots(roots, available) {
  roots.forEach(function (root) {
    if (!root.hasAttribute('data-variant-aware')) return;
    if (available) {
      bkMediaSetDeliveryInStock(root);
    } else {
      bkMediaSetDeliveryOutOfStock(root);
    }
  });
}

function bkMediaUpdateDeliveryStockFromVariant(form, variant) {
  if (!variant) return;
  var scope = form ? form.closest('.product-info__buy-trust') || form.closest('.product-info') : null;
  var roots = scope
    ? scope.querySelectorAll('.delivery-dates-text[data-variant-aware]')
    : document.querySelectorAll('.delivery-dates-text[data-variant-aware]');
  bkMediaUpdateDeliveryStockRoots(Array.prototype.slice.call(roots), !!variant.available);
}

function bkMediaFormatDeliveryDate(date) {
  return bkMediaDeliveryDayNames[date.getDay()] + ' ' + date.getDate() + '.' + bkMediaDeliveryMonths[date.getMonth()];
}

function bkMediaRunDeliveryEstimateForRoot(root) {
  var idSuffix = root.getAttribute('data-id');
  var shippingDay = parseInt(root.getAttribute('data-ship'), 10) || 1;
  var fallbackText = root.getAttribute('data-fallback') || '';
  if (!idSuffix || root.classList.contains('is-out-of-stock') || root.getAttribute('data-in-stock') === 'false') return;

  var today = new Date();
  var year = today.getFullYear();

  bkMediaFetchPublicHolidays(year)
    .then(function (publicHolidays) {
      var isWeekend = today.getDay() === 0 || today.getDay() === 6;
      var isHoliday = bkMediaIsPublicHoliday(today, publicHolidays);
      var pastCutoff = today.getHours() >= bkMediaDeliveryCutoffHour;
      var shipDate;

      if (isWeekend || isHoliday || pastCutoff) {
        shipDate = bkMediaNextShippingDay(today, publicHolidays);
      } else {
        shipDate = new Date(today);
      }

      var fromDate = new Date(shipDate);
      fromDate.setDate(fromDate.getDate() + shippingDay);
      bkMediaSkipNonDeliveryDays(fromDate, publicHolidays);

      var toDate = new Date(fromDate);
      toDate.setDate(toDate.getDate() + 1);
      bkMediaSkipNonDeliveryDays(toDate, publicHolidays);

      var formattedStart = bkMediaFormatDeliveryDate(fromDate);
      var formattedEnd = bkMediaFormatDeliveryDate(toDate);

      document.querySelectorAll('.fromDate' + idSuffix).forEach(function (el) {
        el.textContent = formattedStart;
      });
      document.querySelectorAll('.toDate' + idSuffix).forEach(function (el) {
        el.textContent = formattedEnd;
      });
    })
    .catch(function () {
      bkMediaApplyDeliveryFallback(root, fallbackText);
    });
}

function initEstimatedDeliveryDates() {
  document.querySelectorAll('.delivery-dates-text[data-delivery-estimates]').forEach(function (root) {
    bkMediaRunDeliveryEstimateForRoot(root);
  });
}

function initDeliveryStockVariantSync() {
  document.addEventListener('variant:change', function (event) {
    if (!event.detail || !event.detail.variant) return;
    var form = event.target;
    if (!form || !form.matches || !form.matches('form[is="product-form"]')) return;
    bkMediaUpdateDeliveryStockFromVariant(form, event.detail.variant);
  });

  document.addEventListener('product:rerender', function () {
    setTimeout(scheduleEstimatedDeliveryDates, 100);
  });
}

function scheduleEstimatedDeliveryDates() {
  requestAnimationFrame(function () {
    initEstimatedDeliveryDates();
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', scheduleEstimatedDeliveryDates, { once: true });
  document.addEventListener('DOMContentLoaded', initDeliveryStockVariantSync, { once: true });
} else {
  scheduleEstimatedDeliveryDates();
  initDeliveryStockVariantSync();
}

document.addEventListener('shopify:section:load', function () {
  setTimeout(scheduleEstimatedDeliveryDates, 50);
});

document.addEventListener('cart:change', function () {
  setTimeout(scheduleEstimatedDeliveryDates, 150);
});

document.addEventListener('cart:refresh', function () {
  setTimeout(scheduleEstimatedDeliveryDates, 150);
});

/* ========================================
   BUNDLE BUILDER
   ======================================== */

function bkMediaBundleFormatWithDelimiters(cents, precision, thousands, decimal) {
  if (typeof cents !== 'number' || isNaN(cents)) return '';
  var negative = cents < 0;
  cents = Math.abs(Math.round(cents));
  var numStr = (cents / 100).toFixed(precision);
  var parts = numStr.split('.');
  var intPart = parts[0];
  var decPart = precision > 0 && parts[1] ? parts[1] : '';
  var withThousands = intPart.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
  var body = withThousands + (precision > 0 && decPart ? decimal + decPart : '');
  return negative ? '-' + body : body;
}

function bkMediaBundleApplyMoneyFormatTemplate(cents, template) {
  if (template == null || template === '') return '';
  return String(template).replace(/\{\{\s*(\w+)\s*\}\}/g, function (full, key) {
    switch (key) {
      case 'amount':
        return bkMediaBundleFormatWithDelimiters(cents, 2, ',', '.');
      case 'amount_no_decimals':
        return bkMediaBundleFormatWithDelimiters(cents, 0, ',', '.');
      case 'amount_with_comma_separator':
        return bkMediaBundleFormatWithDelimiters(cents, 2, '.', ',');
      case 'amount_no_decimals_with_comma_separator':
        return bkMediaBundleFormatWithDelimiters(cents, 0, '.', ',');
      default:
        return full;
    }
  });
}

function bkMediaBundleFormatMoney(cents) {
  if (typeof cents !== 'number' || isNaN(cents)) return '';
  var s = window.themeVariables && window.themeVariables.settings;
  var moneyFormat = (s && s.moneyFormat) || '{{amount}}';
  var moneyWithCurrencyFormat = (s && s.moneyWithCurrencyFormat) || moneyFormat;
  var useCurrency = !!(s && s.currencyCodeEnabled);
  var activeFormat = useCurrency ? moneyWithCurrencyFormat : moneyFormat;
  return bkMediaBundleApplyMoneyFormatTemplate(cents, activeFormat);
}

function bkMediaBundleSortedTiers(cfg) {
  if (!cfg) return [];
  var pairs = [
    { q: Number(cfg.tier1Qty), t: Number(cfg.tier1Total) },
    { q: Number(cfg.tier2Qty), t: Number(cfg.tier2Total) },
    { q: Number(cfg.tier3Qty), t: Number(cfg.tier3Total) }
  ];
  pairs = pairs.filter(function(p) {
    return !isNaN(p.q) && p.q > 0 && !isNaN(p.t);
  });
  pairs.sort(function(a, b) {
    return a.q - b.q;
  });
  return pairs;
}

function bkMediaBundlePctFromCsvAtDesignIndex(designIndex1Based, cfg) {
  if (!cfg || designIndex1Based < 1) return 0;
  var arr = cfg.percentageSlotBadgePcts;
  if (!Array.isArray(arr)) return 0;
  var i = Math.floor(Number(designIndex1Based)) - 1;
  if (i < 0 || i >= arr.length) return 0;
  var raw = arr[i];
  if (raw == null || String(raw).trim() === '') return 0;
  var num = parseFloat(String(raw).replace(',', '.'));
  return isFinite(num) ? num : 0;
}

function bkMediaBundleFormatPctBadgeLabel(n) {
  if (!isFinite(n) || n <= 0) return '';
  var rounded = Math.round(n * 100) / 100;
  if (Math.abs(rounded - Math.round(rounded)) < 1e-6) return String(Math.round(rounded));
  return String(rounded).replace('.', ',');
}

function bkMediaBundleLegacyStepDiscountPercent(n, cfg) {
  return bkMediaBundlePctFromCsvAtDesignIndex(Math.floor(Number(n)), cfg);
}

function bkMediaBundlePremiumGiftRetailCents(cfg) {
  if (!cfg || cfg.gratisGiftRetailCents == null) return 0;
  var g = Math.round(Number(cfg.gratisGiftRetailCents));
  if (!isFinite(g)) return 0;
  return Math.max(0, g);
}

function bkMediaBundleManikureHardwarePoolCents(cfg) {
  if (!cfg) return 0;
  var cmp = cfg.mainCompareAtPrice;
  if (cmp != null && String(cmp).trim() !== '' && isFinite(Number(cmp)) && Number(cmp) > 0) {
    return Math.round(Number(cmp));
  }
  return Math.round(Number(cfg.mainProductPrice) || 0);
}

function bkMediaBundleFreeGiftMinDesignCount(cfg) {
  var mn = Number(cfg && cfg.bundleFreeGiftMinAddons);
  if (!isFinite(mn) || mn < 1) mn = 6;
  return Math.floor(mn);
}

function bkMediaBundleAverageManikurePayPerDesignCents(n, cfg, bundleRoot) {
  if (!cfg) return Math.round(Number(cfg.addonUnitPrice) || 0);
  var nz = Math.max(1, Math.floor(Number(n)));
  var pay = bkMediaBundleBundleTotalCents(nz, cfg, bundleRoot);
  var pool = pay - bkMediaBundleManikureHardwarePoolCents(cfg);
  var giftRetail = bkMediaBundlePremiumGiftRetailCents(cfg);
  var giftFloor = bkMediaBundleFreeGiftMinDesignCount(cfg);
  if (nz >= giftFloor && giftRetail > 0) pool -= giftRetail;
  if (pool < 0) pool = 0;
  return Math.round(pool / nz);
}

function bkMediaBundleGiftCompareExtraCentsForQty(n, cfg) {
  var g = bkMediaBundlePremiumGiftRetailCents(cfg);
  if (g <= 0 || !cfg || cfg.slotBadgeLayout !== 'percentage' || cfg.gratisStarterLadder === true) return 0;
  var zi = Math.max(0, Math.floor(Number(n)));
  if (zi < 1) return 0;
  var refillGiftMin = cfg.premiumGiftRetailMinAddons;
  if (refillGiftMin != null && refillGiftMin !== '' && isFinite(Number(refillGiftMin))) {
    var rgm = Math.max(1, Math.floor(Number(refillGiftMin)));
    var hasPremTier =
      cfg.tier1IncludePremiumCompare === true ||
      cfg.tier2IncludePremiumCompare === true ||
      cfg.tier3IncludePremiumCompare === true;
    if (hasPremTier) {
      if (zi >= rgm) return g;
      return 0;
    }
  }
  var q1 = Number(cfg.tier1Qty);
  var q2 = Number(cfg.tier2Qty);
  var q3 = Number(cfg.tier3Qty);
  if (cfg.tier3IncludePremiumCompare === true && !isNaN(q3) && q3 > 0 && zi >= q3) return g;
  if (
    cfg.tier2IncludePremiumCompare === true &&
    !isNaN(q2) &&
    q2 > 0 &&
    (!isNaN(q1) ? q2 > q1 : true)
  ) {
    var hi2 = !isNaN(q3) && q3 > q2 ? q3 : Number.POSITIVE_INFINITY;
    if (zi >= q2 && zi < hi2) return g;
  }
  if (cfg.tier1IncludePremiumCompare === true && !isNaN(q1) && q1 > 0) {
    var hi1 =
      !isNaN(q2) && q2 > q1 ? q2 : !isNaN(q3) && q3 > q1 ? q3 : Number.POSITIVE_INFINITY;
    if (zi >= q1 && zi < hi1) return g;
  }
  return 0;
}

function bkMediaBundleGratisLadderPayCents(z, cfg) {
  var tiers = cfg.gratisLadderPayTiers;
  if (!Array.isArray(tiers) || tiers.length < 1) {
    tiers = [3900, 5100, 5900, 5900, 6700, 7400];
  }
  var zi = Math.floor(Number(z));
  if (!isFinite(zi) || zi < 1) return Math.round(Number(cfg && cfg.mainProductPrice) || 0);
  if (zi <= tiers.length) return Math.round(Number(tiers[zi - 1]));
  var marginal =
    cfg.gratisLadderMarginalCents != null && isFinite(Number(cfg.gratisLadderMarginalCents))
      ? Math.round(Number(cfg.gratisLadderMarginalCents))
      : 800;
  var base = Math.round(Number(tiers[tiers.length - 1]));
  return base + (zi - tiers.length) * marginal;
}

function bkMediaBundleGratisLadderRetailCents(z, cfg) {
  var main = Math.round(Number(cfg.mainProductPrice) || 0);
  var u = Math.round(Number(cfg.addonUnitPrice) || 0);
  var gift = cfg.gratisGiftRetailCents == null ? 800 : Math.round(Number(cfg.gratisGiftRetailCents));
  if (!isFinite(gift)) gift = 800;
  var zi = Math.max(0, Math.floor(Number(z)));
  var line = main + zi * u;
  var mn = bkMediaBundleFreeGiftMinDesignCount(cfg);
  if (zi >= mn) line += gift;
  return line;
}

function bkMediaBundleNativeDiscountPercentForTotalQty(totalQty, cfg, scaleOpt) {
  var scale = Array.isArray(scaleOpt) ? scaleOpt : cfg && cfg.nativeBundlesDiscountScale;
  if (!cfg || !Array.isArray(scale)) return null;
  var qty = Math.max(1, Math.floor(Number(totalQty)));
  if (!isFinite(qty)) return null;
  var pairs = [];
  for (var i = 0; i < scale.length; i++) {
    var pair = scale[i];
    if (!Array.isArray(pair) || pair.length < 2) continue;
    var q = Math.floor(Number(pair[0]));
    var pct = Number(pair[1]);
    if (!isFinite(q) || q < 1 || !isFinite(pct)) continue;
    pairs.push({ q: q, pct: Math.min(100, Math.max(0, pct)) });
  }
  if (!pairs.length) return null;
  pairs.sort(function(a, b) {
    return a.q - b.q;
  });
  var applied = 0;
  for (var j = pairs.length - 1; j >= 0; j--) {
    if (qty >= pairs[j].q) {
      applied = pairs[j].pct;
      break;
    }
  }
  return applied;
}

function bkMediaBundlePremiumGiftBundledDiscountActive(root, cfg, addonQty) {
  if (!root || !cfg || !cfg.premiumGiftCountsForDiscountQty) return false;
  if (cfg.bundleFreeGiftVariantId == null || cfg.bundleFreeGiftVariantId === '')
    return false;
  var mn = Number(cfg.bundleFreeGiftMinAddons);
  if (isNaN(mn) || mn < 1) mn = 1;
  var nn = Math.max(0, Math.floor(Number(addonQty)));
  if (!isFinite(nn) || nn < mn) return false;
  var card = root.querySelector('.bk-media-bundle-builder__variant-card.is-selected');
  var step = card ? String(card.getAttribute('data-bundle-tier-step') || '') : '';
  if (step === '1') return cfg.tier1IncludePremiumCompare === true;
  if (step === '2') return cfg.tier2IncludePremiumCompare === true;
  if (step === '3') return cfg.tier3IncludePremiumCompare === true;
  return false;
}

function bkMediaBundleSelectedTierIncludesPremiumGift(cfg, root) {
  if (!cfg) return false;
  if (cfg.gratisStarterLadder === true && cfg.slotBadgeLayout === 'gratis') return true;
  var card = root ? root.querySelector('.bk-media-bundle-builder__variant-card.is-selected') : null;
  var step = card ? String(card.getAttribute('data-bundle-tier-step') || '') : '';
  if (step === '1') return cfg.tier1IncludePremiumCompare === true;
  if (step === '2') return cfg.tier2IncludePremiumCompare === true;
  if (step === '3') return cfg.tier3IncludePremiumCompare === true;
  return false;
}

function bkMediaBundlePremiumGiftUnlocked(addonCount, cfg, root) {
  if (!cfg || cfg.bundleFreeGiftVariantId == null || cfg.bundleFreeGiftVariantId === '') return false;
  var n = Math.max(0, Math.floor(Number(addonCount)));
  if (!isFinite(n)) return false;
  var mn = Number(cfg.bundleFreeGiftMinAddons);
  if (isNaN(mn) || mn < 1) mn = 6;
  if (n < mn) return false;
  if (!bkMediaBundleSelectedTierIncludesPremiumGift(cfg, root)) return false;
  if (cfg.premiumGiftRetailMinAddons != null && isFinite(Number(cfg.premiumGiftRetailMinAddons))) {
    if (n < Number(cfg.premiumGiftRetailMinAddons)) return false;
  }
  return true;
}

function bkMediaBundleNativeDiscountQtyFromAddons(nn, cfg) {
  return Math.max(1, Math.floor(Number(nn))) + 1;
}

function bkMediaBundleHasNativeBundlesDiscount(cfg) {
  if (!cfg) return false;
  return (
    (Array.isArray(cfg.nativeBundlesDiscountScale) &&
      cfg.nativeBundlesDiscountScale.length > 0) ||
    (Array.isArray(cfg.nativeBundlesDiscountScalePremiumInBundle) &&
      cfg.nativeBundlesDiscountScalePremiumInBundle.length > 0)
  );
}

function bkMediaBundleNativeBundlesScaleForContext(cfg, bundleRoot, addonQty) {
  var nn = Math.max(0, Math.floor(Number(addonQty)));
  var active =
    bundleRoot &&
    cfg &&
    cfg.premiumGiftCountsForDiscountQty &&
    bkMediaBundlePremiumGiftBundledDiscountActive(bundleRoot, cfg, nn);
  if (active) {
    if (
      Array.isArray(cfg.nativeBundlesDiscountScalePremiumInBundle) &&
      cfg.nativeBundlesDiscountScalePremiumInBundle.length > 0
    ) {
      return cfg.nativeBundlesDiscountScalePremiumInBundle;
    }
    return cfg && cfg.nativeBundlesDiscountScale;
  }
  return cfg && cfg.nativeBundlesDiscountScale;
}

function bkMediaBundlePremiumBundleUsesNativeDiscount(cfg, bundleRoot, addonQty) {
  var scale = bkMediaBundleNativeBundlesScaleForContext(cfg, bundleRoot, addonQty);
  return Array.isArray(scale) && scale.length > 0;
}

function bkMediaBundleBundleMainForDiscountCents(cfg) {
  if (!cfg) return 0;
  if (cfg.nativeDiscountMainCents != null && String(cfg.nativeDiscountMainCents).trim() !== '') {
    var nm = Math.round(Number(cfg.nativeDiscountMainCents));
    if (isFinite(nm)) return nm;
  }
  return Math.round(Number(cfg.mainProductPrice) || 0);
}

function bkMediaBundleBundleFullSubtotalBeforeDiscountCents(n, cfg, bundleRoot, refillPayMode) {
  void bundleRoot;
  void refillPayMode;
  var main = bkMediaBundleBundleMainForDiscountCents(cfg);
  var u = Math.round(Number(cfg.addonUnitPrice) || 0);
  var k = Math.max(0, Math.floor(Number(n)));
  return main + Math.round(k * u);
}

function bkMediaBundleBundleTotalCents(n, cfg, bundleRoot) {
  if (!cfg) return 0;
  var main = Math.round(Number(cfg.mainProductPrice) || 0);
  var u = Math.round(Number(cfg.addonUnitPrice) || 0);
  var nn = Math.max(0, Math.floor(Number(n)));
  var refillPayMode =
    cfg.bundlePriceMode === 'refill' || cfg.bundle_price_mode === 'refill';

  if (nn === 0) return main;

  if (
    !refillPayMode &&
    cfg.gratisStarterLadder === true &&
    cfg.slotBadgeLayout === 'gratis'
  ) {
    return bkMediaBundleGratisLadderPayCents(nn, cfg);
  }

  var giftBundledPricing =
    bundleRoot &&
    !!cfg.premiumGiftCountsForDiscountQty &&
    bkMediaBundlePremiumGiftBundledDiscountActive(bundleRoot, cfg, nn) &&
    bkMediaBundlePremiumBundleUsesNativeDiscount(cfg, bundleRoot, nn);
  if (giftBundledPricing) {
    var fullGb = bkMediaBundleBundleFullSubtotalBeforeDiscountCents(
      nn,
      cfg,
      bundleRoot,
      refillPayMode
    );
    var useGiftInDiscountBase =
      cfg.nativePremiumDiscountBaseIncludesGift === true ||
      (cfg.refillNativeDiscountChargeableIncludesGift === true &&
        isFinite(Number(cfg && cfg.premiumGiftRetailMinAddons)) &&
        nn >= Number(cfg.premiumGiftRetailMinAddons) &&
        bkMediaBundlePremiumGiftRetailCents(cfg) > 0);
    var giftRCents = bkMediaBundlePremiumGiftRetailCents(cfg);
    var chargeableGb =
      useGiftInDiscountBase && giftRCents > 0 ? fullGb + giftRCents : fullGb;
    var nativePctGb = bkMediaBundleNativeDiscountPercentForTotalQty(
      bkMediaBundleNativeDiscountQtyFromAddons(nn, cfg),
      cfg,
      bkMediaBundleNativeBundlesScaleForContext(cfg, bundleRoot, nn)
    );
    if (nativePctGb != null && nativePctGb > 0) {
      return Math.round((chargeableGb * (100 - nativePctGb)) / 100);
    }
  }
  var q1 = Number(cfg.tier1Qty);
  var q2 = Number(cfg.tier2Qty);
  var q3 = Number(cfg.tier3Qty);
  var t1 = Number(cfg.tier1Total);
  var t2 = Number(cfg.tier2Total);
  var t3 = Number(cfg.tier3Total);

  function full(k) {
    return bkMediaBundleBundleFullSubtotalBeforeDiscountCents(
      k,
      cfg,
      bundleRoot,
      refillPayMode
    );
  }

  function lerp(a, b, t) {
    if (t <= 0) return Math.round(a);
    if (t >= 1) return Math.round(b);
    return Math.round(a + (b - a) * t);
  }

  var nativePct = bkMediaBundleNativeDiscountPercentForTotalQty(
    bkMediaBundleNativeDiscountQtyFromAddons(nn, cfg),
    cfg,
    bkMediaBundleNativeBundlesScaleForContext(cfg, bundleRoot, nn)
  );
  if (nativePct != null && nativePct > 0) {
    return Math.round((full(nn) * (100 - nativePct)) / 100);
  }

  if (isNaN(q1) || q1 <= 0) {
    return Math.round(full(nn));
  }

  if (nn < q1) {
    return lerp(main, t1, nn / q1);
  }
  if (nn === q1) {
    return Math.round(t1);
  }

  if (!isNaN(q2) && q2 > q1) {
    if (nn < q2) {
      return lerp(t1, t2, (nn - q1) / (q2 - q1));
    }
    if (nn === q2) {
      return Math.round(t2);
    }
  }

  if (!isNaN(q3) && q3 > q2) {
    if (nn < q3) {
      return lerp(t2, t3, (nn - q2) / (q3 - q2));
    }
    if (nn === q3) {
      return Math.round(t3);
    }
  }

  if (!isNaN(q3) && q3 > 0 && nn > q3) {
    var fullQ3 = full(q3);
    var t3r = Math.round(t3);
    if (fullQ3 <= 0) return full(nn);
    var d3 = (100 * (fullQ3 - t3r)) / fullQ3;
    d3 = Math.min(100, Math.max(0, d3));
    return Math.round((full(nn) * (100 - d3)) / 100);
  }

  return Math.round(full(nn));
}

function bkMediaBundleBundleListDiscountPercent(n, cfg, bundleRoot) {
  var full = bkMediaBundleBundleListCompareCents(n, cfg, bundleRoot);
  var pay = bkMediaBundleBundleTotalCents(n, cfg, bundleRoot);
  if (full <= 0) return 0;
  return Math.min(100, Math.max(0, Math.round(((full - pay) / full) * 100)));
}

function bkMediaBundleDiscountForQty(n, cfg, bundleRoot) {
  return bkMediaBundleBundleListDiscountPercent(n, cfg, bundleRoot);
}

function bkMediaBundleMarginalAddonPayCents(n, cfg, bundleRoot) {
  if (!cfg || n < 1) return Math.round(Number(cfg.addonUnitPrice) || 0);
  var payN = bkMediaBundleBundleTotalCents(n, cfg, bundleRoot);
  var payPrev = bkMediaBundleBundleTotalCents(n - 1, cfg, bundleRoot);
  return payN - payPrev;
}

function bkMediaBundleMarginalAddonSaveCents(n, cfg, bundleRoot) {
  var u = Math.round(Number(cfg.addonUnitPrice) || 0);
  if (u <= 0) return 0;
  return Math.max(0, u - bkMediaBundleMarginalAddonPayCents(n, cfg, bundleRoot));
}

function bkMediaBundleSlotAddonIndexIsExtraBeyondPresetBundles(p, cfg) {
  var pi = Math.floor(Number(p));
  if (!isFinite(pi) || pi < 1 || !cfg) return false;
  var q2 = Number(cfg.tier2Qty);
  var q3 = Number(cfg.tier3Qty);
  var hasQ2 = isFinite(q2) && q2 > 0;
  var hasQ3 = isFinite(q3) && q3 > 0;
  if (hasQ3 && pi > q3) return true;
  if (hasQ3 && hasQ2 && q3 > q2 && pi > q2 && pi < q3) return true;
  if (!hasQ3 && hasQ2 && pi > q2) return true;
  return false;
}

function bkMediaBundleSlotMarginalPayShowsDiscountedUnitPrice(p, cfg, bundleRoot) {
  var u = Math.round(Number(cfg.addonUnitPrice) || 0);
  if (u <= 0) return false;
  var mp = bkMediaBundleMarginalAddonPayCents(p, cfg, bundleRoot);
  return mp > 0 && mp < u;
}

function bkMediaBundleBundleListCompareCents(n, cfg, bundleRoot) {
  var refillCmp =
    cfg.bundlePriceMode === 'refill' ||
    cfg.bundle_price_mode === 'refill';
  var nn0 = Math.max(0, Math.floor(Number(n)));
  if (
    bundleRoot &&
    cfg.premiumGiftCountsForDiscountQty &&
    bkMediaBundlePremiumGiftBundledDiscountActive(bundleRoot, cfg, nn0)
  ) {
    var mainGb = bkMediaBundleBundleMainForDiscountCents(cfg);
    var uGb = Math.round(Number(cfg.addonUnitPrice) || 0);
    return mainGb + Math.round(nn0 * uGb) + bkMediaBundlePremiumGiftRetailCents(cfg);
  }
  if (
    !refillCmp &&
    cfg.gratisStarterLadder === true &&
    cfg.slotBadgeLayout === 'gratis'
  ) {
    return bkMediaBundleGratisLadderRetailCents(nn0, cfg);
  }
  var main = bkMediaBundleBundleMainForDiscountCents(cfg);
  var u = Math.round(Number(cfg.addonUnitPrice) || 0);
  var nn = Math.max(0, Math.floor(Number(n)));
  var base = main + Math.round(nn * u);
  return base + bkMediaBundleGiftCompareExtraCentsForQty(nn, cfg);
}

function bkMediaBundleEffectivePerUnitCents(n, cfg, bundleRoot) {
  if (n <= 0 || !cfg) return Math.round(Number(cfg.addonUnitPrice) || 0);
  return bkMediaBundleAverageManikurePayPerDesignCents(n, cfg, bundleRoot);
}

function bkMediaBundleDiscountPercentOffUnit(n, cfg, bundleRoot) {
  return bkMediaBundleBundleListDiscountPercent(n, cfg, bundleRoot);
}

function bkMediaBundleTier2PresetTierMaxDesignPct50(cfg, tierQty, designNum, nz) {
  if (!cfg || !cfg.gratisStarterLadder) return false;
  var tq = Math.floor(Number(tierQty) || 0);
  var dn = Math.floor(Number(designNum));
  var nn = Math.floor(Number(nz));
  var t2 = Math.floor(Number(cfg.tier2Qty));
  var t3 = Math.floor(Number(cfg.tier3Qty));
  if (!isFinite(tq) || !isFinite(dn) || !isFinite(nn) || !isFinite(t2) || !isFinite(t3)) return false;
  if (t2 < 1 || t3 < 1) return false;
  return tq === t2 && dn === t3 && nn >= dn;
}

function bkMediaBundleGratisCountForTierQty(tierQuantity, cfg) {
  if (!cfg || tierQuantity == null || tierQuantity === '') return 0;
  var sc = Number(tierQuantity);
  if (isNaN(sc)) return 0;
  var t1 = Number(cfg.tier1Qty);
  var t2 = Number(cfg.tier2Qty);
  var t3 = Number(cfg.tier3Qty);
  var g1 = Math.max(0, Number(cfg.tier1GratisSlots) || 0);
  var g2 = Math.max(0, Number(cfg.tier2GratisSlots) || 0);
  var g3 = Math.max(0, Number(cfg.tier3GratisSlots) || 0);
  if (!isNaN(t1) && t1 > 0 && sc === t1) return g1;
  if (!isNaN(t2) && t2 > 0 && sc === t2) return g2;
  if (!isNaN(t3) && t3 > 0 && sc === t3) return g3;
  return 0;
}

function bkMediaBundleGratisLadderPresetMessagingBadge(designNum, tierQty, cfg, gratisHtml) {
  var dn = Math.floor(Number(designNum));
  var tqPreset = Math.floor(Number(tierQty) || 0);
  if (!isFinite(dn) || !isFinite(tqPreset) || dn < 1 || tqPreset < 1 || dn > tqPreset) return null;

  var t1 = Number(cfg.tier1Qty);
  var t2 = Number(cfg.tier2Qty);
  var t3 = Number(cfg.tier3Qty);
  var g1 = Math.max(0, Number(cfg.tier1GratisSlots) || 0);
  var g2 = Math.max(0, Number(cfg.tier2GratisSlots) || 0);
  var g3 = Math.max(0, Number(cfg.tier3GratisSlots) || 0);

  var gratis = 0;
  if (!isNaN(t1) && tqPreset === t1) {
    gratis = g1;
  } else if (!isNaN(t2) && tqPreset === t2) {
    gratis = g2;
  } else if (!isNaN(t3) && tqPreset === t3) {
    gratis = g3;
  } else {
    return null;
  }

  var paid = Math.max(0, tqPreset - gratis);
  if (gratis > 0 && dn > paid) return gratisHtml;
  if (dn <= paid) return '';
  return '';
}

function bkMediaBundleGratisLadderBadgeForDesign(designNum, n, tierQty, cfg, gratisHtml, discountHtml) {
  var dn = Math.floor(Number(designNum));
  var nz = Math.floor(Number(n));
  if (!isFinite(dn) || !isFinite(nz) || dn < 1) return '';
  if (bkMediaBundleTier2PresetTierMaxDesignPct50(cfg, tierQty, dn, nz)) {
    return discountHtml(50);
  }
  if (dn === 1) return '';
  if (dn > nz) return '';
  if (dn === 2) {
    return nz >= 2 ? discountHtml(25) : '';
  }
  if (dn === 3) {
    if (nz >= 6) return discountHtml(50);
    if (nz >= 4 && nz <= 5) return gratisHtml;
    if (nz >= 3) return discountHtml(50);
    return '';
  }
  if (dn === 4) {
    return nz >= 4 ? gratisHtml : '';
  }
  if (dn === 5) {
    if (nz >= 6) return gratisHtml;
    if (nz === 5) return discountHtml(50);
    return '';
  }
  if (dn === 6) {
    return nz >= 6 ? gratisHtml : '';
  }
  if (dn >= 7) {
    return nz >= dn ? discountHtml(50) : '';
  }
  return '';
}

function bkMediaBundleGratisLadderSlotBadgeHtml(
  slotIndex,
  priceQty,
  tierQty,
  cfg,
  isEmptySlot,
  isOptionalDesignSlot,
  filledCount
) {
  var idx = Number(slotIndex);
  var pq = typeof priceQty === 'number' ? priceQty : Number(priceQty) || 0;
  var fc = typeof filledCount === 'number' ? filledCount : 0;
  var label =
    cfg.gratisBadgeText != null && String(cfg.gratisBadgeText).trim() !== ''
      ? String(cfg.gratisBadgeText).trim()
      : 'GRATIS';
  var gratisHtml =
    '<on-sale-badge class="badge badge--on-sale bk-media-bundle-builder__slot-gratis-badge">' +
    bkMediaBundleEscapeHtml(label) +
    '</on-sale-badge>';
  function discountHtml(pct) {
    return (
      '<on-sale-badge class="badge badge--on-sale bk-media-bundle-builder__slot-discount-badge">-' +
      pct +
      '%</on-sale-badge>'
    );
  }
  var tqSel = Math.floor(Number(tierQty) || 0);
  if (isOptionalDesignSlot === true) {
    var nextDn = Math.max(1, fc + 1);
    if (nextDn <= tqSel) {
      var presetOpt = bkMediaBundleGratisLadderPresetMessagingBadge(nextDn, tierQty, cfg, gratisHtml);
      if (presetOpt !== null) return presetOpt;
    }
    return bkMediaBundleGratisLadderBadgeForDesign(nextDn, nextDn, tierQty, cfg, gratisHtml, discountHtml);
  }
  var empty = isEmptySlot === true;
  var designNum = empty ? idx + 1 : pq;
  var nzPreview = empty ? Math.max(1, idx + 1) : Math.max(1, pq);
  if (designNum <= tqSel) {
    var presetSlot = bkMediaBundleGratisLadderPresetMessagingBadge(designNum, tierQty, cfg, gratisHtml);
    if (presetSlot !== null) return presetSlot;
  }
  return bkMediaBundleGratisLadderBadgeForDesign(designNum, nzPreview, tierQty, cfg, gratisHtml, discountHtml);
}

function bkMediaBundleGratisLadderBadgeForDesignDiscountPct(designNum, n, tierQty, cfg) {
  var dn = Math.floor(Number(designNum));
  var nz = Math.floor(Number(n));
  if (!isFinite(dn) || !isFinite(nz) || dn < 1) return null;
  if (bkMediaBundleTier2PresetTierMaxDesignPct50(cfg, tierQty, dn, nz)) {
    return 50;
  }
  if (dn === 1) return null;
  if (dn > nz) return null;
  if (dn === 2) {
    return nz >= 2 ? 25 : null;
  }
  if (dn === 3) {
    if (nz >= 6) return 50;
    if (nz >= 4 && nz <= 5) return -1;
    if (nz >= 3) return 50;
    return null;
  }
  if (dn === 4) {
    return nz >= 4 ? -1 : null;
  }
  if (dn === 5) {
    if (nz >= 6) return -1;
    if (nz === 5) return 50;
    return null;
  }
  if (dn === 6) {
    return nz >= 6 ? -1 : null;
  }
  if (dn >= 7) {
    return nz >= dn ? 50 : null;
  }
  return null;
}

function bkMediaBundleGratisLadderPresetSlotListPct(designNum, tierQty, cfg) {
  var dn = Math.floor(Number(designNum));
  var tqPreset = Math.floor(Number(tierQty) || 0);
  if (!isFinite(dn) || !isFinite(tqPreset) || dn < 1 || tqPreset < 1) return undefined;
  if (dn > tqPreset) return undefined;

  var t1 = Number(cfg.tier1Qty);
  var t2 = Number(cfg.tier2Qty);
  var t3 = Number(cfg.tier3Qty);
  var g1 = Math.max(0, Number(cfg.tier1GratisSlots) || 0);
  var g2 = Math.max(0, Number(cfg.tier2GratisSlots) || 0);
  var g3 = Math.max(0, Number(cfg.tier3GratisSlots) || 0);

  var gratis = 0;
  if (!isNaN(t1) && tqPreset === t1) {
    gratis = g1;
  } else if (!isNaN(t2) && tqPreset === t2) {
    gratis = g2;
  } else if (!isNaN(t3) && tqPreset === t3) {
    gratis = g3;
  } else {
    return undefined;
  }

  var paid = Math.max(0, tqPreset - gratis);
  if (gratis > 0 && dn > paid) return -1;
  if (dn <= paid) return null;
  return null;
}

function bkMediaBundleGratisLadderSlotListDiscountPct(
  slotIndex,
  priceQty,
  tierQty,
  cfg,
  isEmptySlot,
  isOptionalDesignSlot,
  filledCount
) {
  var idx = Number(slotIndex);
  var pq = typeof priceQty === 'number' ? priceQty : Number(priceQty) || 0;
  var fc = typeof filledCount === 'number' ? filledCount : 0;
  var tqSel = Math.floor(Number(tierQty) || 0);
  if (isOptionalDesignSlot === true) {
    var nextDn = Math.max(1, fc + 1);
    if (nextDn <= tqSel) {
      var presetOpt = bkMediaBundleGratisLadderPresetSlotListPct(nextDn, tierQty, cfg);
      if (presetOpt !== undefined) return presetOpt;
    }
    return bkMediaBundleGratisLadderBadgeForDesignDiscountPct(nextDn, nextDn, tierQty, cfg);
  }
  var empty = isEmptySlot === true;
  var designNum = empty ? idx + 1 : pq;
  var nzPreview = empty ? Math.max(1, idx + 1) : Math.max(1, pq);
  if (designNum <= tqSel) {
    var presetSlot = bkMediaBundleGratisLadderPresetSlotListPct(designNum, tierQty, cfg);
    if (presetSlot !== undefined) return presetSlot;
  }
  return bkMediaBundleGratisLadderBadgeForDesignDiscountPct(designNum, nzPreview, tierQty, cfg);
}

function bkMediaBundleNativeSlotBadgeOverrideHtml(previewQty, cfg, gratisHtml) {
  if (!cfg || !cfg.nativeBundlesSlotBadgeByQty) return null;
  var q = Math.floor(Number(previewQty));
  if (!isFinite(q) || q < 1) return null;
  var map = cfg.nativeBundlesSlotBadgeByQty;
  var raw = map[String(q)];
  if (raw == null) raw = map[q];
  if (raw == null) return null;
  var text = String(raw).trim();
  if (!text) return null;
  var compact = text.replace(/\s+/g, '');
  if (compact.toLowerCase() === 'gratis') return gratisHtml;
  var num = parseFloat(compact.replace(/%/g, '').replace(',', '.'));
  if (!isNaN(num) && isFinite(num) && num > 0) {
    var pctLabel = bkMediaBundleFormatPctBadgeLabel(num);
    if (pctLabel !== '') {
      return (
        '<on-sale-badge class="badge badge--on-sale bk-media-bundle-builder__slot-discount-badge">-' +
        pctLabel +
        '%</on-sale-badge>'
      );
    }
  }
  return null;
}

function bkMediaBundleNativeSlotBadgeOverridePct(previewQty, cfg) {
  if (!cfg || !cfg.nativeBundlesSlotBadgeByQty) return null;
  var q = Math.floor(Number(previewQty));
  if (!isFinite(q) || q < 1) return null;
  var map = cfg.nativeBundlesSlotBadgeByQty;
  var raw = map[String(q)];
  if (raw == null) raw = map[q];
  if (raw == null) return null;
  var text = String(raw).trim();
  if (!text) return null;
  var compact = text.replace(/\s+/g, '');
  if (compact.toLowerCase() === 'gratis') return -1;
  var num = parseFloat(compact.replace(/%/g, '').replace(',', '.'));
  if (!isNaN(num) && isFinite(num) && num > 0) {
    return num;
  }
  return null;
}

function bkMediaBundleUnitPriceAfterBadgeDiscountPct(fullUnitCents, pct) {
  var u = Math.round(Number(fullUnitCents) || 0);
  var p = Number(pct);
  if (u <= 0 || !isFinite(p) || p <= 0) return u;
  if (p >= 100) return 0;
  var pi = Math.floor(p);
  var discountAmt = Math.floor((u * pi) / 100);
  return Math.max(0, u - discountAmt);
}

function bkMediaBundleSlotListDiscountPct(
  slotIndex,
  totalSlots,
  priceQty,
  tierQty,
  cfg,
  isEmptySlot,
  filledCount,
  isOptionalDesignSlot
) {
  if (!cfg || totalSlots < 1) return null;
  var layout = cfg.slotBadgeLayout || 'percentage';
  var idx = Number(slotIndex);
  var n = Number(totalSlots);
  if (isNaN(idx) || isNaN(n) || idx < 0) return null;
  var pq = typeof priceQty === 'number' ? priceQty : Number(priceQty) || 0;
  var empty = isEmptySlot === true;
  var optionalD = isOptionalDesignSlot === true;
  var filled = typeof filledCount === 'number' ? filledCount : 0;
  if (layout === 'gratis' && cfg.gratisStarterLadder) {
    return bkMediaBundleGratisLadderSlotListDiscountPct(
      slotIndex,
      priceQty,
      tierQty,
      cfg,
      isEmptySlot,
      isOptionalDesignSlot,
      filledCount
    );
  }

  var tierGc = bkMediaBundleGratisCountForTierQty(tierQty, cfg);
  var previewQtyForOverride = optionalD ? Math.max(1, filled + 1) : empty ? idx + 1 : pq;
  var tqOverride = Math.floor(Number(tierQty) || 0);
  var nextPresetTier = bkMediaBundleNextPresetTierQty(tqOverride, cfg);
  var inBetweenPresetWindow =
    previewQtyForOverride > tqOverride &&
    (nextPresetTier == null || previewQtyForOverride <= nextPresetTier);
  if (inBetweenPresetWindow) {
    var overridePct = bkMediaBundleNativeSlotBadgeOverridePct(previewQtyForOverride, cfg);
    if (overridePct !== null) return overridePct;
  }

  var tq = Number(tierQty) || 0;
  var u = Math.round(Number(cfg.addonUnitPrice) || 0);

  var refillUniform =
    (cfg.bundlePriceMode === 'refill' || cfg.bundle_price_mode === 'refill') && layout === 'percentage';
  if (refillUniform) {
    var tqUniform = Math.floor(Number(tierQty) || 0);
    if (tqUniform >= 1) {
      var pctLabRf = bkMediaBundleRefillPresetBadgeLabel(tqUniform, cfg);
      if (pctLabRf !== '') {
        var nRf = parseFloat(String(pctLabRf).replace(',', '.'));
        if (!isNaN(nRf) && nRf > 0) return nRf;
      }
    }
  }
  if (refillUniform) {
    return null;
  }

  if (layout === 'gratis' && tierGc > 0) {
    if (optionalD) {
      var pqOpt = Math.max(1, filled + 1);
      var msaveOpt = bkMediaBundleMarginalAddonSaveCents(pqOpt, cfg);
      if (u > 0 && msaveOpt > 0) {
        var mpctOpt = Math.round((100 * msaveOpt) / u);
        if (mpctOpt > 0) return mpctOpt;
      }
      return null;
    }
    if (tq > 0 && idx >= tq) {
      var addonNumOf = empty ? idx + 1 : pq;
      var msaveOf = bkMediaBundleMarginalAddonSaveCents(addonNumOf, cfg);
      if (u > 0 && msaveOf > 0) {
        var mpctOf = Math.round((100 * msaveOf) / u);
        if (mpctOf > 0) return mpctOf;
      }
      return null;
    }
    if (tq > 0 && idx < tq) {
      var gratisCount2 = Math.min(tierGc, tq);
      var paidCount2 = Math.max(0, tq - gratisCount2);
      if (idx >= paidCount2) {
        return -1;
      }
      return null;
    }
  }

  var previewQty = empty ? idx + 1 : pq;
  var layoutPct = cfg.slotBadgeLayout || 'percentage';
  if (
    layoutPct === 'percentage' &&
    Array.isArray(cfg.percentageSlotBadgePcts) &&
    previewQty >= 1
  ) {
    var rawSOv2 = cfg.percentageSlotBadgePcts[previewQty - 1];
    if (rawSOv2 != null && String(rawSOv2).trim() !== '') {
      var sSlot2 = String(rawSOv2).trim();
      var numSlot2 = parseFloat(sSlot2.replace(',', '.'));
      if (!isNaN(numSlot2) && numSlot2 > 0) return numSlot2;
    }
  }
  var pctOff2 = bkMediaBundleLegacyStepDiscountPercent(previewQty, cfg);
  if (pctOff2 > 0) {
    return pctOff2;
  }
  return null;
}

function bkMediaBundleNextPresetTierQty(currentTierQty, cfg) {
  if (!cfg) return null;
  var current = Math.floor(Number(currentTierQty));
  if (!isFinite(current) || current < 1) return null;
  var tiers = [Number(cfg.tier1Qty), Number(cfg.tier2Qty), Number(cfg.tier3Qty)]
    .filter(function(n) {
      return isFinite(n) && n >= 1;
    })
    .map(function(n) {
      return Math.floor(n);
    })
    .sort(function(a, b) {
      return a - b;
    });
  for (var i = 0; i < tiers.length; i++) {
    if (tiers[i] > current) return tiers[i];
  }
  return null;
}

function bkMediaBundleRefillPresetBadgeLabel(tierQty, cfg) {
  var tq = Math.floor(Number(tierQty));
  if (!isFinite(tq) || tq < 1 || !cfg) return '';
  if (Array.isArray(cfg.percentageSlotBadgePcts) && cfg.percentageSlotBadgePcts.length > 0) {
    var raw = cfg.percentageSlotBadgePcts[tq - 1];
    if (raw != null && String(raw).trim() !== '') {
      var s = String(raw).trim();
      var num = parseFloat(s.replace(',', '.'));
      if (!isNaN(num)) return String(Math.round(num));
      if (s.indexOf('%') >= 0) return s.replace(/%/g, '').replace(/\s+/g, '').trim();
      return s;
    }
  }
  var nativePct = bkMediaBundleNativeDiscountPercentForTotalQty(tq + 1, cfg);
  if (nativePct != null && isFinite(Number(nativePct)) && Number(nativePct) > 0) {
    return String(Math.round(Number(nativePct)));
  }
  return '';
}

function bkMediaBundleSlotBadgeHtml(slotIndex, totalSlots, priceQty, tierQty, cfg, isEmptySlot, filledCount, isOptionalDesignSlot) {
  if (!cfg || totalSlots < 1) return '';
  var layout = cfg.slotBadgeLayout || 'percentage';
  var idx = Number(slotIndex);
  var n = Number(totalSlots);
  if (isNaN(idx) || isNaN(n) || idx < 0) return '';
  var pq = typeof priceQty === 'number' ? priceQty : Number(priceQty) || 0;
  var empty = isEmptySlot === true;
  var optionalD = isOptionalDesignSlot === true;
  var filled = typeof filledCount === 'number' ? filledCount : 0;
  if (layout === 'gratis' && cfg.gratisStarterLadder) {
    return bkMediaBundleGratisLadderSlotBadgeHtml(
      slotIndex,
      priceQty,
      tierQty,
      cfg,
      isEmptySlot,
      isOptionalDesignSlot,
      filledCount
    );
  }
  var tierGc = bkMediaBundleGratisCountForTierQty(tierQty, cfg);
  var label =
    cfg.gratisBadgeText != null && String(cfg.gratisBadgeText).trim() !== ''
      ? String(cfg.gratisBadgeText).trim()
      : 'GRATIS';
  var gratisHtml =
    '<on-sale-badge class="badge badge--on-sale bk-media-bundle-builder__slot-gratis-badge">' +
    bkMediaBundleEscapeHtml(label) +
    '</on-sale-badge>';
  var previewQtyForOverride = optionalD ? Math.max(1, filled + 1) : empty ? idx + 1 : pq;
  var tqOverride = Math.floor(Number(tierQty) || 0);
  var nextPresetTier = bkMediaBundleNextPresetTierQty(tqOverride, cfg);
  var inBetweenPresetWindow =
    previewQtyForOverride > tqOverride &&
    (nextPresetTier == null || previewQtyForOverride <= nextPresetTier);
  if (inBetweenPresetWindow) {
    var overrideHtml = bkMediaBundleNativeSlotBadgeOverrideHtml(previewQtyForOverride, cfg, gratisHtml);
    if (overrideHtml !== null) return overrideHtml;
  }

  var tq = Number(tierQty) || 0;
  var u = Math.round(Number(cfg.addonUnitPrice) || 0);

  var refillUniform =
    (cfg.bundlePriceMode === 'refill' || cfg.bundle_price_mode === 'refill') && layout === 'percentage';
  if (refillUniform) {
    var tqUniform = Math.floor(Number(tierQty) || 0);
    if (tqUniform >= 1) {
      var pctLabRf = bkMediaBundleRefillPresetBadgeLabel(tqUniform, cfg);
      if (pctLabRf !== '') {
        return (
          '<on-sale-badge class="badge badge--on-sale bk-media-bundle-builder__slot-discount-badge">-' +
          pctLabRf +
          '%</on-sale-badge>'
        );
      }
    }
  }
  if (refillUniform) {
    return '';
  }

  if (layout === 'gratis' && tierGc > 0) {
    if (optionalD) {
      var pqOpt = Math.max(1, filled + 1);
      var msaveOpt = bkMediaBundleMarginalAddonSaveCents(pqOpt, cfg);
      if (u > 0 && msaveOpt > 0) {
        var mpctOpt = Math.round((100 * msaveOpt) / u);
        if (mpctOpt > 0) {
          return (
            '<on-sale-badge class="badge badge--on-sale bk-media-bundle-builder__slot-discount-badge">-' +
            mpctOpt +
            '%</on-sale-badge>'
          );
        }
      }
      return '';
    }
    if (tq > 0 && idx >= tq) {
      var addonNumOf = empty ? idx + 1 : pq;
      var msaveOf = bkMediaBundleMarginalAddonSaveCents(addonNumOf, cfg);
      if (u > 0 && msaveOf > 0) {
        var mpctOf = Math.round((100 * msaveOf) / u);
        if (mpctOf > 0) {
          return (
            '<on-sale-badge class="badge badge--on-sale bk-media-bundle-builder__slot-discount-badge">-' +
            mpctOf +
            '%</on-sale-badge>'
          );
        }
      }
      return '';
    }
    if (tq > 0 && idx < tq) {
      var gratisCount = Math.min(tierGc, tq);
      var paidCount = Math.max(0, tq - gratisCount);
      if (idx >= paidCount) {
        return gratisHtml;
      }
      return '';
    }
  }

  var previewQty = empty ? idx + 1 : pq;
  var layoutPct = cfg.slotBadgeLayout || 'percentage';
  if (
    layoutPct === 'percentage' &&
    Array.isArray(cfg.percentageSlotBadgePcts) &&
    previewQty >= 1
  ) {
    var rawSOv = cfg.percentageSlotBadgePcts[previewQty - 1];
    if (rawSOv != null && String(rawSOv).trim() !== '') {
      var sSlot = String(rawSOv).trim();
      var numSlot = parseFloat(sSlot.replace(',', '.'));
      var pctLabel = '';
      if (!isNaN(numSlot)) {
        pctLabel = bkMediaBundleFormatPctBadgeLabel(numSlot);
      } else if (sSlot.indexOf('%') >= 0) {
        pctLabel = sSlot.replace(/%/g, '').replace(/\s+/g, '').trim();
      } else {
        pctLabel = sSlot;
      }
      if (pctLabel !== '') {
        return (
          '<on-sale-badge class="badge badge--on-sale bk-media-bundle-builder__slot-discount-badge">-' +
          pctLabel +
          '%</on-sale-badge>'
        );
      }
    }
  }
  var pctOff = bkMediaBundleLegacyStepDiscountPercent(previewQty, cfg);
  if (pctOff > 0) {
    var pctOffLabel = bkMediaBundleFormatPctBadgeLabel(pctOff);
    return (
      '<on-sale-badge class="badge badge--on-sale bk-media-bundle-builder__slot-discount-badge">-' +
      pctOffLabel +
      '%</on-sale-badge>'
    );
  }
  return '';
}

function bkMediaBundleSlotShouldShowSlotPrice(
  slotIndex,
  totalSlots,
  priceQty,
  tierQty,
  cfg,
  filledCount,
  isOptionalDesignSlot,
  bundleRoot
) {
  if (!cfg || totalSlots < 1) return false;
  var layout = cfg.slotBadgeLayout || 'percentage';
  var idx = Number(slotIndex);
  var n = Number(totalSlots);
  if (isNaN(idx) || isNaN(n) || idx < 0) return false;
  var pq = typeof priceQty === 'number' ? priceQty : Number(priceQty) || 0;
  var optionalD = isOptionalDesignSlot === true;
  var filled = typeof filledCount === 'number' ? filledCount : 0;
  var tq = Number(tierQty) || 0;

  if (layout === 'gratis') {
    var addonIdx = optionalD ? Math.max(1, filled + 1) : pq;
    if (!bkMediaBundleSlotAddonIndexIsExtraBeyondPresetBundles(addonIdx, cfg)) {
      return false;
    }
    return bkMediaBundleSlotMarginalPayShowsDiscountedUnitPrice(addonIdx, cfg, bundleRoot);
  }

  var refillSlotPrice =
    cfg.bundlePriceMode === 'refill' || cfg.bundle_price_mode === 'refill';
  if (!refillSlotPrice && tq > 0 && idx < tq) {
    return false;
  }

  var layoutPct2 = cfg.slotBadgeLayout || 'percentage';
  if (layoutPct2 === 'percentage' && Array.isArray(cfg.percentageSlotBadgePcts)) {
    var rawOv2 = null;
    if (refillSlotPrice) {
      var tqPv = Math.floor(Number(tierQty) || 0);
      rawOv2 = tqPv >= 1 ? cfg.percentageSlotBadgePcts[tqPv - 1] : null;
    } else if (pq >= 1) {
      rawOv2 = cfg.percentageSlotBadgePcts[pq - 1];
    }
    if (rawOv2 != null && String(rawOv2).trim() !== '') {
      var nz = parseFloat(String(rawOv2).replace(',', '.'));
      if (!isNaN(nz) && nz > 0) return true;
      return true;
    }
  }

  return bkMediaBundleLegacyStepDiscountPercent(pq, cfg) > 0;
}

function bkMediaBundleEscapeHtml(s) {
  if (s == null) return '';
  return String(s)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

function bkMediaBundleRandomId() {
  return Math.random().toString(36).slice(2, 10) + Math.random().toString(36).slice(2, 8);
}

function bkMediaBundleSlotsToCounts(slots) {
  var c = {};
  slots.forEach(function(entry) {
    if (entry && entry.variantId) {
      var k = String(entry.variantId);
      c[k] = (c[k] || 0) + 1;
    }
  });
  return c;
}

function bkMediaBundleCountsToSlots(products, counts, slotCount) {
  var remaining = {};
  Object.keys(counts).forEach(function(k) {
    if (counts[k] > 0) remaining[k] = counts[k];
  });
  var flat = [];
  products.forEach(function(p) {
    p.variants.forEach(function(v) {
      var k = String(v.id);
      while (remaining[k] > 0 && flat.length < slotCount) {
        var cmpV = v.compare_at_price != null && v.price != null && v.compare_at_price > v.price ? v.compare_at_price : null;
        flat.push({
          variantId: v.id,
          image: p.nail_image || v.featured_media || p.featured_media,
          title: p.title + (p.variants.length > 1 ? ' — ' + v.title : ''),
          productTitle: p.title,
          variantTitle: v.title,
          price: v.price,
          compareAtPrice: cmpV
        });
        remaining[k]--;
      }
    });
  });
  while (flat.length < slotCount) flat.push(null);
  return flat.slice(0, slotCount);
}

function bkMediaBundleSelectVariantInForm(form, variant) {
  if (!form || !variant) return Promise.resolve();
  var fid = form.getAttribute('id');
  if (!fid) return Promise.resolve();

  var picker = null;
  document.querySelectorAll('variant-picker').forEach(function(el) {
    if (el.getAttribute('form-id') === fid) picker = el;
  });
  if (picker && typeof picker.selectCombination === 'function') {
    var ids = variant.optionValueIds || [];
    var valid = ids.length > 0 && ids.every(function(id) {
      return id != null && id !== '';
    });
    if (valid) {
      var optionValues = ids.map(function(id) {
        return String(id);
      });
      return picker.selectCombination({ optionValues: optionValues, productChange: false });
    }
  }

  if (variant.optionValueIds && variant.optionValueIds.length) {
    var lastRadio = null;
    variant.optionValueIds.forEach(function(ovId, i) {
      if (ovId == null || ovId === '') return;
      var pos = i + 1;
      var nm = fid + '-option' + pos;
      var radio = null;
      for (var j = 0; j < form.elements.length; j++) {
        var el = form.elements[j];
        if (!el || !el.matches) continue;
        if (el.type === 'radio' && el.name === nm && String(el.value) === String(ovId)) {
          radio = el;
          break;
        }
      }
      if (radio) {
        radio.checked = true;
        lastRadio = radio;
      }
    });
    if (lastRadio) {
      lastRadio.dispatchEvent(new Event('change', { bubbles: true }));
      return Promise.resolve();
    }
  }

  var idInput = form.querySelector('input[name="id"]');
  if (idInput) {
    idInput.value = String(variant.id);
    idInput.dispatchEvent(new Event('change', { bubbles: true }));
  }
  return Promise.resolve();
}

function bkMediaBundleSyncBundlePrice(root, cfg, addonCount) {
  if (!root || !cfg) return;
  var wrap = root.querySelector('.bk-media-bundle-builder__main-price');
  if (!wrap) return;
  var priceList = wrap.querySelector('price-list');
  if (!priceList) return;
  var n = typeof addonCount === 'number' ? addonCount : 0;
  var total = bkMediaBundleBundleTotalCents(n, cfg, root);
  var compareTotal = bkMediaBundleBundleListCompareCents(n, cfg, root);
  var onSale = compareTotal > 0 && total < compareTotal;
  var fmt = bkMediaBundleFormatMoney;
  var saleText = fmt(total);
  var compareText = compareTotal != null ? fmt(compareTotal) : '';

  var saleEl = priceList.querySelector('sale-price');
  if (!saleEl) return;
  var saleSr = saleEl.querySelector('.sr-only');
  saleEl.className = onSale ? 'text-lg text-on-sale' : 'text-lg';
  saleEl.textContent = '';
  if (saleSr) {
    saleEl.appendChild(saleSr);
  } else {
    var sr = document.createElement('span');
    sr.className = 'sr-only';
    saleEl.appendChild(sr);
  }
  saleEl.appendChild(document.createTextNode(saleText));

  var compareEl = priceList.querySelector('compare-at-price');
  if (onSale && compareTotal != null) {
    if (!compareEl) {
      compareEl = document.createElement('compare-at-price');
      compareEl.className = 'text-lg text-subdued line-through';
      var csrNew = document.createElement('span');
      csrNew.className = 'sr-only';
      compareEl.appendChild(csrNew);
      priceList.appendChild(compareEl);
    }
    compareEl.className = 'text-lg text-subdued line-through';
    var csr = compareEl.querySelector('.sr-only');
    compareEl.textContent = '';
    if (csr) compareEl.appendChild(csr);
    else {
      var c = document.createElement('span');
      c.className = 'sr-only';
      compareEl.appendChild(c);
    }
    compareEl.appendChild(document.createTextNode(compareText));
  } else if (compareEl) {
    compareEl.remove();
  }

  bkMediaBundleSyncBundleDiscountBadge(wrap, onSale, compareTotal, total, cfg, n, root);
}

function bkMediaBundleSyncBundleDiscountBadge(wrap, onSale, compareTotal, total, cfg, addonCount, bundleRoot) {
  if (!wrap || !cfg) return;
  var badge = wrap.querySelector('[data-bk-bundle-addon-discount]');
  if (!badge) return;
  if (!cfg.showDiscount) {
    badge.setAttribute('hidden', '');
    return;
  }
  if (!onSale || compareTotal == null || total >= compareTotal) {
    badge.setAttribute('hidden', '');
    return;
  }
  var savings;
  if (cfg.discountMode === 'percentage') {
    var au = Math.floor(Number(addonCount));
    var ovPct = null;
    if (
      cfg.gratisStarterLadder &&
      Array.isArray(cfg.gratisLadderPctDisplay) &&
      au >= 1 &&
      au <= cfg.gratisLadderPctDisplay.length
    ) {
      var rawPct = cfg.gratisLadderPctDisplay[au - 1];
      if (rawPct != null && String(rawPct).trim() !== '') {
        ovPct = String(rawPct).trim();
      }
    }
    if (
      ovPct == null &&
      cfg.slotBadgeLayout === 'percentage' &&
      Array.isArray(cfg.percentageDiscountBadgePcts)
    ) {
      var auCsv = Math.floor(Number(addonCount));
      var idxCsv = auCsv;
      var refillBadge =
        cfg.bundlePriceMode === 'refill' || cfg.bundle_price_mode === 'refill';
      if (refillBadge && bundleRoot && bundleRoot.getAttribute) {
        var tr = Math.floor(Number(bundleRoot.getAttribute('data-initial-tier')));
        if (!isNaN(tr) && tr >= 1) {
          idxCsv = tr;
        }
      }
      if (idxCsv >= 1 && idxCsv <= cfg.percentageDiscountBadgePcts.length) {
        var rawBd = cfg.percentageDiscountBadgePcts[idxCsv - 1];
        if (rawBd != null && String(rawBd).trim() !== '') {
          ovPct = String(rawBd).trim();
        }
      }
    }
    if (ovPct != null) {
      var rawStr = String(ovPct).trim();
      var numFromCfg = parseFloat(rawStr.replace(',', '.'));
      if (!isNaN(numFromCfg)) {
        savings = Math.round(numFromCfg) + '%';
      } else {
        savings = rawStr.indexOf('%') >= 0 ? rawStr : rawStr + '%';
      }
    } else {
      savings = Math.round(((compareTotal - total) / compareTotal) * 100) + '%';
    }
  } else {
    savings = bkMediaBundleFormatMoney(compareTotal - total);
  }
  var tpl = cfg.discountBadgeTemplate;
  if (typeof tpl === 'string' && tpl.indexOf('__SAVINGS__') >= 0) {
    badge.innerHTML = tpl.split('__SAVINGS__').join(savings);
  } else if (typeof tpl === 'string' && tpl.length) {
    badge.innerHTML = tpl.replace(/\{\{\s*savings\s*\}\}/gi, savings);
  } else {
    badge.textContent = savings;
  }
  badge.removeAttribute('hidden');
}

function bkMediaGetCartDrawerSectionId() {
  var cartDrawer = document.querySelector('cart-drawer[data-theme-cart-drawer]') || document.querySelector('cart-drawer');
  if (!cartDrawer) return 'cart-drawer';
  var el = cartDrawer.classList.contains('shopify-section') ? cartDrawer : cartDrawer.closest('.shopify-section');
  if (!el || !el.id) return 'cart-drawer';
  return el.id.replace(/^shopify-section-/, '');
}

function bkMediaBundleApplyAtcButtonContent(btn, text, showLock) {
  if (!btn || text == null) return;
  var label = String(text);
  var tpl = document.getElementById('bk-media-bundle-atc-lock-icon');
  while (btn.firstChild) {
    btn.removeChild(btn.firstChild);
  }
  if (showLock && tpl && tpl.content && tpl.content.childNodes.length) {
    var wrap = document.createElement('div');
    wrap.className = 'text-with-icon justify-center';
    wrap.appendChild(tpl.content.cloneNode(true));
    wrap.appendChild(document.createTextNode(label));
    btn.appendChild(wrap);
    return;
  }
  btn.appendChild(document.createTextNode(label));
}

function bkMediaBundleSlotProductImageClassAttr(cfg) {
  var aspect = (cfg && cfg.productImageAspect) || 'square';
  var crop = cfg && cfg.productImageCrop === true;
  var cls = 'bk-media-bundle-builder__slot-img product-card__image';
  if (crop) cls += ' object-fill-safe';
  cls += ' aspect-' + aspect;
  return cls;
}

function bkMediaAnimateScrollLeft(scrollEl, targetLeft, durationMs) {
  var startLeft = scrollEl.scrollLeft;
  var delta = targetLeft - startLeft;
  if (Math.abs(delta) < 1) return;
  var start = performance.now();
  function step(now) {
    var t = Math.min(1, (now - start) / durationMs);
    var eased = t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
    scrollEl.scrollLeft = startLeft + delta * eased;
    if (t < 1) requestAnimationFrame(step);
  }
  requestAnimationFrame(step);
}

function bkMediaScrollChildCenterHorizontally(scrollEl, childEl, behavior, attempt, durationMs) {
  if (!scrollEl || !childEl) return;
  attempt = attempt || 0;
  var maxL = Math.max(0, scrollEl.scrollWidth - scrollEl.clientWidth);
  if (maxL <= 0 && attempt < 20) {
    requestAnimationFrame(function() {
      bkMediaScrollChildCenterHorizontally(scrollEl, childEl, behavior, attempt + 1, durationMs);
    });
    return;
  }
  if (maxL <= 0) return;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var beh = reduce ? 'auto' : behavior || 'smooth';
  var sR = scrollEl.getBoundingClientRect();
  var cR = childEl.getBoundingClientRect();
  var need = cR.left + cR.width / 2 - (sR.left + sR.width / 2);
  var targetLeft = scrollEl.scrollLeft + need;
  targetLeft = Math.max(0, Math.min(maxL, targetLeft));
  if (!reduce && durationMs && durationMs > 0) {
    bkMediaAnimateScrollLeft(scrollEl, targetLeft, durationMs);
    return;
  }
  try {
    scrollEl.scrollTo({ left: targetLeft, behavior: beh });
  } catch (e) {
    scrollEl.scrollLeft = targetLeft;
  }
}

window.bkMediaScrollChildCenterHorizontally = bkMediaScrollChildCenterHorizontally;

function bkMediaReadCookie(name) {
  var match = document.cookie.match(
    new RegExp('(^|;) ?' + name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '=([^;]*)(;|$)')
  );
  return match ? decodeURIComponent(match[2]) : '';
}

function bkMediaParseWishlistProductIdsFromCookie() {
  var raw = bkMediaReadCookie('WISHLIST_PRODUCTS_IDS');
  if (!raw) return [];
  try {
    var data = JSON.parse(raw);
    return Object.keys(data).filter(function(id) {
      var entry = data[id];
      return entry && (entry.is_exist !== false || (entry.variants && entry.variants.length));
    });
  } catch (e) {
    return [];
  }
}

function bkMediaBundleDrawerWishlistCardMatchesUnitPrice(card, unitPriceCents) {
  if (!card) return false;
  var unitPrice = Number(unitPriceCents);
  if (!unitPrice || unitPrice <= 0) return true;
  var script = card.querySelector('script[data-bb-card-product]');
  if (!script || !script.textContent) return false;
  try {
    var product = JSON.parse(script.textContent);
    var variants = product && product.variants ? product.variants : [];
    for (var i = 0; i < variants.length; i++) {
      var variant = variants[i];
      if (variant && variant.available && Number(variant.price) === unitPrice) {
        return true;
      }
    }
    return false;
  } catch (e) {
    return false;
  }
}

function bkMediaFilterWishlistFeedCardsByUnitPrice(feed, unitPriceCents) {
  if (!feed || !unitPriceCents) return;
  feed.querySelectorAll('[data-bundle-drawer-card]').forEach(function(card) {
    if (!bkMediaBundleDrawerWishlistCardMatchesUnitPrice(card, unitPriceCents)) {
      card.remove();
    }
  });
}

function bkMediaFetchWishlistProductIdsFromSeApi() {
  var uuid = bkMediaReadCookie('WISHLIST_UUID');
  if (!uuid || typeof Shopify === 'undefined' || !Shopify.shop) {
    return Promise.resolve([]);
  }
  return fetch('https://livewishlist.scriptengine.net/api/get-all-product', {
    method: 'POST',
    headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
    body: JSON.stringify({
      uuid: uuid,
      ip_address: bkMediaReadCookie('WISHLIST_IP_ADDRESS'),
      shop: Shopify.shop,
      shopify_local_language: Shopify.locale || 'de'
    })
  })
    .then(function(res) {
      return res.json();
    })
    .then(function(json) {
      var list = json && json.data ? json.data : [];
      var seen = {};
      var ids = [];
      list.forEach(function(item) {
        var pid = String(item.product_id || item.shopify_id || '');
        if (pid && !seen[pid]) {
          seen[pid] = true;
          ids.push(pid);
        }
      });
      return ids;
    })
    .catch(function() {
      return [];
    });
}

function bkMediaOrderDrawerCardsByProductIds(grid, ids) {
  if (!grid || !ids || !ids.length) return;
  var cards = Array.from(grid.querySelectorAll('[data-bundle-drawer-card]'));
  if (!cards.length) return;
  var byId = {};
  cards.forEach(function(card) {
    byId[String(card.getAttribute('data-product-id') || '')] = card;
  });
  cards.forEach(function(card) {
    card.remove();
  });
  ids.forEach(function(id) {
    var card = byId[String(id)];
    if (card) grid.appendChild(card);
  });
}

function scrollBundleDrawerActiveCollectionTabIntoView(drawerEl, deferMs) {
  if (!drawerEl) return;
  var tabsScroll = drawerEl.querySelector('[data-bundle-collection-tabs]');
  if (!tabsScroll) return;
  var active = tabsScroll.querySelector('.bk-media-bundle-drawer__filter--collection-tab.is-active');
  if (!active) return;
  var pill = active.closest('.bk-media-bundle-drawer__filter-pill') || active;
  var d = typeof deferMs === 'number' ? deferMs : 0;
  function run() {
    requestAnimationFrame(function() {
      requestAnimationFrame(function() {
        bkMediaScrollChildCenterHorizontally(tabsScroll, pill, 'smooth', 0);
      });
    });
  }
  if (d > 0) {
    setTimeout(run, d);
  } else {
    run();
  }
}

function initCollectionSwitcherScrollSelected() {
  document.querySelectorAll('.shopify-section--collection-switcher .collection-switcher__item--selected').forEach(function(el) {
    var sc = el.closest('scroll-carousel');
    if (!sc) return;
    setTimeout(function() {
      requestAnimationFrame(function() {
        requestAnimationFrame(function() {
          bkMediaScrollChildCenterHorizontally(sc, el, 'smooth', 0);
        });
      });
    }, 100);
  });
}

var collectionWishlistPopulateToken = 0;

function bkMediaResolveWishlistProductIds() {
  var ids = bkMediaParseWishlistProductIdsFromCookie();
  if (ids.length) return Promise.resolve(ids);
  return bkMediaFetchWishlistProductIdsFromSeApi();
}

function buildCollectionWishlistSearchUrl(ids, rootEl) {
  var q = ids
    .map(function(id) {
      return 'id:' + id;
    })
    .join(' OR ');
  var params = new URLSearchParams();
  params.set('type', 'product');
  params.set('q', q);
  params.set('view', 'collection-wishlist');
  var mobileCols = rootEl.getAttribute('data-collection-wishlist-mobile-cols');
  var desktopCols = rootEl.getAttribute('data-collection-wishlist-desktop-cols');
  if (mobileCols) params.set('cs_mobile_cols', mobileCols);
  if (desktopCols) params.set('cs_desktop_cols', desktopCols);
  return (window.Shopify.routes.root || '/') + 'search?' + params.toString();
}

function bkMediaOrderCollectionWishlistCards(feed, ids) {
  if (!feed || !ids || !ids.length) return;
  var cards = Array.from(feed.querySelectorAll('[data-collection-wishlist-card]'));
  if (!cards.length) return;
  var byId = {};
  cards.forEach(function(card) {
    byId[String(card.getAttribute('data-product-id') || '')] = card;
  });
  cards.forEach(function(card) {
    card.remove();
  });
  ids.forEach(function(id) {
    var card = byId[String(id)];
    if (card) feed.appendChild(card);
  });
}

function setCollectionWishlistStatus(panel, state) {
  if (!panel) return;
  var loading = panel.querySelector('[data-collection-wishlist-loading]');
  var empty = panel.querySelector('[data-collection-wishlist-empty]');
  if (loading) loading.hidden = state !== 'loading';
  if (empty) empty.hidden = state !== 'empty';
}

function clearCollectionWishlistCards(rootEl) {
  var feed = rootEl.querySelector('[data-collection-wishlist-feed]');
  if (!feed) return;
  feed.innerHTML = '';
}

function appendCollectionWishlistCardsFromHtml(rootEl, html, ids) {
  var feed = rootEl.querySelector('[data-collection-wishlist-feed]');
  if (!feed) return 0;
  var doc = new DOMParser().parseFromString(html, 'text/html');
  var remoteFeed = doc.querySelector('[data-collection-wishlist-feed]');
  if (!remoteFeed) return 0;
  var existingIds = {};
  feed.querySelectorAll('[data-collection-wishlist-card]').forEach(function(card) {
    existingIds[String(card.getAttribute('data-product-id') || '')] = true;
  });
  var appended = 0;
  remoteFeed.querySelectorAll('[data-collection-wishlist-card]').forEach(function(card) {
    var pid = String(card.getAttribute('data-product-id') || '');
    if (!pid || existingIds[pid]) return;
    existingIds[pid] = true;
    feed.appendChild(card);
    appended++;
  });
  bkMediaOrderCollectionWishlistCards(feed, ids);
  return appended;
}

function fetchCollectionWishlistChunk(ids, rootEl) {
  if (!ids.length) return Promise.resolve('');
  return fetch(buildCollectionWishlistSearchUrl(ids, rootEl)).then(function(res) {
    if (!res.ok) throw new Error('collection wishlist search');
    return res.text();
  });
}

function populateCollectionWishlist(rootEl, force) {
  var panel = rootEl.querySelector('[data-collection-wishlist-panel]');
  var feed = rootEl.querySelector('[data-collection-wishlist-feed]');
  if (!panel || !feed) return Promise.resolve();
  var token = ++collectionWishlistPopulateToken;
  setCollectionWishlistStatus(panel, 'loading');
  clearCollectionWishlistCards(rootEl);
  return bkMediaResolveWishlistProductIds().then(function(ids) {
    if (token !== collectionWishlistPopulateToken) return;
    if (!ids.length) {
      feed.setAttribute('data-wishlist-loaded-key', '');
      setCollectionWishlistStatus(panel, 'empty');
      return;
    }
    var idsKey = ids.join(',');
    if (
      !force &&
      feed.getAttribute('data-wishlist-loaded-key') === idsKey &&
      feed.querySelector('[data-collection-wishlist-card]')
    ) {
      setCollectionWishlistStatus(panel, 'idle');
      return;
    }
    var chunkSize = 10;
    var chain = Promise.resolve();
    for (var i = 0; i < ids.length; i += chunkSize) {
      (function(chunk) {
        chain = chain.then(function() {
          if (token !== collectionWishlistPopulateToken) return;
          return fetchCollectionWishlistChunk(chunk, rootEl).then(function(html) {
            if (token !== collectionWishlistPopulateToken) return;
            appendCollectionWishlistCardsFromHtml(rootEl, html, ids);
          });
        });
      })(ids.slice(i, i + chunkSize));
    }
    return chain
      .then(function() {
        if (token !== collectionWishlistPopulateToken) return;
        feed.setAttribute('data-wishlist-loaded-key', idsKey);
        var hasCards = feed.querySelector('[data-collection-wishlist-card]');
        setCollectionWishlistStatus(panel, hasCards ? 'idle' : 'empty');
        initBkMediaProductCardCarouselProductLink();
      })
      .catch(function() {
        if (token !== collectionWishlistPopulateToken) return;
        feed.setAttribute('data-wishlist-loaded-key', '');
        setCollectionWishlistStatus(panel, 'empty');
      });
  });
}

function scrollCollectionSwitcherActiveTabIntoView(rootOrSwitcherEl, deferMs, durationMs) {
  if (!rootOrSwitcherEl) return;
  var tabsScroll = rootOrSwitcherEl.querySelector('[data-collection-switcher-tabs]');
  if (!tabsScroll && rootOrSwitcherEl.matches('[data-collection-switcher]')) {
    tabsScroll = rootOrSwitcherEl.querySelector('[data-collection-switcher-tabs]');
  }
  if (!tabsScroll) {
    var switcher = rootOrSwitcherEl.querySelector('[data-collection-switcher]');
    if (switcher) tabsScroll = switcher.querySelector('[data-collection-switcher-tabs]');
  }
  if (!tabsScroll) return;
  var active = tabsScroll.querySelector('.bk-media-collection-switcher__link.is-active');
  if (!active) return;
  var pill = active.closest('.bk-media-collection-switcher__pill') || active;
  var d = typeof deferMs === 'number' ? deferMs : 0;
  var scrollDuration = typeof durationMs === 'number' ? durationMs : 550;
  function run() {
    requestAnimationFrame(function() {
      requestAnimationFrame(function() {
        bkMediaScrollChildCenterHorizontally(tabsScroll, pill, 'smooth', 0, scrollDuration);
      });
    });
  }
  if (d > 0) {
    setTimeout(run, d);
  } else {
    run();
  }
}

var collectionSwitcherActiveScrollTimer;

function initCollectionSwitcherActiveScroll() {
  document.querySelectorAll('[data-collection-switcher]').forEach(function(switcherEl) {
    if (!switcherEl.querySelector('.bk-media-collection-switcher__link.is-active')) return;
    scrollCollectionSwitcherActiveTabIntoView(switcherEl, 0, 550);
  });
}

function scheduleCollectionSwitcherActiveScroll() {
  clearTimeout(collectionSwitcherActiveScrollTimer);
  collectionSwitcherActiveScrollTimer = setTimeout(initCollectionSwitcherActiveScroll, 150);
}

/* ========================================
   COLLECTION LOAD MORE
   ======================================== */

function bkMediaLoadMoreCollectionProducts(btn, section, wrapper) {
  var nextUrl = btn.getAttribute('data-next-url');
  if (!nextUrl || btn.getAttribute('aria-busy') === 'true') return Promise.resolve();

  var sectionId = section.id.replace('shopify-section-', '');
  var fetchUrl = new URL(nextUrl, window.location.origin);
  fetchUrl.searchParams.set('section_id', sectionId);

  var localList = section.querySelector('[data-collection-default-panel] [data-collection-product-list]');
  if (!localList) return Promise.resolve();

  btn.setAttribute('aria-busy', 'true');
  btn.disabled = true;

  return fetch(fetchUrl.toString(), { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
    .then(function(res) {
      if (!res.ok) throw new Error('collection load more');
      return res.text();
    })
    .then(function(html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var remoteSection = doc.getElementById(section.id);
      if (!remoteSection) return;

      var remoteList = remoteSection.querySelector('[data-collection-default-panel] [data-collection-product-list]');
      if (!remoteList) return;

      Array.from(remoteList.children).forEach(function(child) {
        localList.appendChild(document.importNode(child, true));
      });

      var remoteBtn = remoteSection.querySelector('[data-collection-load-more-btn]');
      var remoteNextUrl = remoteBtn ? remoteBtn.getAttribute('data-next-url') : '';
      if (remoteNextUrl) {
        btn.setAttribute('data-next-url', remoteNextUrl);
        wrapper.hidden = false;
      } else {
        btn.removeAttribute('data-next-url');
        wrapper.hidden = true;
      }

      var historyUrl = new URL(nextUrl, window.location.origin);
      history.pushState({}, '', historyUrl.toString());

      if (typeof initBkMediaProductCardCarouselProductLink === 'function') {
        initBkMediaProductCardCarouselProductLink();
      }
    })
    .catch(function(err) {
      console.error('Collection load more failed', err);
    })
    .finally(function() {
      btn.removeAttribute('aria-busy');
      btn.disabled = false;
    });
}

function initCollectionLoadMore() {
  if (window.__bkMediaCollectionLoadMoreBound) return;
  window.__bkMediaCollectionLoadMoreBound = true;

  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-collection-load-more-btn]');
    if (!btn || btn.getAttribute('aria-busy') === 'true') return;

    var wrapper = btn.closest('[data-collection-load-more]');
    var section = btn.closest('.shopify-section');
    if (!wrapper || !section) return;

    e.preventDefault();
    bkMediaLoadMoreCollectionProducts(btn, section, wrapper);
  });
}

function setCollectionWishlistActive(rootEl, active) {
  if (!rootEl) return;
  rootEl.classList.toggle('collection--wishlist-active', active);
  var wishlistPanel = rootEl.querySelector('[data-collection-wishlist-panel]');
  if (wishlistPanel) wishlistPanel.hidden = !active;
  var tabsWrap = rootEl.querySelector('[data-collection-switcher-tabs]');
  if (!tabsWrap) return;
  var wishlistBtn = tabsWrap.querySelector('[data-collection-switcher-tab="wishlist"]');
  tabsWrap.querySelectorAll('a[data-collection-switcher-tab="collection"]').forEach(function(link) {
    if (active) {
      link.classList.remove('is-active');
      link.removeAttribute('aria-current');
    }
  });
  if (wishlistBtn) {
    wishlistBtn.classList.toggle('is-active', active);
    wishlistBtn.setAttribute('aria-pressed', active ? 'true' : 'false');
  }
}

function initCollectionSwitcherWishlist() {
  document.querySelectorAll('[data-collection-wishlist-root]:not([data-collection-wishlist-bound])').forEach(function(rootEl) {
    var tabsWrap = rootEl.querySelector('[data-collection-switcher-tabs]');
    if (!tabsWrap || tabsWrap.getAttribute('data-collection-wishlist-tabs-bound') === 'true') return;
    rootEl.setAttribute('data-collection-wishlist-bound', 'true');
    tabsWrap.setAttribute('data-collection-wishlist-tabs-bound', 'true');
    tabsWrap.addEventListener('click', function(e) {
      var wishlistBtn = e.target.closest('[data-collection-switcher-tab="wishlist"]');
      if (!wishlistBtn || !tabsWrap.contains(wishlistBtn)) return;
      e.preventDefault();
      setCollectionWishlistActive(rootEl, true);
      populateCollectionWishlist(rootEl, false).then(function() {
        scrollCollectionSwitcherActiveTabIntoView(rootEl, 80, 550);
      });
    });
  });
}

function bkMediaBundleResolveCheckoutVariantIdForTierQty(bundleCfg, tierQty) {
  if (!bundleCfg) return null;
  var map = bundleCfg.presetCheckoutVariants || {};
  var raw = map[String(tierQty)];
  if (raw != null && raw !== '') {
    var n = Number(raw);
    if (!isNaN(n) && n > 0) return n;
  }
  var base = bundleCfg.baseCheckoutVariantId != null ? Number(bundleCfg.baseCheckoutVariantId) : null;
  if (base != null && !isNaN(base) && base > 0) return base;
  var fb = bundleCfg.checkoutVariantId != null ? Number(bundleCfg.checkoutVariantId) : null;
  if (fb != null && !isNaN(fb) && fb > 0) return fb;
  return null;
}

function bkMediaBundleFindProductGallery(formId, form) {
  var gallery = null;
  document.querySelectorAll('product-gallery').forEach(function(g) {
    if (g.getAttribute('form') === formId) {
      gallery = g;
    }
  });
  if (!gallery && form) {
    var col = form.closest('.product');
    if (col) {
      gallery = col.querySelector('product-gallery');
    }
  }
  return gallery;
}

function bkMediaBundleComputeGalleryFilteredIndexes(carousel, variantDetail, productTitle) {
  if (!carousel || !variantDetail) {
    return { filteredPositions: [], featuredIndex: 0 };
  }
  var slides = Array.from(carousel.querySelectorAll('.product-gallery__media[data-media-id]'));
  var opts = variantDetail.options && typeof variantDetail.options === 'object' ? variantDetail.options : {};
  var featuredMediaId =
    variantDetail.featuredMediaId != null ? String(variantDetail.featuredMediaId) : '';
  var productTitleStr = productTitle != null ? String(productTitle) : '';
  var filteredPositions = [];

  slides.forEach(function(slide, carouselIndex) {
    var slideMediaId = slide.getAttribute('data-media-id') || '';
    if (featuredMediaId && slideMediaId === featuredMediaId) {
      return;
    }
    var img = slide.querySelector('img');
    var alt = img ? img.getAttribute('alt') || '' : '';
    if (!alt || alt.indexOf('#') === -1 || alt === productTitleStr) {
      return;
    }
    var hashPart = alt.split('#').pop();
    var usIdx = hashPart.indexOf('_');
    if (usIdx < 0) {
      return;
    }
    var optionName = hashPart.slice(0, usIdx);
    var groupValue = hashPart.slice(usIdx + 1).trim().toLowerCase();
    var optionValue =
      opts[optionName] != null ? String(opts[optionName]).trim().toLowerCase() : '';
    if (optionValue !== groupValue) {
      filteredPositions.push(carouselIndex + 1);
    }
  });

  var featuredIndex = 0;
  if (variantDetail.featuredMediaPosition != null) {
    var pos = Number(variantDetail.featuredMediaPosition);
    if (!isNaN(pos) && pos >= 1) {
      featuredIndex = pos - 1;
    }
  }

  return { filteredPositions: filteredPositions, featuredIndex: featuredIndex };
}

function bkMediaBundleSyncGalleryForVariantDetail(gallery, variantDetail, productTitle) {
  if (!gallery || !variantDetail || !variantDetail.id) {
    return;
  }
  var carousel = gallery.querySelector('media-carousel');
  if (!carousel) {
    return;
  }
  var result = bkMediaBundleComputeGalleryFilteredIndexes(carousel, variantDetail, productTitle);
  var filteredPositions = result.filteredPositions;
  var filteredIndexesZero = filteredPositions.map(function(p) {
    return p - 1;
  });

  gallery.setAttribute('filtered-indexes', JSON.stringify(filteredPositions));
  carousel._items = null;
  carousel.dispatchEvent(
    new CustomEvent('carousel:filter', { detail: { filteredIndexes: filteredIndexesZero } })
  );
  gallery.querySelectorAll('page-dots[aria-controls]').forEach(function(pageDots) {
    pageDots.dispatchEvent(
      new CustomEvent('control:filter', { detail: { filteredIndexes: filteredIndexesZero } })
    );
  });
  carousel.select(result.featuredIndex, { animate: false, force: true });
}

function bkMediaBundleSyncGalleryForTier(bundleCfg, formId, form, tierQty) {
  var detail = (bundleCfg.presetVariantDetails || {})[String(tierQty)];
  if (!detail || !detail.id) {
    return;
  }
  var gallery = bkMediaBundleFindProductGallery(formId, form);
  if (!gallery) {
    return;
  }
  bkMediaBundleSyncGalleryForVariantDetail(gallery, detail, bundleCfg.productTitle);
}

function bkMediaMergeBundleProductsFromMiniJson(scopeRoot, cfg) {
  if (!scopeRoot || !cfg || !Array.isArray(cfg.products)) return;
  var seen = {};
  cfg.products.forEach(function(p) {
    if (p && p.id != null) seen[String(p.id)] = true;
  });
  scopeRoot.querySelectorAll('script[type="application/json"][data-bb-card-product]').forEach(function(s) {
    try {
      var p = JSON.parse(s.textContent);
      if (p && p.id != null && !seen[String(p.id)]) {
        seen[String(p.id)] = true;
        cfg.products.push(p);
      }
    } catch (e) {}
  });
}

function initBundleBuilder(root) {
  if (!window.__bkBundleInited) window.__bkBundleInited = new WeakSet();
  if (window.__bkBundleInited.has(root)) return;
  window.__bkBundleInited.add(root);

  var cfgEl = root.querySelector('script[data-bundle-config]');
  if (!cfgEl) return;
  var cfg;
  try {
    cfg = JSON.parse(cfgEl.textContent);
  } catch (e) {
    return;
  }
  var form = document.getElementById(cfg.formId);
  if (!form) return;
  function getBundleDrawer() {
    var d = root.querySelector('x-drawer.bk-media-bundle-builder__drawer');
    if (d && d.isConnected) return d;
    if (cfg.drawerDomId) {
      d = document.getElementById(cfg.drawerDomId);
      if (d) return d;
    }
    return null;
  }

  var variantCards = root.querySelectorAll('.bk-media-bundle-builder__variant-card');
  var slotGrid = root.querySelector('[data-slot-grid]');
  var searchInput = root.querySelector('[data-bundle-search]');
  var confirmBtn = root.querySelector('[data-drawer-confirm]');
  var confirmWrap = root.querySelector('[data-drawer-confirm-wrap]');
  var stripEl = root.querySelector('[data-selection-strip]');
  var remainingEl = root.querySelector('[data-remaining-label]');
  var cartWrap = root.querySelector('[data-bundle-cart]');
  var statusEl = root.querySelector('[data-bundle-status]');
  var bundlePlaceholderTpl = root.querySelector('template[data-bundle-image-placeholder]');
  var bundlePlaceholderHtml =
    bundlePlaceholderTpl && bundlePlaceholderTpl.innerHTML ? bundlePlaceholderTpl.innerHTML.trim() : '';
  var designSlotSelector =
    '.bk-media-bundle-builder__slot:not([data-optional-design-slot]):not([data-premium-gift-slot])';

  (function mergeInitialBundleDrawerProducts() {
    var dm = root.querySelector('x-drawer.bk-media-bundle-builder__drawer');
    if (!dm && cfg.drawerDomId) dm = document.getElementById(cfg.drawerDomId);
    bkMediaMergeBundleProductsFromMiniJson(dm || root, cfg);
  })();

  function getBundleDrawerScope() {
    return getBundleDrawer() || root;
  }

  function queryBundleDrawerCards() {
    var host = getBundleDrawer() || root;
    return host.querySelectorAll('[data-bundle-drawer-card]');
  }

  function isBundleDrawerOpen() {
    var d = getBundleDrawer();
    return !!(d && d.open);
  }

  var wishlistTabPopulateToken = 0;

  function isBundleDrawerWishlistTabActive() {
    var tabsWrap = getBundleDrawerScope().querySelector('[data-bundle-collection-tabs]');
    if (!tabsWrap) return false;
    var active = tabsWrap.querySelector('.bk-media-bundle-drawer__filter--collection-tab.is-active');
    return active && String(active.getAttribute('data-bundle-collection-id') || '') === 'wishlist';
  }

  function getBundleDrawerWishlistPanel() {
    var scope = getBundleDrawerScope();
    return scope.querySelector('[data-bundle-collection-grid][data-collection-id="wishlist"]');
  }

  function getBundleDrawerWishlistTabPill() {
    var scope = getBundleDrawerScope();
    if (!scope) return null;
    return scope.querySelector('[data-bundle-wishlist-tab]');
  }

  function syncBundleDrawerFiltersRowVisibility() {
    var scope = getBundleDrawerScope();
    if (!scope) return;
    var filtersRow = scope.querySelector('.bk-media-bundle-drawer__filters-row');
    if (!filtersRow) return;
    var visibleTabs = filtersRow.querySelectorAll(
      '.bk-media-bundle-drawer__filter-pill:not([hidden]) .bk-media-bundle-drawer__filter--collection-tab'
    );
    filtersRow.hidden = visibleTabs.length <= 1;
  }

  function activateFirstBundleDrawerCollectionTab() {
    var scope = getBundleDrawerScope();
    var tabsWrap = scope && scope.querySelector('[data-bundle-collection-tabs]');
    if (!tabsWrap) return;
    var firstColTab = tabsWrap.querySelector(
      '.bk-media-bundle-drawer__filter--collection-tab:not([data-bundle-collection-id="wishlist"])'
    );
    if (!firstColTab) return;
    tabsWrap.querySelectorAll('.bk-media-bundle-drawer__filter--collection-tab').forEach(function(b) {
      var on = b === firstColTab;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    syncBundleCollectionPanelsVisibility();
    applyFiltersAndSearch();
  }

  var bundleDrawerWishlistHasItems = null;

  function applyBundleDrawerWishlistVisibility(hasItems) {
    var tabPill = getBundleDrawerWishlistTabPill();
    var wishlistPanel = getBundleDrawerWishlistPanel();
    if (tabPill) tabPill.hidden = !hasItems;
    if (wishlistPanel && !hasItems) wishlistPanel.hidden = true;
    if (!hasItems && isBundleDrawerWishlistTabActive()) {
      activateFirstBundleDrawerCollectionTab();
    }
    syncBundleDrawerFiltersRowVisibility();
  }

  function syncBundleDrawerWishlistTabVisibility(forceRefresh) {
    if (!cfg.showDrawerWishlistTab) return Promise.resolve(false);
    var tabPill = getBundleDrawerWishlistTabPill();
    var wishlistPanel = getBundleDrawerWishlistPanel();
    if (!tabPill && !wishlistPanel) return Promise.resolve(false);

    if (bundleDrawerWishlistHasItems !== null && !forceRefresh) {
      applyBundleDrawerWishlistVisibility(bundleDrawerWishlistHasItems);
      return Promise.resolve(bundleDrawerWishlistHasItems);
    }

    return resolveWishlistProductIds().then(function(ids) {
      var hasItems = !!(ids && ids.length);
      bundleDrawerWishlistHasItems = hasItems;
      applyBundleDrawerWishlistVisibility(hasItems);
      return hasItems;
    });
  }

  var bundleDrawerWishlistCountObserverBound = false;

  function bindBundleDrawerWishlistCountObserver() {
    if (bundleDrawerWishlistCountObserverBound || typeof MutationObserver === 'undefined') return;
    var countEl = document.querySelector('.wishlist-total-count[data-total]');
    if (!countEl) return;
    bundleDrawerWishlistCountObserverBound = true;
    new MutationObserver(function() {
      bundleDrawerWishlistHasItems = null;
      syncBundleDrawerWishlistTabVisibility(true);
    }).observe(countEl, { attributes: true, attributeFilter: ['data-total'] });
  }

  function getBundleDrawerWishlistGrid() {
    var panel = getBundleDrawerWishlistPanel();
    if (!panel) return null;
    return panel.querySelector('[data-drawer-wishlist-grid]');
  }

  function getBundleDrawerWishlistFeed() {
    var panel = getBundleDrawerWishlistPanel();
    if (!panel) return null;
    return panel.querySelector('#bk-bundle-drawer-wishlist-feed');
  }

  function setBundleDrawerWishlistStatus(panel, state) {
    if (!panel) return;
    var loading = panel.querySelector('[data-bundle-wishlist-loading]');
    var empty = panel.querySelector('[data-bundle-wishlist-empty]');
    if (loading) loading.hidden = state !== 'loading';
    if (empty) empty.hidden = state !== 'empty';
  }

  function clearBundleDrawerWishlistCards() {
    var feed = getBundleDrawerWishlistFeed();
    if (!feed) return;
    feed.querySelectorAll('[data-bundle-drawer-card]').forEach(function(c) {
      c.remove();
    });
  }

  function resolveWishlistProductIds() {
    var ids = bkMediaParseWishlistProductIdsFromCookie();
    if (ids.length) return Promise.resolve(ids);
    return bkMediaFetchWishlistProductIdsFromSeApi();
  }

  function buildCollectionFeedUrl(handle, view, limit, offset, page) {
    var params = new URLSearchParams();
    params.set('view', view);
    params.set('bb_parent_handle', cfg.parentProductHandle || '');
    if (cfg.excludeMainFromDrawer && cfg.bundleDrawerStripParentProductId != null) {
      params.set('bb_exclude_parent', String(cfg.bundleDrawerStripParentProductId));
      params.set('bb_exclude_main', '1');
    }
    if (limit != null) params.set('bb_limit', String(limit));
    if (offset != null) params.set('bb_offset', String(offset));
    if (page != null && page > 1) params.set('page', String(page));
    return (
      (window.Shopify.routes.root || '/') +
      'collections/' +
      encodeURIComponent(handle) +
      '?' +
      params.toString()
    );
  }

  var BB_FEED_PAGE_SIZE = 12;
  var bundleFeedLoadPromises = typeof WeakMap !== 'undefined' ? new WeakMap() : null;

  function getActiveCollectionFeed() {
    var scope = getBundleDrawerScope();
    if (!scope) return null;
    var activeGrid = scope.querySelector('[data-bundle-collection-grid]:not([hidden])');
    if (activeGrid) {
      var feedInGrid = activeGrid.querySelector('[data-bb-collection-feed]');
      if (feedInGrid) return feedInGrid;
    }
    var panel = scope.querySelector('[data-bundle-collection-panel]:not([hidden])');
    if (panel) {
      var feedInPanel = panel.querySelector('[data-bb-collection-feed]');
      if (feedInPanel) return feedInPanel;
    }
    return scope.querySelector('[data-bb-collection-feed]');
  }

  function feedHasLoadedCards(feed) {
    return !!(feed && feed.querySelector('[data-bundle-drawer-card]'));
  }

  function feedIsFullyLoaded(feed) {
    return !!(feed && feed.getAttribute('data-bb-collection-loaded') === '1');
  }

  function removeFeedSkeletons(feed) {
    if (!feed) return;
    feed.querySelectorAll('[data-bb-feed-skeleton]').forEach(function(s) {
      s.remove();
    });
  }

  function prepareBundleDrawerContent() {
    syncAllDrawerCards();
    bindDrawerCarouselControls();
    syncBundleCollectionPanelsVisibility();
    applyFiltersAndSearch();
    bindBundleDrawerZoom();
  }

  function markBundleDrawerFooterReady() {
    var drawerEl = getBundleDrawer();
    if (!drawerEl || drawerEl.classList.contains('is-footer-ready')) return;
    requestAnimationFrame(function() {
      requestAnimationFrame(function() {
        if (drawerEl.isConnected) drawerEl.classList.add('is-footer-ready');
      });
    });
  }

  function ensureActiveCollectionFeedPlaceholders() {
    var feed = getActiveCollectionFeed();
    if (!feed || feedHasLoadedCards(feed)) return;
    if (!feed.querySelector('[data-bb-feed-skeleton]')) {
      ensureFeedSkeletons(feed);
    }
  }

  function loadBundleDrawerFeedsIfNeeded() {
    var feed = getActiveCollectionFeed();
    if (feed && (feedHasLoadedCards(feed) || feedIsFullyLoaded(feed))) return Promise.resolve();
    return populateBundleDrawerCollectionFeeds({ priorityOnly: true });
  }

  function ensureFeedSkeletons(feed) {
    if (!feed || feedHasLoadedCards(feed)) return;
    if (feed.querySelector('[data-bb-feed-skeleton]')) return;
    for (var i = 0; i < 9; i++) {
      var sk = document.createElement('div');
      sk.className = 'bk-media-bundle-drawer-card-skeleton';
      sk.setAttribute('data-bb-feed-skeleton', '');
      sk.setAttribute('aria-hidden', 'true');
      sk.innerHTML =
        '<div class="bk-media-bundle-drawer-card-skeleton__media"></div><div class="bk-media-bundle-drawer-card-skeleton__line"></div>';
      feed.appendChild(sk);
    }
  }

  function readRemoteFeedMeta(remoteFeed) {
    var meta = { nextPage: 1, nextOffset: 0, hasMore: false };
    if (!remoteFeed) return meta;
    var nextPage = parseInt(remoteFeed.getAttribute('data-bb-next-page') || '1', 10);
    var nextOffset = parseInt(remoteFeed.getAttribute('data-bb-next-offset') || '0', 10);
    var hasMore = remoteFeed.getAttribute('data-bb-has-more') === 'true';
    if (!isNaN(nextPage) && nextPage > 0) meta.nextPage = nextPage;
    if (!isNaN(nextOffset) && nextOffset >= 0) meta.nextOffset = nextOffset;
    meta.hasMore = hasMore;
    return meta;
  }

  function applyRemoteFeedMeta(feed, meta) {
    if (!feed || !meta) return;
    feed.setAttribute('data-bb-feed-page', String(meta.nextPage || 1));
    feed.setAttribute('data-bb-feed-offset', String(meta.nextOffset || 0));
    if (meta.hasMore) {
      feed.setAttribute('data-bb-has-more', '1');
      feed.removeAttribute('data-bb-collection-loaded');
    } else {
      feed.removeAttribute('data-bb-has-more');
      feed.setAttribute('data-bb-collection-loaded', '1');
    }
  }

  function mergeRemoteFeedHtml(feed, remoteFeed, replace) {
    if (!feed || !remoteFeed) return;
    var sentinel = feed.querySelector('[data-bb-feed-sentinel]');
    if (replace) {
      removeFeedSkeletons(feed);
      feed.innerHTML = remoteFeed.innerHTML;
      return;
    }
    if (sentinel) sentinel.remove();
    remoteFeed.querySelectorAll('[data-bundle-drawer-card]').forEach(function(card) {
      feed.appendChild(card);
    });
    var remoteSentinel = remoteFeed.querySelector('[data-bb-feed-sentinel]');
    if (remoteSentinel) feed.appendChild(remoteSentinel);
  }

  function loadCollectionFeedPage(feed, options) {
    if (!feed) return Promise.resolve(false);
    options = options || {};
    if (feedIsFullyLoaded(feed)) return Promise.resolve(false);
    if (feedHasLoadedCards(feed) && !options.loadMore) return Promise.resolve(false);
    if (bundleFeedLoadPromises && bundleFeedLoadPromises.has(feed)) {
      return bundleFeedLoadPromises.get(feed);
    }

    var handle = feed.getAttribute('data-bb-collection-handle');
    var view = feed.getAttribute('data-bb-feed-view');
    if (!handle || !view) return Promise.resolve(false);

    var page = parseInt(feed.getAttribute('data-bb-feed-page') || '1', 10) || 1;
    var offset = parseInt(feed.getAttribute('data-bb-feed-offset') || '0', 10) || 0;
    var isInitial = !feedHasLoadedCards(feed);
    if (isInitial && !options.silent) ensureFeedSkeletons(feed);

    feed.setAttribute('data-bb-collection-loading', '1');

    var promise = fetch(buildCollectionFeedUrl(handle, view, BB_FEED_PAGE_SIZE, offset, page))
      .then(function(res) {
        if (!res.ok) throw new Error('collection feed');
        return res.text();
      })
      .then(function(html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var remoteFeed = doc.getElementById(feed.id);
        if (!remoteFeed) return false;
        var meta = readRemoteFeedMeta(remoteFeed);
        mergeRemoteFeedHtml(feed, remoteFeed, isInitial);
        applyRemoteFeedMeta(feed, meta);
        afterDrawerCardsAppended();
        bindBundleDrawerFeedSentinels();
        return true;
      })
      .catch(function(err) {
        console.error('Bundle drawer collection feed failed', handle, err);
        if (isInitial) removeFeedSkeletons(feed);
        return false;
      })
      .finally(function() {
        feed.removeAttribute('data-bb-collection-loading');
        if (bundleFeedLoadPromises) bundleFeedLoadPromises.delete(feed);
      });

    if (bundleFeedLoadPromises) bundleFeedLoadPromises.set(feed, promise);
    return promise;
  }

  function loadMoreCollectionFeed(feed) {
    if (!feed || feedIsFullyLoaded(feed) || feed.getAttribute('data-bb-collection-loading') === '1') {
      return Promise.resolve(false);
    }
    if (feed.getAttribute('data-bb-has-more') !== '1') return Promise.resolve(false);
    return loadCollectionFeedPage(feed, { loadMore: true });
  }

  var bundleFeedObserver =
    typeof IntersectionObserver !== 'undefined'
      ? new IntersectionObserver(
          function(entries) {
            entries.forEach(function(entry) {
              if (!entry.isIntersecting) return;
              var sentinel = entry.target;
              var feed = sentinel.closest('[data-bb-collection-feed]');
              if (!feed) return;
              var grid = feed.closest('[data-bundle-collection-grid]');
              if (grid && grid.hidden) return;
              loadMoreCollectionFeed(feed);
            });
          },
          { root: null, rootMargin: '240px 0px', threshold: 0.01 }
        )
      : null;

  function bindBundleDrawerFeedSentinels() {
    if (!bundleFeedObserver) return;
    getBundleDrawerScope()
      .querySelectorAll('[data-bb-feed-sentinel]:not([data-bb-sentinel-bound])')
      .forEach(function(sentinel) {
        sentinel.setAttribute('data-bb-sentinel-bound', 'true');
        bundleFeedObserver.observe(sentinel);
      });
  }

  function populateBundleDrawerCollectionFeeds(options) {
    options = options || {};
    var scope = getBundleDrawerScope();
    if (!scope || !scope.querySelectorAll) return Promise.resolve();
    var feeds = Array.prototype.slice.call(
      scope.querySelectorAll('[data-bb-collection-feed]:not([data-bb-collection-loaded])')
    ).filter(function(f) {
      return !feedHasLoadedCards(f);
    });
    if (!feeds.length) return Promise.resolve();

    var activeFeed = getActiveCollectionFeed();
    var priorityFeed = options.feed || activeFeed;
    var otherFeeds = feeds.filter(function(f) {
      return f !== priorityFeed;
    });

    if (priorityFeed && feeds.indexOf(priorityFeed) !== -1) {
      return loadCollectionFeedPage(priorityFeed, options).then(function() {
        if (options.priorityOnly) return;
        return Promise.all(
          otherFeeds.map(function(f) {
            return loadCollectionFeedPage(f, options);
          })
        );
      });
    }

    return Promise.all(
      feeds.map(function(f) {
        return loadCollectionFeedPage(f, options);
      })
    );
  }

  function prefetchActiveBundleDrawerFeed() {
    var feed = getActiveCollectionFeed();
    if (!feed || feedHasLoadedCards(feed) || feedIsFullyLoaded(feed)) return;
    loadCollectionFeedPage(feed, { silent: true });
  }

  function scheduleBundleDrawerFeedPrefetch() {
    if (typeof requestIdleCallback === 'function') {
      requestIdleCallback(prefetchActiveBundleDrawerFeed, { timeout: 1500 });
    } else {
      setTimeout(prefetchActiveBundleDrawerFeed, 400);
    }
  }

  function buildWishlistSearchUrl(ids) {
    var q = ids
      .map(function(id) {
        return 'id:' + id;
      })
      .join(' OR ');
    var params = new URLSearchParams();
    params.set('type', 'product');
    params.set('q', q);
    params.set('view', 'bundle-drawer-wishlist');
    params.set('bb_parent_handle', cfg.parentProductHandle || '');
    params.set('bb_bundle_group', cfg.bundleGroup || 'starter');
    if (cfg.addonUnitPrice != null && Number(cfg.addonUnitPrice) > 0) {
      params.set('bb_wishlist_unit_price', String(cfg.addonUnitPrice));
    }
    if (cfg.excludeMainFromDrawer && cfg.bundleDrawerStripParentProductId != null) {
      params.set('bb_exclude_parent', String(cfg.bundleDrawerStripParentProductId));
    }
    return (window.Shopify.routes.root || '/') + 'search?' + params.toString();
  }

  function getDrawerFeedProductIds(feed) {
    var ids = {};
    if (!feed || !feed.querySelectorAll) return ids;
    feed.querySelectorAll('[data-bundle-drawer-card]').forEach(function(card) {
      var pid = String(card.getAttribute('data-product-id') || '');
      if (pid) ids[pid] = true;
    });
    return ids;
  }

  function appendDrawerCardsToFeed(targetFeed, sourceRoot, stripPid) {
    if (!targetFeed || !sourceRoot || !sourceRoot.querySelectorAll) return 0;
    var existingIds = getDrawerFeedProductIds(targetFeed);
    var appended = 0;
    sourceRoot.querySelectorAll('[data-bundle-drawer-card]').forEach(function(card) {
      var pid = String(card.getAttribute('data-product-id') || '');
      if (!pid || existingIds[pid]) return;
      if (stripPid && pid === stripPid) return;
      existingIds[pid] = true;
      targetFeed.appendChild(card);
      appended++;
    });
    return appended;
  }

  function appendWishlistCardsFromHtml(html, ids) {
    var targetFeed = getBundleDrawerWishlistFeed();
    if (!targetFeed) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var remoteFeed = doc.getElementById('bk-bundle-drawer-wishlist-feed');
    var stripPid =
      cfg.excludeMainFromDrawer && cfg.bundleDrawerStripParentProductId != null
        ? String(cfg.bundleDrawerStripParentProductId)
        : null;
    var source = remoteFeed || doc;
    appendDrawerCardsToFeed(targetFeed, source, stripPid);
    bkMediaFilterWishlistFeedCardsByUnitPrice(targetFeed, cfg.addonUnitPrice || 1600);
    bkMediaOrderDrawerCardsByProductIds(targetFeed, ids);
  }

  function fetchWishlistDrawerChunk(ids) {
    if (!ids.length) return Promise.resolve('');
    return fetch(buildWishlistSearchUrl(ids)).then(function(res) {
      if (!res.ok) throw new Error('wishlist search');
      return res.text();
    });
  }

  function populateBundleDrawerWishlistTab(force) {
    if (!cfg.showDrawerWishlistTab) return Promise.resolve();
    var panel = getBundleDrawerWishlistPanel();
    var grid = getBundleDrawerWishlistGrid();
    if (!panel || !grid) return Promise.resolve();
    var token = ++wishlistTabPopulateToken;
    setBundleDrawerWishlistStatus(panel, 'loading');
    clearBundleDrawerWishlistCards();
    return resolveWishlistProductIds().then(function(ids) {
      if (token !== wishlistTabPopulateToken) return;
      if (!ids.length) {
        grid.setAttribute('data-wishlist-loaded-key', '');
        setBundleDrawerWishlistStatus(panel, 'empty');
        applyFiltersAndSearch();
        return;
      }
      var idsKey = ids.join(',');
      if (
        !force &&
        grid.getAttribute('data-wishlist-loaded-key') === idsKey &&
        getBundleDrawerWishlistFeed() &&
        getBundleDrawerWishlistFeed().querySelector('[data-bundle-drawer-card]')
      ) {
        setBundleDrawerWishlistStatus(panel, 'idle');
        applyFiltersAndSearch();
        syncAllDrawerCards();
        return;
      }
      var chunkSize = 10;
      var chain = Promise.resolve();
      for (var i = 0; i < ids.length; i += chunkSize) {
        (function(chunk, orderIds) {
          chain = chain.then(function() {
            if (token !== wishlistTabPopulateToken) return;
            return fetchWishlistDrawerChunk(chunk).then(function(html) {
              if (token !== wishlistTabPopulateToken) return;
              appendWishlistCardsFromHtml(html, orderIds);
            });
          });
        })(ids.slice(i, i + chunkSize), ids);
      }
      return chain
        .then(function() {
          if (token !== wishlistTabPopulateToken) return;
          grid.setAttribute('data-wishlist-loaded-key', idsKey);
          var feed = getBundleDrawerWishlistFeed();
          var hasCards = feed && feed.querySelector('[data-bundle-drawer-card]');
          setBundleDrawerWishlistStatus(panel, hasCards ? 'idle' : 'empty');
          afterDrawerCardsAppended();
        })
        .catch(function() {
          if (token !== wishlistTabPopulateToken) return;
          grid.setAttribute('data-wishlist-loaded-key', '');
          setBundleDrawerWishlistStatus(panel, 'empty');
        });
    });
  }

  function getDrawerBadgeSlotItems() {
    if (isBundleDrawerOpen()) {
      return bkMediaBundleCountsToSlots(cfg.products, drawerCounts, getSlotCountFromDrawerAndTier());
    }
    return slotItems;
  }

  function getNextEmptySlotIndexForDrawerBadges() {
    var items = getDrawerBadgeSlotItems();
    var n = items.length > 0 ? items.length : Math.max(selectedTier, 1);
    for (var i = 0; i < n; i++) {
      if (!items[i] || !items[i].variantId) {
        return i;
      }
    }
    return -1;
  }

  function getFilledCountForDrawerBadges() {
    if (isBundleDrawerOpen()) {
      return getTotalDrawerCount();
    }
    return getFilledSlotCount();
  }

  function syncBundleSlotGridVisibilityFromSlotItems() {
    var n = slotItems.length;
    setSlotGridColumns(n);
    var slotEls = root.querySelectorAll(designSlotSelector);
    slotEls.forEach(function(btn, i) {
      if (i < n) {
        btn.removeAttribute('hidden');
      } else {
        btn.setAttribute('hidden', '');
      }
    });
  }

  function getDesignSlotElements() {
    return root.querySelectorAll(designSlotSelector);
  }

  function collectFormProperties(formEl) {
    var props = {};
    if (!formEl || typeof FormData === 'undefined') return props;
    try {
      var fd = new FormData(formEl);
      fd.forEach(function(value, key) {
        var m = key.match(/^properties\[(.+)\]$/);
        if (m && value !== '' && value !== null && String(value).trim() !== '') {
          props[m[1]] = value;
        }
      });
    } catch (e) {}
    return props;
  }

  var slotItems = [];
  var drawerCounts = {};
  var tier1Qty = Number(cfg.tier1Qty);
  if (isNaN(tier1Qty) || tier1Qty < 1) tier1Qty = 2;
  var selectedTier = Number(root.getAttribute('data-initial-tier')) || tier1Qty;
  var chosenTierSlots = selectedTier;
  var maxSlotsUi = cfg.maxSlots || 20;
  var tierMaxQtyCfg = Number(cfg.tierMaxQty);
  if (isNaN(tierMaxQtyCfg) || tierMaxQtyCfg < 1) tierMaxQtyCfg = 0;
  var drawerStripSlotCount = Number(cfg.drawerStripSlotCount);
  if (isNaN(drawerStripSlotCount) || drawerStripSlotCount < 1) {
    drawerStripSlotCount = tierMaxQtyCfg > 0 ? tierMaxQtyCfg + 1 : maxSlotsUi;
  }
  drawerStripSlotCount = Math.min(Math.max(drawerStripSlotCount, 1), maxSlotsUi);

  function syncBundleCheckoutVariantFromTier() {
    if (!cfg.forceCheckoutVariant) return;
    var cid = bkMediaBundleResolveCheckoutVariantIdForTierQty(cfg, selectedTier);
    if (cid == null || isNaN(cid) || cid < 1) return;
    cfg.checkoutVariantId = cid;
    cfg.checkoutVariantGid = 'gid://shopify/ProductVariant/' + cid;
    root.setAttribute('data-checkout-variant-id', String(cid));
    var idInpSync = form.querySelector('input[name="id"]');
    if (idInpSync && Number(idInpSync.value) !== cid) {
      idInpSync.value = String(cid);
      idInpSync.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
  syncBundleCheckoutVariantFromTier();
  syncBundleGalleryForTier();

  function getTierQtyForSlotBadges() {
    var card = root.querySelector('.bk-media-bundle-builder__variant-card.is-selected');
    if (card) {
      var ts = parseInt(card.getAttribute('data-tier-slots'), 10);
      if (!isNaN(ts) && ts >= 1) return ts;
    }
    return selectedTier;
  }

  function getFilledSlotCount() {
    var filled = 0;
    for (var i = 0; i < slotItems.length; i++) {
      if (slotItems[i] && slotItems[i].variantId) filled++;
    }
    return filled;
  }

  function getRequiredSelectionsForCart() {
    var tierRequired = Number(chosenTierSlots);
    if (isNaN(tierRequired) || tierRequired < 1) {
      return Math.max(1, tier1Qty);
    }
    return tierRequired;
  }

  function getNextDesignSlotNumber() {
    var i;
    for (i = 0; i < slotItems.length; i++) {
      if (!slotItems[i] || !slotItems[i].variantId) {
        return i + 1;
      }
    }
    return getFilledSlotCount() + 1;
  }

  function updateSelectionConfirmBlock() {
    var wrap = root.querySelector('[data-bundle-selection-confirm]');
    if (!wrap) return;
    var filled = getFilledSlotCount();
    if (filled === 0) {
      wrap.setAttribute('hidden', '');
      return;
    }
    wrap.removeAttribute('hidden');
    var msgEl = wrap.querySelector('[data-bundle-confirm-message]');
    var setComplete = filled >= chosenTierSlots;
    var msgComplete = (cfg.strings && cfg.strings.confirmSetReady) || 'Toller Look! Dein Set ist jetzt bereit!';
    var msgMore = (cfg.strings && cfg.strings.confirmChooseNext) || 'Wähle dein nächstes Design';
    if (msgEl) msgEl.textContent = setComplete ? msgComplete : msgMore;
  }

  function getAddonCountForBundlePrice() {
    var fromSlots = getFilledSlotCount();
    var fromDrawer = getTotalDrawerCount();
    var n = Math.max(fromSlots, fromDrawer);
    var tierCap = Math.max(1, chosenTierSlots);
    if (n < 1) {
      return tierCap;
    }
    if (n <= tierCap) {
      return tierCap;
    }
    return n;
  }

  function compactAndTrimSlots() {
    var compact = [];
    for (var i = 0; i < slotItems.length; i++) {
      if (slotItems[i] && slotItems[i].variantId) compact.push(slotItems[i]);
    }
    var target = Math.max(selectedTier, compact.length);
    if (target > maxSlotsUi) target = maxSlotsUi;
    slotItems = compact;
    while (slotItems.length < target) slotItems.push(null);
  }

  function updateDrawerConfirmVisibility() {
    if (!confirmBtn) return;
    var total = getTotalDrawerCount();
    var tierGoal = Math.max(1, chosenTierSlots);
    var ready = total >= tierGoal;
    if (!confirmWrap) {
      confirmBtn.disabled = !ready;
      return;
    }
    if (!ready) {
      confirmWrap.setAttribute('aria-hidden', 'true');
      confirmWrap.classList.remove('is-visible');
      confirmBtn.setAttribute('tabindex', '-1');
      confirmBtn.setAttribute('disabled', '');
    } else {
      confirmWrap.setAttribute('aria-hidden', 'false');
      confirmWrap.classList.add('is-visible');
      confirmBtn.removeAttribute('tabindex');
      confirmBtn.removeAttribute('disabled');
    }
  }

  function setSlotGridColumns(n) {
    if (!slotGrid) return;
    slotGrid.style.setProperty('--bb-slot-count', String(n));
  }

  function buildOptionalDesignPlaceholderHtml() {
    var hint = (cfg.strings && cfg.strings.emptySlotHint) || 'Design wählen';
    var fallback = (cfg.strings && cfg.strings.emptySlot) || '+';
    var iconUrl = cfg.emptySlotIconUrl;
    var imgHtml = '';
    if (iconUrl) {
      imgHtml = '<span class="bk-media-bundle-builder__slot-custom-icon" aria-hidden="true"></span>';
    } else {
      imgHtml =
        '<span class="bk-media-bundle-builder__slot-fallback" aria-hidden="true">' +
        bkMediaBundleEscapeHtml(fallback) +
        '</span>';
    }
    return (
      '<span class="bk-media-bundle-builder__slot-optional-placeholder">' +
      imgHtml +
      '<span class="text-xs bk-media-bundle-builder__slot-hint">' +
      bkMediaBundleEscapeHtml(hint) +
      '</span>' +
      '</span>'
    );
  }

  function buildOptionalStyleSlotHtml(bundleQty, titleLabel, slotIndex, totalSlots, tierQty) {
    var badgeHtml = bkMediaBundleSlotBadgeHtml(
      slotIndex,
      totalSlots,
      bundleQty,
      tierQty,
      cfg,
      true,
      getFilledSlotCount(),
      false
    );
    return (
      '<div class="bk-media-bundle-builder__slot-preview-inner bk-media-bundle-builder__slot-preview-inner--optional">' +
      badgeHtml +
      '<div class="bk-media-bundle-builder__slot-image-wrap bk-media-bundle-builder__slot-image-wrap--optional">' +
      buildOptionalDesignPlaceholderHtml() +
      '</div>' +
      '<div class="bk-media-bundle-builder__slot-meta prose">' +
      '<p class="text-xs bk-media-bundle-builder__slot-product-name">' +
      bkMediaBundleEscapeHtml(titleLabel) +
      '</p>' +
      '</div>' +
      '</div>'
    );
  }

  function buildOptionalDesignSlotInnerHtml(bundleQty) {
    var label = (cfg.strings && cfg.strings.optionalDesignLabel) || 'Optionales Design';
    var filledCount = getFilledSlotCount();
    var totalReg = slotItems.length > 0 ? slotItems.length : Math.max(selectedTier, 1);
    var optionalSlotIndex = filledCount;
    var totalForBadge = Math.max(totalReg + 1, selectedTier + 1, filledCount + 1);
    var badgeHtml = bkMediaBundleSlotBadgeHtml(
      optionalSlotIndex,
      totalForBadge,
      bundleQty,
      getTierQtyForSlotBadges(),
      cfg,
      true,
      filledCount,
      true
    );
    return (
      '<div class="bk-media-bundle-builder__slot-preview-inner bk-media-bundle-builder__slot-preview-inner--optional">' +
      badgeHtml +
      '<div class="bk-media-bundle-builder__slot-image-wrap bk-media-bundle-builder__slot-image-wrap--optional">' +
      buildOptionalDesignPlaceholderHtml() +
      '</div>' +
      '<div class="bk-media-bundle-builder__slot-meta prose">' +
      '<p class="text-xs bk-media-bundle-builder__slot-product-name">' +
      bkMediaBundleEscapeHtml(label) +
      '</p>' +
      '</div>' +
      '</div>'
    );
  }

  function updateOptionalDesignSlot() {
    var el = root.querySelector('[data-optional-design-slot]');
    if (!el) return;
    var filled = getFilledSlotCount();
    var prev = el.querySelector('[data-slot-preview]');
    var empty = el.querySelector('[data-slot-empty]');
    var tierNeed = Math.max(1, selectedTier);
    var showOptional = filled >= tierNeed;
    if (showOptional) {
      el.removeAttribute('hidden');
      var bundleQty = getAddonCountForBundlePrice();
      if (prev) {
        prev.innerHTML = buildOptionalDesignSlotInnerHtml(bundleQty);
        prev.removeAttribute('hidden');
      }
      if (empty) empty.setAttribute('hidden', '');
      el.classList.add('is-filled');
    } else {
      el.setAttribute('hidden', '');
      if (prev) {
        prev.innerHTML = '';
        prev.setAttribute('hidden', '');
      }
      if (empty) empty.removeAttribute('hidden');
      el.classList.remove('is-filled');
    }
  }

  function buildPremiumGiftSlotHtml() {
    var gift = cfg.bundleFreeGiftProduct || {};
    var label =
      cfg.gratisBadgeText != null && String(cfg.gratisBadgeText).trim() !== ''
        ? String(cfg.gratisBadgeText).trim()
        : 'GRATIS';
    var badgeHtml =
      '<on-sale-badge class="badge badge--on-sale bk-media-bundle-builder__slot-gratis-badge">' +
      bkMediaBundleEscapeHtml(label) +
      '</on-sale-badge>';
    var imgHtml = '';
    if (gift.image) {
      imgHtml =
        '<img src="' +
        bkMediaBundleEscapeHtml(String(gift.image)) +
        '" alt="" class="' +
        bkMediaBundleSlotProductImageClassAttr(cfg) +
        '" loading="lazy">';
    }
    var title = gift.title != null ? String(gift.title) : '';
    return (
      '<div class="bk-media-bundle-builder__slot-preview-inner">' +
      badgeHtml +
      '<div class="bk-media-bundle-builder__slot-image-wrap">' +
      imgHtml +
      '</div>' +
      '<div class="bk-media-bundle-builder__slot-meta prose">' +
      '<p class="text-xs bk-media-bundle-builder__slot-product-name">' +
      bkMediaBundleEscapeHtml(title) +
      '</p>' +
      '</div>' +
      '</div>'
    );
  }

  function updatePremiumGiftSlot() {
    var el = root.querySelector('[data-premium-gift-slot]');
    if (!el) return;
    var bundleQty = getAddonCountForBundlePrice();
    var showGift = bkMediaBundlePremiumGiftUnlocked(bundleQty, cfg, root);
    var prev = el.querySelector('[data-slot-preview]');
    if (showGift) {
      el.removeAttribute('hidden');
      if (prev) {
        prev.innerHTML = buildPremiumGiftSlotHtml();
        prev.removeAttribute('hidden');
      }
      el.classList.add('is-filled');
    } else {
      el.setAttribute('hidden', '');
      if (prev) {
        prev.innerHTML = '';
        prev.setAttribute('hidden', '');
      }
      el.classList.remove('is-filled');
    }
  }

  function updateSlotVisibility() {
    compactAndTrimSlots();
    var n = slotItems.length;
    setSlotGridColumns(n);
    var slotEls = getDesignSlotElements();
    slotEls.forEach(function(btn, i) {
      if (i < n) {
        btn.removeAttribute('hidden');
      } else {
        btn.setAttribute('hidden', '');
      }
    });
    renderSlots();
    updateOptionalDesignSlot();
    updatePremiumGiftSlot();
    drawerCounts = bkMediaBundleSlotsToCounts(slotItems);
    syncAllDrawerCards();
    bkMediaBundleSyncBundlePrice(root, cfg, getAddonCountForBundlePrice());
    updateSelectionConfirmBlock();
    updateFooterProgressLabel();
    updateDrawerConfirmVisibility();
  }

  function updateFooterProgressLabel() {
    if (!remainingEl) return;
    var t = getTotalDrawerCount();
    var den = chosenTierSlots;
    var num = Math.min(t, den);
    remainingEl.textContent = num + ' / ' + den;
    var success = t >= den;
    remainingEl.classList.toggle('bk-media-bundle-builder__remaining-label--success', success);
    remainingEl.classList.toggle('bk-media-bundle-builder__remaining-label--progress', !success);
  }

  function updateBundleBuyButtonState() {
    var buttons = [];
    var primary = root.querySelector('[data-bundle-cart] [data-bundle-add-to-cart]');
    if (primary) {
      buttons.push(primary);
    }
    var stickyHost = document.querySelector('product-quick-add[form="' + cfg.formId + '"]');
    if (stickyHost) {
      stickyHost.querySelectorAll('[data-bundle-add-to-cart]').forEach(function(b) {
        buttons.push(b);
      });
    }
    if (buttons.length === 0) return;

    var filled = getFilledSlotCount();
    var required = getRequiredSelectionsForCart();
    var complete = filled >= required;
    var defaultLabel = (cfg.strings && cfg.strings.atcLabelDefault) || '';
    var chooseTpl =
      (cfg.strings && cfg.strings.atcLabelChooseDesign) || 'Wähle dein Design __N__';
    var incompleteLabel = chooseTpl.split('__N__').join(String(getNextDesignSlotNumber()));

    buttons.forEach(function(btn) {
      if (btn.disabled) {
        btn.classList.remove('bk-media-bundle-builder__atc--incomplete');
        return;
      }
      btn.classList.toggle('bk-media-bundle-builder__atc--incomplete', !complete);
      if (!complete) {
        bkMediaBundleApplyAtcButtonContent(btn, incompleteLabel, false);
      } else {
        bkMediaBundleApplyAtcButtonContent(btn, defaultLabel, true);
      }
    });
  }

  function buildSlotPreviewHtml(data, priceQty, slotIndex, totalSlots, tierQty) {
    var fullUnit = Math.round(Number(cfg.addonUnitPrice) || 0);
    var badgeHtml = bkMediaBundleSlotBadgeHtml(
      slotIndex,
      totalSlots,
      priceQty,
      tierQty,
      cfg,
      false,
      getFilledSlotCount(),
      false
    );
    var slotHasGratisBadge = badgeHtml.indexOf('bk-media-bundle-builder__slot-gratis-badge') !== -1;
    var showSlotPrice =
      bkMediaBundleSlotShouldShowSlotPrice(
        slotIndex,
        totalSlots,
        priceQty,
        tierQty,
        cfg,
        getFilledSlotCount(),
        false,
        root
      ) && !slotHasGratisBadge;
    var listPct = bkMediaBundleSlotListDiscountPct(
      slotIndex,
      totalSlots,
      priceQty,
      tierQty,
      cfg,
      false,
      getFilledSlotCount(),
      false
    );
    var saleUnit = fullUnit;
    if (listPct != null && listPct > 0 && fullUnit > 0) {
      saleUnit = bkMediaBundleUnitPriceAfterBadgeDiscountPct(fullUnit, listPct);
    }
    var showCompare = showSlotPrice && fullUnit > 0 && listPct != null && listPct > 0 && saleUnit < fullUnit;
    var fmt = bkMediaBundleFormatMoney;
    var saleText = fmt(saleUnit);
    var compareText = fmt(fullUnit);
    var imgHtml = '';
    if (data.image) {
      imgHtml =
        '<img src="' +
        bkMediaBundleEscapeHtml(String(data.image)) +
        '" alt="" class="' +
        bkMediaBundleSlotProductImageClassAttr(cfg) +
        '" loading="lazy">';
    } else if (bundlePlaceholderHtml) {
      imgHtml = bundlePlaceholderHtml;
    }
    var nameHtml = bkMediaBundleEscapeHtml(data.productTitle || data.title || '');
    var priceBlock = '';
    if (showSlotPrice) {
      if (showCompare) {
        priceBlock =
          '<price-list class="price-list bk-media-bundle-builder__slot-price-list">' +
          '<sale-price class="text-sm text-on-sale">' +
          saleText +
          '</sale-price>' +
          '<compare-at-price class="text-sm text-subdued line-through">' +
          compareText +
          '</compare-at-price>' +
          '</price-list>';
      } else {
        priceBlock =
          '<price-list class="price-list bk-media-bundle-builder__slot-price-list">' +
          '<sale-price class="text-sm">' +
          saleText +
          '</sale-price>' +
          '</price-list>';
      }
    }
    return (
      '<div class="bk-media-bundle-builder__slot-preview-inner">' +
      badgeHtml +
      '<div class="bk-media-bundle-builder__slot-image-wrap">' +
      imgHtml +
      '</div>' +
      '<div class="bk-media-bundle-builder__slot-meta prose">' +
      '<p class="text-xs bk-media-bundle-builder__slot-product-name">' +
      nameHtml +
      '</p>' +
      priceBlock +
      '</div>' +
      '</div>'
    );
  }

  function renderSlots() {
    var slotEls = getDesignSlotElements();
    var bundleQty = getAddonCountForBundlePrice();
    var totalReg = slotItems.length;
    var emptyTitle = (cfg.strings && cfg.strings.emptySlotHint) || 'Design wählen';
    slotEls.forEach(function(btn, i) {
      if (btn.hasAttribute('hidden')) return;
      var empty = btn.querySelector('[data-slot-empty]');
      var prev = btn.querySelector('[data-slot-preview]');
      var data = slotItems[i];
      var clearBtn = btn.querySelector('[data-slot-clear]');
      if (data && data.variantId) {
        if (empty) empty.setAttribute('hidden', '');
        if (prev) {
          prev.innerHTML = buildSlotPreviewHtml(data, i + 1, i, totalReg, getTierQtyForSlotBadges());
          prev.removeAttribute('hidden');
        }
        btn.classList.add('is-filled');
        if (clearBtn) clearBtn.removeAttribute('hidden');
      } else {
        if (empty) empty.setAttribute('hidden', '');
        if (prev) {
          prev.innerHTML = buildOptionalStyleSlotHtml(bundleQty, emptyTitle, i, totalReg, getTierQtyForSlotBadges());
          prev.removeAttribute('hidden');
        }
        btn.classList.add('is-filled');
        if (clearBtn) clearBtn.setAttribute('hidden', '');
      }
    });
    updateBundleBuyButtonState();
  }

  function updateTierPromoBanner() {
    var wrap = root.querySelector('[data-tier-promo-banner]');
    if (!wrap || !cfg.tierPromoIconUrl) return;
    var texts = cfg.tierPromoTexts || {};
    var raw = texts[String(selectedTier)];
    var msg = raw != null && raw !== '' ? String(raw).trim() : '';
    var textEl = wrap.querySelector('[data-tier-promo-message]');
    if (textEl) {
      textEl.textContent = msg;
      textEl.hidden = !msg;
    }
  }

  function syncBundleGalleryForTier() {
    bkMediaBundleSyncGalleryForTier(cfg, cfg.formId, form, selectedTier);
  }

  function updateTierCards(activeSlots) {
    variantCards.forEach(function(card) {
      var ts = Number(card.getAttribute('data-tier-slots'));
      var on = ts === Number(activeSlots);
      card.classList.toggle('is-selected', on);
      card.setAttribute('aria-checked', on ? 'true' : 'false');
    });
    updateTierPromoBanner();
    syncBundleCheckoutVariantFromTier();
    syncBundleGalleryForTier();
  }

  function getCartVariantIdFromCard(card) {
    var sel = card.querySelector('[data-bundle-variant-select]');
    if (sel) return String(sel.value);
    return String(card.getAttribute('data-default-variant-id') || '');
  }

  function getTotalDrawerCount() {
    return Object.keys(drawerCounts).reduce(function(s, k) {
      return s + (drawerCounts[k] || 0);
    }, 0);
  }

  function getSlotCountFromDrawerAndTier() {
    var total = getTotalDrawerCount();
    return Math.min(maxSlotsUi, Math.max(selectedTier, total));
  }

  function canSwitchToTierSlots(targetSlots) {
    var ts = Math.floor(Number(targetSlots));
    if (!isFinite(ts) || ts < 1) return false;
    var currentTier = Math.floor(Number(chosenTierSlots));
    if (!isFinite(currentTier) || currentTier < 1) currentTier = ts;
    var filled = getFilledSlotCount();
    var drawerTotal = getTotalDrawerCount();
    if (ts < currentTier) {
      var currentMin = currentTier;
      if (filled >= currentMin || drawerTotal >= currentMin) return false;
    } else {
      if (filled > ts || drawerTotal > ts) return false;
    }
    return true;
  }

  function getBundleOrderedTierSlotGoals() {
    var raw = [Number(cfg.tier1Qty), Number(cfg.tier2Qty), Number(cfg.tier3Qty)];
    var out = [];
    for (var ri = 0; ri < raw.length; ri++) {
      var n = raw[ri];
      if (!isNaN(n) && n >= 1) {
        out.push(n);
      }
    }
    out.sort(function(a, b) {
      return a - b;
    });
    var u = [];
    for (var uj = 0; uj < out.length; uj++) {
      if (uj === 0 || out[uj] !== out[uj - 1]) u.push(out[uj]);
    }
    return u;
  }

  function maybeAutoAdvanceBundleTier() {
    if (!isBundleDrawerOpen()) return;
    var total = getTotalDrawerCount();
    var goals = getBundleOrderedTierSlotGoals();
    if (!goals.length) return;
    while (true) {
      var nextSlots = null;
      for (var g = 0; g < goals.length; g++) {
        if (goals[g] > chosenTierSlots) {
          nextSlots = goals[g];
          break;
        }
      }
      if (nextSlots == null) break;
      if (total < nextSlots) break;
      selectedTier = nextSlots;
      chosenTierSlots = nextSlots;
      root.setAttribute('data-initial-tier', String(nextSlots));
      updateTierCards(nextSlots);
    }
  }

  function syncCard(card) {
    var vid = getCartVariantIdFromCard(card);
    var n = drawerCounts[vid] || 0;
    var input = card.querySelector('[data-qty-input]');
    var bar = card.querySelector('[data-qty-bar]');
    if (input) input.value = String(n);
    if (n > 0) {
      card.classList.add('is-selected');
      if (bar) bar.removeAttribute('hidden');
    } else {
      card.classList.remove('is-selected');
      if (bar) bar.setAttribute('hidden', '');
    }
  }

  function syncAllDrawerCards() {
    queryBundleDrawerCards().forEach(syncCard);
    updateDrawerFooter();
  }

  function bundleDrawerAddOneFromVorschau(card) {
    var vid = getCartVariantIdFromCard(card);
    var total = getTotalDrawerCount();
    if (total >= maxSlotsUi) return;
    drawerCounts[vid] = (drawerCounts[vid] || 0) + 1;
    syncCard(card);
    updateDrawerFooter();
  }

  function bkMediaEscHtml(s) {
    if (s == null) return '';
    var d = document.createElement('div');
    d.textContent = String(s);
    return d.innerHTML;
  }

  function syncBundleVorschauReserve(wrap, pswp) {
    if (!wrap || !wrap.isConnected) return;
    if (pswp && typeof pswp.updateSize === 'function') {
      try {
        pswp.updateSize();
      } catch (e) {}
    }
  }

  function removeBundleVorschauPanel() {
    document.querySelectorAll('[data-bk-bundle-vorschau-extra]').forEach(function(n) {
      if (n._bkVorschauOpenAnim && n._bkPswpCore && typeof n._bkPswpCore.off === 'function') {
        try {
          n._bkPswpCore.off('openingAnimationStart', n._bkVorschauOpenAnim);
        } catch (e) {}
      }
      n._bkVorschauOpenAnim = null;
      if (n._bkVorschauCloseAnim && n._bkPswpCore && typeof n._bkPswpCore.off === 'function') {
        try {
          n._bkPswpCore.off('closingAnimationStart', n._bkVorschauCloseAnim);
        } catch (e) {}
      }
      n._bkVorschauCloseAnim = null;
      n._bkPswpCore = null;
      if (n._bkVorschauRevealFallbackTimer) {
        try {
          clearTimeout(n._bkVorschauRevealFallbackTimer);
        } catch (e) {}
        n._bkVorschauRevealFallbackTimer = null;
      }
      var pswpHost = n.parentElement;
      var br = n.querySelector('.pswp__bottom-bar');
      if (br && br._bkPswpDefaultParent) {
        try {
          br._bkPswpDefaultParent.appendChild(br);
        } catch (e) {}
        delete br._bkPswpDefaultParent;
        br.removeAttribute('data-bk-vorschau-relocated');
      }
      if (pswpHost) {
        pswpHost.removeAttribute('data-bk-vorschau-bar-in-panel');
      }
      if (n._bkVorschauRo) {
        try {
          n._bkVorschauRo.disconnect();
        } catch (e) {}
        n._bkVorschauRo = null;
      }
      n.remove();
    });
  }

  function bundleRelocatePswpBottomBarToVorschau(lb) {
    if (!lb || !lb.pswp || !lb.pswp.element) return;
    var root = lb.pswp.element;
    if (!root.classList.contains('pswp--open')) return;
    if (!root.querySelector('[data-bk-bundle-vorschau-extra]')) return;
    var bar = root.querySelector('.pswp__bottom-bar');
    if (!bar) return;
    var slot = root.querySelector('[data-bk-vorschau-pswp-bar-slot]');
    if (!slot) return;
    if (slot.contains(bar)) {
      if (!root.getAttribute('data-bk-vorschau-bar-in-panel')) {
        root.setAttribute('data-bk-vorschau-bar-in-panel', '');
      }
      return;
    }
    if (!bar._bkPswpDefaultParent) {
      bar._bkPswpDefaultParent = bar.parentNode;
    }
    slot.appendChild(bar);
    bar.setAttribute('data-bk-vorschau-relocated', '');
    root.setAttribute('data-bk-vorschau-bar-in-panel', '');
  }

  function bundleRestorePswpBottomBarFromVorschau(lb) {
    if (!lb || !lb.pswp || !lb.pswp.element) return;
    var root = lb.pswp.element;
    var bar = root.querySelector('.pswp__bottom-bar');
    if (bar && bar._bkPswpDefaultParent) {
      try {
        bar._bkPswpDefaultParent.appendChild(bar);
      } catch (e) {}
      delete bar._bkPswpDefaultParent;
      bar.removeAttribute('data-bk-vorschau-relocated');
    }
    root.removeAttribute('data-bk-vorschau-bar-in-panel');
  }

  function bkMediaBundleSchedulePswpBarBelowImage(lb) {
    if (!lb) return;
    var run = function() {
      if (lb.pswp) {
        bundleRelocatePswpBottomBarToVorschau(lb);
      }
    };
    requestAnimationFrame(function() {
      requestAnimationFrame(function() {
        run();
        setTimeout(run, 60);
        setTimeout(run, 200);
      });
    });
  }

  function ensureBundleDrawerVorschauPaddingFilter(gallery) {
    var lb = gallery.photoswipe;
    if (!lb || !lb.options || lb._bkBundleVorschauPaddingFilter) return;
    lb._bkBundleVorschauPaddingFilter = true;
    var origFn = lb.options.paddingFn;
    var origPad = lb.options.padding;
    lb.options.paddingFn = function(viewportSize, itemData, slideIndex) {
      var base = { top: 0, right: 0, bottom: 0, left: 0 };
      if (typeof origFn === 'function') {
        var o = origFn(viewportSize, itemData, slideIndex);
        if (o && typeof o === 'object') {
          base = Object.assign(base, o);
        }
      } else if (origPad && typeof origPad === 'object') {
        base = Object.assign(base, origPad);
      }
      if (!gallery.classList || !gallery.classList.contains('bk-media-bundle-drawer-card__product-gallery')) {
        return base;
      }
      var pswpRoot = document.querySelector('.pswp.pswp--open') || document.querySelector('.pswp');
      var panel = pswpRoot ? pswpRoot.querySelector('[data-bk-bundle-vorschau-extra]') : null;
      var bottomPad = 0;
      if (panel && panel.isConnected) {
        try {
          void panel.offsetHeight;
        } catch (eM) {}
        var rh = panel.offsetHeight;
        if (rh && !isNaN(rh)) {
          bottomPad = Math.ceil(rh);
        }
      }
      var out = Object.assign({}, base);
      out.bottom = (Number(out.bottom) || 0) + bottomPad;
      return out;
    };
  }

  function vorschauSliderPct(v) {
    var n = parseInt(v, 10);
    if (isNaN(n)) n = 5;
    n = Math.max(1, Math.min(10, n));
    return ((n - 1) / 9) * 100;
  }

  function vorschauSliderRow(left, right, pct) {
    return (
      '<div class="bk-media-bundle-vorschau-slider">' +
      '<div class="bk-media-bundle-vorschau-slider__track" style="--bb-fill-pct:' +
      pct.toFixed(4) +
      '%">' +
      '<span class="bk-media-bundle-vorschau-slider__fill"></span>' +
      '<span class="bk-media-bundle-vorschau-slider__thumb"></span>' +
      '</div>' +
      '<div class="bk-media-bundle-vorschau-slider__labels h-stack justify-between gap-2">' +
      '<span class="text-sm bold">' +
      bkMediaEscHtml(left) +
      '</span>' +
      '<span class="text-sm bold">' +
      bkMediaEscHtml(right) +
      '</span>' +
      '</div></div>'
    );
  }

  function injectBundleVorschauPanel(lb, card) {
    removeBundleVorschauPanel();
    var pswp = lb.pswp;
    if (!pswp || !pswp.element) return;
    var title = card.getAttribute('data-product-title') || '';
    var sub = card.getAttribute('data-bb-produkt-untertitel') || '';
    var tp = card.getAttribute('data-bb-mf-tp');
    var ep = card.getAttribute('data-bb-mf-ep');
    var kl = card.getAttribute('data-bb-mf-kl');
    var featHead = card.getAttribute('data-bb-vorschau-features-heading') || 'Produktmerkmale';
    var btnLabel = card.getAttribute('data-bb-vorschau-select-label') || 'Auswählen';
    var bg = card.getAttribute('data-bb-vorschau-bg') || '';
    var act = card.getAttribute('data-bb-vorschau-act') || '';
    var inact = card.getAttribute('data-bb-vorschau-inact') || '';
    var wrap = document.createElement('div');
    wrap.setAttribute('data-bk-bundle-vorschau-extra', '');
    wrap.className = 'bk-media-bundle-vorschau-extra';
    if (bg) wrap.style.setProperty('--bb-vorschau-panel-bg', bg);
    if (act) wrap.style.setProperty('--bb-vorschau-slider-active', act);
    if (inact) wrap.style.setProperty('--bb-vorschau-slider-inactive', inact);
    var excerptHtml = sub
      ? '<p class="product-card__excerpt p text-sm text-subdued">' + bkMediaEscHtml(sub) + '</p>'
      : '';
    wrap.innerHTML =
      '<div class="bk-media-bundle-vorschau-head">' +
      '<div class="bk-media-bundle-vorschau-head__text prose text-start">' +
      '<h3 class="h3 bk-media-bundle-vorschau-extra__title">' +
      bkMediaEscHtml(title) +
      '</h3>' +
      excerptHtml +
      '</div>' +
      '<div class="bk-media-bundle-vorschau-head__pswp" data-bk-vorschau-pswp-bar-slot></div>' +
      '</div>' +
      '<div class="bk-media-bundle-vorschau-body prose text-start">' +
      '<button type="button" class="button button--xl w-full bk-media-bundle-vorschau-extra__btn" data-bb-vorschau-select>' +
      bkMediaEscHtml(btnLabel) +
      '</button>' +
      '<div class="bk-media-bundle-vorschau-features">' +
      '<h3 class="h3 bk-media-bundle-vorschau-features__heading">' +
      bkMediaEscHtml(featHead) +
      '</h3>' +
      vorschauSliderRow('klassisch', 'Trendy', vorschauSliderPct(tp)) +
      vorschauSliderRow('Einfarbig', 'Muster', vorschauSliderPct(ep)) +
      vorschauSliderRow('Transparent', 'Deckend', vorschauSliderPct(kl)) +
      '</div></div>';
    pswp.element.appendChild(wrap);
    wrap._bkPswpCore = pswp;
    try {
      void wrap.offsetHeight;
    } catch (eR) {}
    function runVorschauLayoutSync() {
      syncBundleVorschauReserve(wrap, pswp);
      bundleRelocatePswpBottomBarToVorschau(lb);
    }
    runVorschauLayoutSync();
    wrap._bkVorschauRevealed = false;
    function revealVorschauPanelOnce() {
      if (wrap._bkVorschauRevealed) return;
      wrap._bkVorschauRevealed = true;
      wrap.classList.add('bk-media-bundle-vorschau-extra--visible');
      runVorschauLayoutSync();
    }
    function onVorschauOpeningAnimStart() {
      if (pswp && typeof pswp.off === 'function') {
        try {
          pswp.off('openingAnimationStart', onVorschauOpeningAnimStart);
        } catch (e) {}
      }
      wrap._bkVorschauOpenAnim = null;
      if (wrap._bkVorschauRevealFallbackTimer) {
        try {
          clearTimeout(wrap._bkVorschauRevealFallbackTimer);
        } catch (e) {}
        wrap._bkVorschauRevealFallbackTimer = null;
      }
      revealVorschauPanelOnce();
    }
    wrap._bkVorschauOpenAnim = onVorschauOpeningAnimStart;
    if (pswp && typeof pswp.on === 'function') {
      try {
        pswp.on('openingAnimationStart', onVorschauOpeningAnimStart);
      } catch (e) {}
    }
    function onVorschauClosingAnimStart() {
      wrap.classList.remove('bk-media-bundle-vorschau-extra--visible');
    }
    wrap._bkVorschauCloseAnim = onVorschauClosingAnimStart;
    if (pswp && typeof pswp.on === 'function') {
      try {
        pswp.on('closingAnimationStart', onVorschauClosingAnimStart);
      } catch (e) {}
    }
    wrap._bkVorschauRevealFallbackTimer = window.setTimeout(function() {
      wrap._bkVorschauRevealFallbackTimer = null;
      revealVorschauPanelOnce();
    }, 660);
    if (typeof ResizeObserver !== 'undefined') {
      wrap._bkVorschauRo = new ResizeObserver(runVorschauLayoutSync);
      wrap._bkVorschauRo.observe(wrap);
    }
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(runVorschauLayoutSync);
    }
    var selBtn = wrap.querySelector('[data-bb-vorschau-select]');
    if (selBtn) {
      selBtn.addEventListener(
        'click',
        function(ev) {
          ev.preventDefault();
          ev.stopPropagation();
          if (lb.pswp) lb.pswp.close();
          bundleDrawerAddOneFromVorschau(card);
        },
        false
      );
    }
  }

  function ensureBundleDrawerVorschauHooks(gallery) {
    ensureBundleDrawerVorschauPaddingFilter(gallery);
    if (gallery.getAttribute('data-bk-vorschau-pswp-hooks') === 'true') return;
    gallery.setAttribute('data-bk-vorschau-pswp-hooks', 'true');
    var lb = gallery.photoswipe;
    lb.on('firstUpdate', function() {
      var c = gallery._bkBundleVorschauCard;
      if (!c || c.getAttribute('data-bb-vorschau-panel') !== 'true') return;
      injectBundleVorschauPanel(lb, c);
      bkMediaBundleSchedulePswpBarBelowImage(lb);
      var core = lb.pswp;
      if (!core || gallery._bkPswpBarCore === core) {
        return;
      }
      gallery._bkPswpBarCore = core;
      var zPanRaf = 0;
      core.on('change', function() {
        bkMediaBundleSchedulePswpBarBelowImage(lb);
      });
      core.on('resize', function() {
        bkMediaBundleSchedulePswpBarBelowImage(lb);
      });
      core.on('zoomPanUpdate', function() {
        if (zPanRaf) return;
        zPanRaf = requestAnimationFrame(function() {
          zPanRaf = 0;
          bkMediaBundleSchedulePswpBarBelowImage(lb);
        });
      });
    });
    lb.on('destroy', function() {
      gallery._bkPswpBarCore = null;
      bundleRestorePswpBottomBarFromVorschau(lb);
      removeBundleVorschauPanel();
      gallery._bkBundleVorschauCard = null;
    });
  }

  var drawerBadgePaintRaf = 0;
  var drawerBadgePaintSlot = null;
  var lastDrawerBadgePaint = { html: null, cards: -1 };

  function scheduleDrawerBadgePaint(force) {
    drawerBadgePaintSlot = getNextEmptySlotIndexForDrawerBadges();
    if (force) lastDrawerBadgePaint = { html: null, cards: -1 };
    if (drawerBadgePaintRaf) return;
    drawerBadgePaintRaf = requestAnimationFrame(function() {
      drawerBadgePaintRaf = 0;
      updateDrawerProductSlotBadges(drawerBadgePaintSlot);
    });
  }

  function updateDrawerFooter() {
    maybeAutoAdvanceBundleTier();
    updateFooterProgressLabel();
    updateDrawerConfirmVisibility();
    updateStrip();
    scheduleDrawerBadgePaint();
  }

  function updateStrip() {
    if (!stripEl) return;
    var total = getTotalDrawerCount();
    var slotCount = Math.min(Math.max(drawerStripSlotCount, total, selectedTier), maxSlotsUi);
    stripEl.innerHTML = '';
    var order = bkMediaBundleCountsToSlots(cfg.products, drawerCounts, slotCount);
    for (var i = 0; i < slotCount; i++) {
      var slot = document.createElement('span');
      var item = order[i];
      if (item && item.variantId) {
        slot.className = 'bk-media-bundle-drawer__strip-slot bk-media-bundle-drawer__strip-slot--filled';
        if (item.image) {
          slot.innerHTML = '<img src="' + item.image + '" alt="" width="48" height="48" loading="lazy">';
        } else if (bundlePlaceholderHtml) {
          slot.innerHTML = bundlePlaceholderHtml;
        }
      } else {
        slot.className = 'bk-media-bundle-drawer__strip-slot bk-media-bundle-drawer__strip-slot--empty';
        if (cfg.emptySlotIconUrl) {
          slot.innerHTML =
            '<img src="' +
            String(cfg.emptySlotIconUrl).replace(/"/g, '&quot;') +
            '" alt="" class="bk-media-bundle-drawer__strip-custom-icon" width="100" height="100" loading="lazy">';
        } else {
          var fb = document.createElement('span');
          fb.className = 'bk-media-bundle-drawer__strip-empty-fallback';
          fb.setAttribute('aria-hidden', 'true');
          fb.textContent =
            cfg.strings && cfg.strings.emptySlot != null && cfg.strings.emptySlot !== ''
              ? String(cfg.strings.emptySlot)
              : '+';
          slot.appendChild(fb);
        }
      }
      stripEl.appendChild(slot);
    }
  }

  function getActiveBundleProductCardsRoot() {
    var scope = getBundleDrawerScope();
    var productsRoot = scope.querySelector('[data-drawer-products]');
    if (!productsRoot) return root;
    var tabsWrap = scope.querySelector('[data-bundle-collection-tabs]');
    var activeId = null;
    if (tabsWrap) {
      var activeTab = tabsWrap.querySelector('.bk-media-bundle-drawer__filter--collection-tab.is-active');
      if (activeTab) {
        activeId = String(activeTab.getAttribute('data-bundle-collection-id') || '').trim();
      }
    }
    if (activeId) {
      var grids = productsRoot.querySelectorAll('[data-bundle-collection-grid]');
      for (var gi = 0; gi < grids.length; gi++) {
        var wrap = grids[gi];
        var wid = String(wrap.getAttribute('data-collection-id') || '').trim();
        if (wid === activeId) {
          var innerGrid = wrap.querySelector('.bk-media-bundle-drawer__grid');
          return innerGrid || wrap;
        }
      }
    }
    var activeCol = productsRoot.querySelector('[data-bundle-collection-grid]:not([hidden])');
    if (activeCol) {
      var innerGrid2 = activeCol.querySelector('.bk-media-bundle-drawer__grid');
      return innerGrid2 || activeCol;
    }
    var loneGrid = productsRoot.querySelector('.bk-media-bundle-drawer__grid');
    return loneGrid || productsRoot;
  }

  function syncBundleCollectionPanelsVisibility() {
    var scope = getBundleDrawerScope();
    var tabsWrap = scope.querySelector('[data-bundle-collection-tabs]');
    if (!tabsWrap) return;
    var activeBtn = tabsWrap.querySelector('.bk-media-bundle-drawer__filter--collection-tab.is-active');
    if (!activeBtn) {
      var allTabs = tabsWrap.querySelectorAll('.bk-media-bundle-drawer__filter--collection-tab');
      if (allTabs.length) {
        allTabs.forEach(function(b, i) {
          var on = i === 0;
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        activeBtn = allTabs[0];
      }
    }
    var id = activeBtn
      ? String(activeBtn.getAttribute('data-bundle-collection-id') || '').trim()
      : null;
    if (!id) return;
    scope.querySelectorAll('[data-bundle-collection-panel]').forEach(function(panel) {
      var pid = String(panel.getAttribute('data-collection-id') || '').trim();
      panel.hidden = pid !== id;
    });
    scope.querySelectorAll('[data-bundle-collection-grid]').forEach(function(g) {
      var gid = String(g.getAttribute('data-collection-id') || '').trim();
      g.hidden = gid !== id;
    });
  }

  function bundleDrawerCardHasHideFabrikatorTag(card) {
    var needle =
      cfg.hideInFabrikatorTagHandle && typeof cfg.hideInFabrikatorTagHandle === 'string'
        ? cfg.hideInFabrikatorTagHandle
        : 'hide-in-fabrikator';
    var dt = card && card.getAttribute('data-tags');
    if (!dt || typeof dt !== 'string') return false;
    return dt.split(',').some(function(h) {
      return String(h).trim() === needle;
    });
  }

  function applyFiltersAndSearch() {
    var cardsRoot = getActiveBundleProductCardsRoot();
    if (!cardsRoot) return;
    var q = (searchInput && searchInput.value.trim().toLowerCase()) || '';
    var cardList = cardsRoot.querySelectorAll('[data-bundle-drawer-card]');
    for (var ci = 0; ci < cardList.length; ci++) {
      var card = cardList[ci];
      var title = (card.getAttribute('data-product-title') || '').toLowerCase();
      var titleOk = !q || title.indexOf(q) !== -1;
      card.style.display = titleOk ? '' : 'none';
    }
  }

  function drawerCardTapShouldIgnore(target) {
    return !!target.closest(
      'button, a[href], select, input, textarea, [data-bundle-drawer-zoom], page-dots, .bk-media-bundle-drawer-card__badges, .bk-media-bundle-drawer-card__badge'
    );
  }

  function bindDrawerCardDelegation() {
    var drawer = getBundleDrawer();
    if (!drawer || drawer.getAttribute('data-bb-card-delegation') === 'true') return;
    drawer.setAttribute('data-bb-card-delegation', 'true');
    drawer.addEventListener('touchstart', function() {}, { passive: true });

    drawer.addEventListener('click', function(e) {
      if (!drawer.open) return;
      var card = e.target.closest('[data-bundle-drawer-card]');
      if (!card || !drawer.contains(card)) return;

      var plus = e.target.closest('[data-qty-plus]');
      if (plus && card.contains(plus)) {
        e.preventDefault();
        e.stopPropagation();
        var plusVid = getCartVariantIdFromCard(card);
        var plusTotal = getTotalDrawerCount();
        if (plusTotal >= maxSlotsUi) return;
        drawerCounts[plusVid] = (drawerCounts[plusVid] || 0) + 1;
        syncCard(card);
        updateDrawerFooter();
        return;
      }

      var minus = e.target.closest('[data-qty-minus]');
      if (minus && card.contains(minus)) {
        e.preventDefault();
        e.stopPropagation();
        var minusVid = getCartVariantIdFromCard(card);
        if (!drawerCounts[minusVid]) return;
        drawerCounts[minusVid]--;
        if (drawerCounts[minusVid] <= 0) delete drawerCounts[minusVid];
        syncCard(card);
        updateDrawerFooter();
        return;
      }

      var visual = e.target.closest('.bk-media-bundle-drawer-card__visual');
      if (!visual || !card.contains(visual)) return;
      if (drawerCardTapShouldIgnore(e.target)) return;
      var tapVid = getCartVariantIdFromCard(card);
      var tapTotal = getTotalDrawerCount();
      if (tapTotal >= maxSlotsUi) return;
      drawerCounts[tapVid] = (drawerCounts[tapVid] || 0) + 1;
      syncCard(card);
      updateDrawerFooter();
    });

    drawer.addEventListener('change', function(e) {
      if (!drawer.open) return;
      var card = e.target.closest('[data-bundle-drawer-card]');
      if (!card || !drawer.contains(card)) return;

      var input = e.target.closest('[data-qty-input]');
      if (input && card.contains(input)) {
        var inputVid = getCartVariantIdFromCard(card);
        var want = parseInt(input.value, 10);
        if (isNaN(want) || want < 0) want = 0;
        var other = getTotalDrawerCount() - (drawerCounts[inputVid] || 0);
        var maxForThis = Math.max(0, maxSlotsUi - other);
        want = Math.min(want, maxForThis);
        if (want <= 0) delete drawerCounts[inputVid];
        else drawerCounts[inputVid] = want;
        syncCard(card);
        updateDrawerFooter();
        return;
      }

      var vSelect = e.target.closest('[data-bundle-variant-select]');
      if (!vSelect || !card.contains(vSelect)) return;
      var oldVid = vSelect.getAttribute('data-prev-vid');
      var nv = String(vSelect.value);
      var moved = oldVid != null ? drawerCounts[oldVid] || 0 : 0;
      if (moved && oldVid != null) {
        delete drawerCounts[oldVid];
        drawerCounts[nv] = (drawerCounts[nv] || 0) + moved;
      }
      vSelect.setAttribute('data-prev-vid', nv);
      syncCard(card);
      updateDrawerFooter();
    });
  }

  function applyPendingCartPrefill() {
    var pending = root.getAttribute('data-bb-pending-prefill-vid');
    if (!pending) return;
    var vid = parseInt(pending, 10);
    if (!isFinite(vid) || vid < 1) {
      root.removeAttribute('data-bb-pending-prefill-vid');
      return;
    }
    var found = false;
    for (var pi = 0; pi < cfg.products.length; pi++) {
      var p = cfg.products[pi];
      if (!p || p.drawerExcluded) continue;
      if (!Array.isArray(p.variants)) continue;
      for (var vi = 0; vi < p.variants.length; vi++) {
        if (Number(p.variants[vi].id) === vid) {
          found = true;
          break;
        }
      }
      if (found) break;
    }
    if (!found) return;
    root.removeAttribute('data-bb-pending-prefill-vid');
    drawerCounts = {};
    drawerCounts[String(vid)] = 1;
    slotItems = bkMediaBundleCountsToSlots(cfg.products, drawerCounts, getSlotCountFromDrawerAndTier());
    updateSlotVisibility();
  }

  function afterDrawerCardsAppended() {
    var drawer = getBundleDrawer();
    bkMediaMergeBundleProductsFromMiniJson(drawer || root, cfg);
    applyPendingCartPrefill();
    bindDrawerCards();
    bindDrawerCarouselControls();
    syncAllDrawerCards();
    applyFiltersAndSearch();
    scheduleDrawerBadgePaint(true);
  }

  function bindDrawerCarouselControls() {
    var stopPropagation = function(e) {
      e.stopPropagation();
    };
    getBundleDrawerScope().querySelectorAll('.bk-media-bundle-drawer-card .product-card__media-wrapper:not([data-bb-controls-bound])').forEach(function(w) {
      w.setAttribute('data-bb-controls-bound', 'true');
      w.addEventListener('control:prev', stopPropagation);
      w.addEventListener('control:next', stopPropagation);
      w.addEventListener('control:select', stopPropagation);
    });
  }

  function bindBundleDrawerZoom() {
    var drawerEl = getBundleDrawer();
    if (!drawerEl) return;
    if (drawerEl.getAttribute('data-bb-zoom-bound') === 'true') return;
    drawerEl.setAttribute('data-bb-zoom-bound', 'true');
    document.addEventListener(
      'click',
      function(e) {
        var d = getBundleDrawer();
        var btn = e.target.closest('[data-bundle-drawer-zoom]');
        if (!btn || !d || !d.contains(btn)) return;
        e.preventDefault();
        e.stopPropagation();
        var gallery = btn.closest('product-gallery');
        if (!gallery) {
          var card = btn.closest('[data-bundle-drawer-card]');
          gallery = card && card.querySelector('product-gallery');
        }
        if (!gallery) return;
        var carousel = gallery.querySelector('media-carousel');
        if (!carousel) return;
        var selectedSlide = carousel.selectedSlide;
        if (!selectedSlide) return;
        var mediaId = selectedSlide.getAttribute('data-media-id');
        var imageEls = gallery.querySelectorAll(
          '.product-gallery__media[data-media-type="image"]:not([hidden]) > img'
        );
        var index = 0;
        var found = false;
        if (mediaId) {
          for (var ii = 0; ii < imageEls.length; ii++) {
            var wrap = imageEls[ii].closest('.product-gallery__media');
            if (wrap && wrap.getAttribute('data-media-id') === mediaId) {
              index = ii;
              found = true;
              break;
            }
          }
        }
        if (!found) {
          index = 0;
        }
        var zoomCard = btn.closest('[data-bundle-drawer-card]');
        gallery._bkBundleVorschauCard =
          zoomCard && zoomCard.getAttribute('data-bb-vorschau-panel') === 'true' ? zoomCard : null;
        function ensureBundleDrawerPhotoswipeFocusTrapHooks() {
          var lb = gallery.photoswipe;
          if (lb._bkDrawerFtBound) return;
          lb._bkDrawerFtBound = true;
          lb.on('firstUpdate', function() {
            var dr = getBundleDrawer();
            if (dr && dr.focusTrap && typeof dr.focusTrap.pause === 'function') {
              dr.focusTrap.pause();
            }
          });
          lb.on('destroy', function() {
            var dr = getBundleDrawer();
            if (dr && dr.focusTrap && typeof dr.focusTrap.unpause === 'function') {
              dr.focusTrap.unpause();
            }
          });
        }
        function openLightbox() {
          if (imageEls.length === 0) return;
          var openIndex = Math.min(Math.max(0, index), imageEls.length - 1);
          ensureBundleDrawerPhotoswipeFocusTrapHooks();
          ensureBundleDrawerVorschauHooks(gallery);
          Array.prototype.slice.call(imageEls).forEach(function(img) {
            try {
              void img.offsetHeight;
            } catch (e) {}
          });
          var ds = Array.from(imageEls).map(function(image) {
            var nw = image.naturalWidth || 0;
            var nh = image.naturalHeight || 0;
            var aw = parseInt(image.getAttribute('width'), 10);
            var ah = parseInt(image.getAttribute('height'), 10);
            var w = nw > 0 ? nw : isFinite(aw) && aw > 0 ? aw : 1200;
            var h = nh > 0 ? nh : isFinite(ah) && ah > 0 ? ah : 1200;
            return {
              src: image.currentSrc || image.src,
              width: w,
              height: h,
              alt: image.alt || ''
            };
          });
          gallery.photoswipe.loadAndOpen(openIndex, ds);
        }
        if (window.customElements && typeof customElements.whenDefined === 'function') {
          customElements.whenDefined('product-gallery').then(openLightbox);
        } else {
          openLightbox();
        }
      },
      true
    );
  }

  function bindDrawerCards() {
    getBundleDrawerScope().querySelectorAll('[data-bundle-drawer-card]:not([data-bb-drawer-card-bound])').forEach(function(card) {
      card.setAttribute('data-bb-drawer-card-bound', 'true');
      var vSelect = card.querySelector('[data-bundle-variant-select]');
      if (vSelect && !vSelect.hasAttribute('data-prev-vid')) {
        vSelect.setAttribute('data-prev-vid', vSelect.value);
      }
    });

    var tabsWrap = getBundleDrawerScope().querySelector('[data-bundle-collection-tabs]');
    if (tabsWrap && tabsWrap.getAttribute('data-bb-tabs-bound') !== 'true') {
      tabsWrap.setAttribute('data-bb-tabs-bound', 'true');
      tabsWrap.querySelectorAll('.bk-media-bundle-drawer__filter--collection-tab').forEach(function(tabBtn) {
        if (tabBtn.getAttribute('data-bb-tab-touch') === 'true') return;
        tabBtn.setAttribute('data-bb-tab-touch', 'true');
        tabBtn.addEventListener('touchstart', function() {}, { passive: true });
      });
      tabsWrap.addEventListener(
        'click',
        function(e) {
          var tabBtn = e.target.closest('.bk-media-bundle-drawer__filter--collection-tab');
          if (!tabBtn || !tabsWrap.contains(tabBtn)) return;
          tabsWrap.querySelectorAll('.bk-media-bundle-drawer__filter--collection-tab').forEach(function(b) {
            var on = b === tabBtn;
            b.classList.toggle('is-active', on);
            b.setAttribute('aria-selected', on ? 'true' : 'false');
          });
          syncBundleCollectionPanelsVisibility();
          if (String(tabBtn.getAttribute('data-bundle-collection-id') || '') === 'wishlist') {
            populateBundleDrawerWishlistTab(false);
          } else {
            var tabFeed = null;
            var tabId = String(tabBtn.getAttribute('data-bundle-collection-id') || '');
            if (tabId) {
              var tabGrid = getBundleDrawerScope().querySelector(
                '[data-bundle-collection-grid][data-collection-id="' + tabId + '"]'
              );
              if (tabGrid) tabFeed = tabGrid.querySelector('[data-bb-collection-feed]');
            }
            populateBundleDrawerCollectionFeeds({ feed: tabFeed, priorityOnly: true });
            applyFiltersAndSearch();
          }
          bindDrawerCarouselControls();
          bindBundleDrawerZoom();
          scheduleDrawerBadgePaint(true);
          scrollBundleDrawerActiveCollectionTabIntoView(getBundleDrawer());
        },
        true
      );
    }

    syncBundleCollectionPanelsVisibility();
    applyFiltersAndSearch();
    bindBundleDrawerWishlistCountObserver();
    syncBundleDrawerWishlistTabVisibility();
  }

  function updateDrawerProductSlotBadges(targetSlotIndex) {
    var badgeSlotItems = getDrawerBadgeSlotItems();
    var totalSlotsBadge = badgeSlotItems.length > 0 ? badgeSlotItems.length : Math.max(selectedTier, 1);
    var bundleQty = getAddonCountForBundlePrice();
    var filledNow = getFilledCountForDrawerBadges();
    var html = '';
    if (targetSlotIndex === -1) {
      html = bkMediaBundleSlotBadgeHtml(0, 1, bundleQty, getTierQtyForSlotBadges(), cfg, true, filledNow, true);
    } else if (targetSlotIndex >= 0) {
      html = bkMediaBundleSlotBadgeHtml(
        targetSlotIndex,
        totalSlotsBadge,
        bundleQty,
        getTierQtyForSlotBadges(),
        cfg,
        true,
        filledNow,
        false
      );
    }
    var cardsRoot = getActiveBundleProductCardsRoot();
    var cards = cardsRoot
      ? cardsRoot.querySelectorAll('[data-bundle-drawer-card]')
      : queryBundleDrawerCards();
    var cardCount = cards.length;
    if (
      html === lastDrawerBadgePaint.html &&
      cardCount > 0 &&
      cardCount === lastDrawerBadgePaint.cards
    ) {
      return;
    }
    lastDrawerBadgePaint = { html: html, cards: cardCount };
    for (var ci = 0; ci < cards.length; ci++) {
      var card = cards[ci];
      var mount = card.querySelector('[data-bundle-drawer-slot-badge]');
      if (!mount) continue;
      if (html) {
        mount.innerHTML = html;
        mount.removeAttribute('hidden');
      } else {
        mount.innerHTML = '';
        mount.setAttribute('hidden', '');
      }
    }
  }

  function openDrawer() {
    drawerCounts = bkMediaBundleSlotsToCounts(slotItems);
    var drawerElOpen = getBundleDrawer();
    if (!drawerElOpen) return;
    drawerElOpen.classList.remove('is-footer-ready');
    updateDrawerFooter();
    prepareBundleDrawerContent();
    ensureActiveCollectionFeedPlaceholders();
    if (drawerElOpen.show) drawerElOpen.show();
  }

  if (confirmBtn) {
    confirmBtn.addEventListener('touchstart', function() {}, { passive: true });
    confirmBtn.addEventListener('click', function() {
      var total = getTotalDrawerCount();
      var tierGoal = Math.max(1, chosenTierSlots);
      if (total < tierGoal) return;
      slotItems = bkMediaBundleCountsToSlots(cfg.products, drawerCounts, getSlotCountFromDrawerAndTier());
      updateSlotVisibility();
      var dh = getBundleDrawer();
      if (dh && dh.hide) dh.hide();
    });
  }

  function onBundleDrawerAfterShow() {
    bindBundleDrawerFeedSentinels();
    markBundleDrawerFooterReady();
    loadBundleDrawerFeedsIfNeeded().then(function() {
      scheduleDrawerBadgePaint(true);
      bindDrawerCarouselControls();
    });
    if (isBundleDrawerWishlistTabActive()) {
      populateBundleDrawerWishlistTab(true);
    }
  }
  function onBundleDrawerAfterHide() {
    var drawerEl = getBundleDrawer();
    if (drawerEl) drawerEl.classList.remove('is-footer-ready');
    slotItems = bkMediaBundleCountsToSlots(cfg.products, drawerCounts, getSlotCountFromDrawerAndTier());
    updateSlotVisibility();
  }
  if (cfg.drawerDomId) {
    document.addEventListener(
      'dialog:after-show',
      function(ev) {
        if (!ev.target || ev.target.id !== cfg.drawerDomId) return;
        onBundleDrawerAfterShow();
      },
      false
    );
    document.addEventListener(
      'dialog:after-hide',
      function(ev) {
        if (!ev.target || ev.target.id !== cfg.drawerDomId) return;
        onBundleDrawerAfterHide();
      },
      false
    );
  } else {
    var legacyDrawer = getBundleDrawer();
    if (legacyDrawer) {
      legacyDrawer.addEventListener('dialog:after-show', onBundleDrawerAfterShow);
      legacyDrawer.addEventListener('dialog:after-hide', onBundleDrawerAfterHide);
    }
  }

  if (slotGrid) {
    slotGrid.addEventListener(
      'click',
      function(e) {
        var clearEl = e.target.closest('[data-slot-clear]');
        if (clearEl && root.contains(clearEl)) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          var slotEl = clearEl.closest('.bk-media-bundle-builder__slot');
          if (!slotEl) return;
          var idx = Number(slotEl.getAttribute('data-slot-index'));
          if (isNaN(idx)) return;
          slotItems[idx] = null;
          drawerCounts = bkMediaBundleSlotsToCounts(slotItems);
          updateSlotVisibility();
          return;
        }
        var opener = e.target.closest('[data-open-bundle-drawer]');
        if (!opener || !root.contains(opener)) return;
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        var slotEl = opener.closest('.bk-media-bundle-builder__slot');
        openDrawer();
      },
      true
    );
  }

  variantCards.forEach(function(card) {
    function activateTierCard() {
      var ts = Number(card.getAttribute('data-tier-slots'));
      if (isNaN(ts)) return;
      if (!canSwitchToTierSlots(ts)) return;
      selectedTier = ts;
      chosenTierSlots = ts;
      root.setAttribute('data-initial-tier', String(ts));
      updateTierCards(ts);
      updateSlotVisibility();
    }
    card.addEventListener('click', activateTierCard);
    card.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        activateTierCard();
      }
    });
  });

  if (searchInput) {
    searchInput.addEventListener('input', function() {
      applyFiltersAndSearch();
    });
  }

  bindDrawerCardDelegation();
  bindDrawerCards();
  bindDrawerCarouselControls();
  bindBundleDrawerZoom();
  bindBundleDrawerFeedSentinels();
  scheduleBundleDrawerFeedPrefetch();

  root.querySelectorAll('[data-open-bundle-drawer]').forEach(function(opener) {
    if (opener.getAttribute('data-bb-touch-hint') === 'true') return;
    opener.setAttribute('data-bb-touch-hint', 'true');
    opener.addEventListener('touchstart', function() {}, { passive: true });
  });

  variantCards.forEach(function(vc) {
    if (vc.getAttribute('data-bb-touch-hint') === 'true') return;
    vc.setAttribute('data-bb-touch-hint', 'true');
    vc.addEventListener('touchstart', function() {}, { passive: true });
  });

  syncBundleGalleryForTier();

  form.addEventListener('product:rerender', function() {
    setTimeout(syncBundleGalleryForTier, 0);
    setTimeout(syncBundleGalleryForTier, 150);
  });

  var bundleAddInFlight = false;

  function bundleCompareIncludesGiftForSelectedTier(bundleCfg) {
    var card = root.querySelector('.bk-media-bundle-builder__variant-card.is-selected');
    var step = card ? String(card.getAttribute('data-bundle-tier-step') || '') : '';
    if (step === '1') return !!bundleCfg.tier1IncludePremiumCompare;
    if (step === '2') return !!bundleCfg.tier2IncludePremiumCompare;
    if (step === '3') return !!bundleCfg.tier3IncludePremiumCompare;
    return false;
  }

  function resolvePremiumBundleFreeGiftVariantId(bundleGroupSlug, addonCountUsed, bundleCfg) {
    if (bundleGroupSlug !== 'starter' && bundleGroupSlug !== 'refill') return null;
    if (!bkMediaBundlePremiumGiftUnlocked(addonCountUsed, bundleCfg, root)) return null;
    var vid = bundleCfg.bundleFreeGiftVariantId;
    if (vid == null || vid === '') return null;
    var nvid = Number(vid);
    if (!nvid || isNaN(nvid)) return null;
    return nvid;
  }

  function runBundleAddToCart(btn) {
    if (!btn || btn.disabled || bundleAddInFlight) return;
    var filled = getFilledSlotCount();
    if (filled < getRequiredSelectionsForCart()) {
      if (statusEl) statusEl.setAttribute('hidden', '');
      openDrawer();
      return;
    }
    var mainVid = null;
    if (cfg.forceCheckoutVariant) {
      mainVid = bkMediaBundleResolveCheckoutVariantIdForTierQty(cfg, selectedTier);
    }
    if (mainVid == null || isNaN(mainVid)) {
      var idInput = form.querySelector('input[name="id"]');
      mainVid = idInput ? Number(idInput.value) : null;
    }
    if (!mainVid) {
      if (statusEl) {
        statusEl.textContent = (cfg.strings && cfg.strings.error) || '';
        statusEl.removeAttribute('hidden');
      }
      return;
    }

    var bundleGroupSlug = String(cfg.bundleGroup || 'starter').replace(/[-_]/g, '');
    if (bundleGroupSlug === 'farbenset') bundleGroupSlug = 'refill';
    if (!bundleGroupSlug) bundleGroupSlug = 'bundle';
    var bn = getAddonCountForBundlePrice();
    var premiumGiftVid = resolvePremiumBundleFreeGiftVariantId(bundleGroupSlug, bn, cfg);
    var bundleGroupCart = bundleGroupSlug;
    var bundleKey = bundleGroupCart + '-' + bkMediaBundleRandomId();
    var baseProps = collectFormProperties(form);
    var presetDetail = (cfg.presetVariantDetails || {})[String(selectedTier)];
    var presetImageUrl =
      presetDetail && presetDetail.featuredImageUrl
        ? String(presetDetail.featuredImageUrl)
        : '';
    var mainVidStr = String(mainVid);
    baseProps._DiscountId = bundleKey;
    baseProps._BundleId = bundleKey;
    var parentVidRef =
      mainVid != null && !isNaN(mainVid)
        ? 'gid://shopify/ProductVariant/' + mainVid
        : cfg.checkoutVariantGid && String(cfg.checkoutVariantGid).trim()
          ? String(cfg.checkoutVariantGid).trim()
          : mainVidStr;
    baseProps._BundleParentVariantId = parentVidRef;
    var mergeTitle = cfg.bundleMergeTitle != null ? String(cfg.bundleMergeTitle).trim() : '';
    if (mergeTitle) {
      baseProps._BundleTitle = mergeTitle;
    }
    if (presetImageUrl) {
      baseProps._BundlePresetImage = presetImageUrl;
    }
    var cmpC = bkMediaBundleBundleListCompareCents(bn, cfg, root);
    var payQ = bkMediaBundleBundleTotalCents(bn, cfg, root);
    var discountScaleQty = bkMediaBundleNativeDiscountQtyFromAddons(bn, cfg);
    baseProps._BundleDiscountScaleQty = String(discountScaleQty);
    if (cmpC > 0 && payQ < cmpC) {
      baseProps._BundleListCompareCents = String(Math.round(cmpC));
    }
    if (premiumGiftVid) {
      baseProps._BundleFreeGiftVariantId = String(premiumGiftVid);
    }
    var items = [{ id: mainVid, quantity: 1, properties: baseProps }];

    var agg = {};
    if (Array.isArray(cfg.bundleBaseProductVariantIds)) {
      cfg.bundleBaseProductVariantIds.forEach(function(baseVid) {
        var baseNum = Number(baseVid);
        if (!baseNum || isNaN(baseNum)) return;
        var baseKey = String(baseNum);
        agg[baseKey] = (agg[baseKey] || 0) + 1;
      });
    }
    for (var si = 0; si < slotItems.length; si++) {
      var s = slotItems[si];
      if (s && s.variantId) {
        var kk = String(s.variantId);
        agg[kk] = (agg[kk] || 0) + 1;
      }
    }
    var addonBundleProps = {
      _DiscountId: bundleKey,
      _BundleId: bundleKey,
      _BundleDiscountScaleQty: String(discountScaleQty)
    };
    Object.keys(agg).forEach(function(k) {
      items.push({
        id: Number(k),
        quantity: agg[k],
        properties: addonBundleProps
      });
    });

    if (premiumGiftVid) {
      var giftKeyStr = String(premiumGiftVid);
      if (!agg[giftKeyStr]) {
        items.push({
          id: premiumGiftVid,
          quantity: 1,
          properties: {
            _DiscountId: bundleKey,
            _BundleId: bundleKey,
            _BundleDiscountScaleQty: String(discountScaleQty),
            _BundleFreeGift: 'true'
          }
        });
      }
    }

    if (Object.keys(agg).length === 0) {
      if (statusEl) {
        statusEl.textContent = cfg.strings.incomplete;
        statusEl.removeAttribute('hidden');
      }
      return;
    }

    bundleAddInFlight = true;
    btn.setAttribute('aria-busy', 'true');
    if (statusEl) statusEl.setAttribute('hidden', '');

    var sectionsToBundle = ['variant-added'];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:prepare-bundled-sections', {
        bubbles: true,
        detail: { sections: sectionsToBundle }
      })
    );
    var sectionId = bkMediaGetCartDrawerSectionId();
    if (sectionsToBundle.indexOf(sectionId) === -1) {
      sectionsToBundle.push(sectionId);
    }

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: items, sections: sectionsToBundle.join(',') })
    })
      .then(function(res) {
        if (!res.ok) {
          return res.text().then(function(t) {
            var err;
            try {
              err = JSON.parse(t);
            } catch (e) {
              throw new Error(t.slice(0, 120) || 'Cart error');
            }
            var msg = (err && (err.description || err.message || err.error)) || '';
            throw new Error(typeof msg === 'string' && msg ? msg : 'Cart error');
          });
        }
        return res.json();
      })
      .then(function(responseJson) {
        return fetch(window.Shopify.routes.root + 'cart.js')
          .then(function(r) {
            return r.json();
          })
          .then(function(cartContent) {
            if (!responseJson.sections || !responseJson.sections[sectionId]) {
              return fetch(window.Shopify.routes.root + 'cart?section_id=' + encodeURIComponent(sectionId))
                .then(function(r) {
                  return r.text();
                })
                .then(function(html) {
                  var temp = document.createElement('div');
                  temp.innerHTML = html;
                  var newDrawer = temp.querySelector('#theme-cart-drawer');
                  if (newDrawer) {
                    if (!responseJson.sections) responseJson.sections = {};
                    responseJson.sections[sectionId] = newDrawer.outerHTML;
                  }
                  return { responseJson: responseJson, cartContent: cartContent };
                });
            }
            return { responseJson: responseJson, cartContent: cartContent };
          });
      })
      .then(function(data) {
        var responseJson = data.responseJson;
        var cartContent = data.cartContent;
        if (!cartContent.sections) cartContent.sections = {};
        cartContent.sections = Object.assign(cartContent.sections || {}, responseJson.sections || {});

        var productForm = document.querySelector('form[is="product-form"]');
        var formToUse = productForm || form;
        var formAdded = false;
        if (!formToUse) {
          formToUse = document.createElement('form');
          document.body.appendChild(formToUse);
          formAdded = true;
        }

        var addedItems = responseJson.items;
        if (addedItems && addedItems.length) {
          /* use as-is */
        } else if (responseJson.item) {
          addedItems = [responseJson.item];
        } else {
          addedItems = [responseJson];
        }

        var variantAddEvent = new CustomEvent('variant:add', {
          bubbles: true,
          cancelable: true,
          detail: {
            items: addedItems,
            cart: cartContent
          }
        });
        formToUse.dispatchEvent(variantAddEvent);

        document.documentElement.dispatchEvent(
          new CustomEvent('cart:change', {
            bubbles: true,
            detail: {
              baseEvent: 'variant:add',
              cart: cartContent
            }
          })
        );

        if (formAdded) document.body.removeChild(formToUse);
      })
      .catch(function(err) {
        if (statusEl) {
          statusEl.textContent = (err && err.message) || cfg.strings.error;
          statusEl.removeAttribute('hidden');
        }
      })
      .finally(function() {
        bundleAddInFlight = false;
        btn.removeAttribute('aria-busy');
      });
  }

  window.bkMediaBundleAtcRunByFormId = window.bkMediaBundleAtcRunByFormId || {};
  window.bkMediaBundleAtcRunByFormId[cfg.formId] = { run: runBundleAddToCart };
  if (!window.__bkMediaBundleAtcDocClick) {
    window.__bkMediaBundleAtcDocClick = true;
    document.addEventListener(
      'click',
      function(e) {
        var btn = e.target.closest('[data-bundle-add-to-cart]');
        if (!btn || btn.disabled) return;
        var fid = null;
        var bundleRoot = btn.closest('[data-bundle-builder]');
        if (bundleRoot) {
          fid = bundleRoot.getAttribute('data-form-id');
        } else {
          var qa = btn.closest('product-quick-add');
          if (qa) fid = qa.getAttribute('form');
        }
        if (!fid) return;
        var reg = window.bkMediaBundleAtcRunByFormId[fid];
        if (!reg || typeof reg.run !== 'function') return;
        e.preventDefault();
        reg.run(btn);
      },
      true
    );
  }

  var stickyQuickAdd = document.querySelector('product-quick-add[form="' + cfg.formId + '"]');
  if (stickyQuickAdd) {
    stickyQuickAdd.querySelectorAll('[data-bundle-add-to-cart]').forEach(function(atcBtn) {
      if (atcBtn.getAttribute('data-bb-touch-atc') === 'true') return;
      atcBtn.setAttribute('data-bb-touch-atc', 'true');
      atcBtn.addEventListener('touchstart', function() {}, { passive: true });
    });
  }

  if (cartWrap) {
    cartWrap.querySelectorAll('[data-bundle-add-to-cart]').forEach(function(atcBtn) {
      if (atcBtn.getAttribute('data-bb-touch-atc') === 'true') return;
      atcBtn.setAttribute('data-bb-touch-atc', 'true');
      atcBtn.addEventListener('touchstart', function() {}, { passive: true });
    });
  }

  if (!form.__bkMediaBundleStickyAtc) {
    form.__bkMediaBundleStickyAtc = true;
    form.addEventListener(
      'submit',
      function(e) {
        var sub = e.submitter;
        if (!sub || sub.type !== 'submit') return;
        var qa = sub.closest('product-quick-add');
        if (!qa || qa.getAttribute('form') !== cfg.formId) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        runBundleAddToCart(sub);
      },
      true
    );
  }

  function syncBundleUiFromForm() {
    updateTierCards(selectedTier);
    updateSlotVisibility();
  }

  (function applyCartDrawerBundlePrefill() {
    try {
      var raw = sessionStorage.getItem('bkMediaBundleCartPrefill');
      if (!raw) return;
      sessionStorage.removeItem('bkMediaBundleCartPrefill');
      var vid = parseInt(raw, 10);
      if (!isFinite(vid) || vid < 1) return;
      var found = false;
      for (var pi = 0; pi < cfg.products.length; pi++) {
        var p = cfg.products[pi];
        if (!p || p.drawerExcluded) continue;
        if (!Array.isArray(p.variants)) continue;
        for (var vi = 0; vi < p.variants.length; vi++) {
          if (Number(p.variants[vi].id) === vid) {
            found = true;
            break;
          }
        }
        if (found) break;
      }
      if (!found) {
        root.setAttribute('data-bb-pending-prefill-vid', String(vid));
        return;
      }
      drawerCounts = {};
      drawerCounts[String(vid)] = 1;
      slotItems = bkMediaBundleCountsToSlots(cfg.products, drawerCounts, getSlotCountFromDrawerAndTier());
    } catch (e) {}
  })();

  syncBundleUiFromForm();
  updateDrawerConfirmVisibility();
}

/* ========================================
   BUNDLE STICKY QUICK-ADD
   ======================================== */

var __bkMediaBundleStickyQuickAddObserver = null;

function bkMediaUpdateBundleStickyQuickAddBars() {
  document.querySelectorAll('product-quick-add[form]').forEach(function(bar) {
    var fid = bar.getAttribute('form');
    if (!fid) return;
    var formEl = document.getElementById(fid);
    if (formEl && formEl.classList.contains('product-form--bundle-anchor')) return;

    var bundle = document.querySelector('[data-bundle-builder][data-form-id="' + fid + '"]');
    if (!bundle) return;
    if (!formEl) return;
    var useBundleAnchor =
      formEl.classList.contains('product-form--fallback') || formEl.offsetParent === null;
    if (!useBundleAnchor) return;

    var bundlePassed = bundle.getBoundingClientRect().bottom < 0;
    var footer = document.querySelector('.footer');
    var footerHit = false;
    if (footer) {
      var fr = footer.getBoundingClientRect();
      footerHit = fr.top < window.innerHeight && fr.bottom > 0;
    }

    var visible = bundlePassed && !footerHit;
    var wasVisible = bar.classList.contains('is-visible');
    if (visible !== wasVisible) {
      bar.classList.toggle('is-visible', visible);
    }
  });
}

function bkMediaBindBundleStickyQuickAddObserver() {
  bkMediaDisconnectBundleStickyQuickAddObserver();

  var bundles = document.querySelectorAll('[data-bundle-builder]');
  if (bundles.length === 0) return;

  var legacyBundles = [];
  bundles.forEach(function(bundle) {
    var fid = bundle.getAttribute('data-form-id');
    if (!fid) return;
    var formEl = document.getElementById(fid);
    if (formEl && formEl.classList.contains('product-form--bundle-anchor')) return;
    legacyBundles.push(bundle);
  });

  if (legacyBundles.length === 0) return;

  if (typeof IntersectionObserver === 'undefined') {
    bkMediaUpdateBundleStickyQuickAddBars();
    return;
  }

  __bkMediaBundleStickyQuickAddObserver = new IntersectionObserver(
    function() {
      bkMediaUpdateBundleStickyQuickAddBars();
    },
    { root: null, threshold: [0] }
  );

  legacyBundles.forEach(function(bundle) {
    __bkMediaBundleStickyQuickAddObserver.observe(bundle);
  });

  var footer = document.querySelector('.footer');
  if (footer) {
    __bkMediaBundleStickyQuickAddObserver.observe(footer);
  }

  bkMediaUpdateBundleStickyQuickAddBars();
}

function bkMediaDisconnectBundleStickyQuickAddObserver() {
  if (__bkMediaBundleStickyQuickAddObserver) {
    __bkMediaBundleStickyQuickAddObserver.disconnect();
    __bkMediaBundleStickyQuickAddObserver = null;
  }
}

function initBkMediaBundleStickyQuickAddAnchor() {
  if (document.documentElement.getAttribute('data-bk-sticky-bundle-anchor') === 'true') {
    bkMediaBindBundleStickyQuickAddObserver();
    return;
  }
  document.documentElement.setAttribute('data-bk-sticky-bundle-anchor', 'true');
  document.addEventListener('shopify:section:load', function() {
    setTimeout(bkMediaBindBundleStickyQuickAddObserver, 100);
  });
  document.addEventListener('product:rerender', function() {
    setTimeout(bkMediaBindBundleStickyQuickAddObserver, 200);
  });
  bkMediaBindBundleStickyQuickAddObserver();
}

function bkMediaScheduleBundleBuilderInit() {
  var run = function() {
    initBundleBuilders();
    initBkMediaBundleStickyQuickAddAnchor();
  };

  if (typeof window.requestAnimationFrame === 'function') {
    window.requestAnimationFrame(run);
  } else {
    run();
  }
}

function initBundleBuilders() {
  document.querySelectorAll('[data-bundle-builder]').forEach(initBundleBuilder);
}

function bkMediaInitCartBundleUpgradeCtaHandlers() {
  if (document.documentElement.getAttribute('data-bk-cart-bundle-cta-js') === 'true') return;
  document.documentElement.setAttribute('data-bk-cart-bundle-cta-js', 'true');
  function refresh() {
    document.querySelectorAll('[data-bk-cart-bundle-cta]').forEach(function(el) {
      var k = el.getAttribute('data-line-key');
      if (!k || !window.sessionStorage) return;
      try {
        if (sessionStorage.getItem('bkCartBundleCtaDismiss:' + k) === '1') {
          el.setAttribute('hidden', '');
          return;
        }
      } catch (e) {}
      el.removeAttribute('hidden');
    });
  }
  document.addEventListener(
    'click',
    function(e) {
      var btn = e.target.closest('[data-bk-cart-bundle-cta-dismiss]');
      if (btn) {
        var cta = btn.closest('[data-bk-cart-bundle-cta]');
        if (cta) {
          var k = cta.getAttribute('data-line-key');
          try {
            if (k) sessionStorage.setItem('bkCartBundleCtaDismiss:' + k, '1');
          } catch (err) {}
          cta.setAttribute('hidden', '');
        }
        return;
      }
      var a = e.target.closest('a[data-bk-bundle-cart-prefill]');
      if (!a) return;
      var vid = a.getAttribute('data-bk-bundle-cart-prefill');
      var prefillFormId = a.getAttribute('data-bk-bundle-prefill-form');
      if (prefillFormId) {
        var prefillForm = document.getElementById(prefillFormId);
        var idInput = prefillForm && prefillForm.querySelector('input[name="id"]');
        if (idInput && idInput.value) vid = idInput.value;
      }
      if (!vid || !window.sessionStorage) return;
      try {
        sessionStorage.setItem('bkMediaBundleCartPrefill', vid);
      } catch (err) {}
    },
    true
  );
  document.addEventListener('cart:change', function() {
    setTimeout(refresh, 80);
  });
  document.addEventListener('shopify:section:load', function() {
    setTimeout(refresh, 80);
  });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh);
  } else {
    refresh();
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function() {
    bkMediaScheduleBundleBuilderInit();
    initCollectionSwitcherScrollSelected();
    initCollectionSwitcherWishlist();
    scheduleCollectionSwitcherActiveScroll();
    initCollectionLoadMore();
    bkMediaInitCartBundleUpgradeCtaHandlers();
  });
} else {
  bkMediaScheduleBundleBuilderInit();
  initCollectionSwitcherScrollSelected();
  initCollectionSwitcherWishlist();
  scheduleCollectionSwitcherActiveScroll();
  initCollectionLoadMore();
  bkMediaInitCartBundleUpgradeCtaHandlers();
}

window.addEventListener('load', scheduleCollectionSwitcherActiveScroll);

window.addEventListener('pageshow', function(e) {
  if (e.persisted) scheduleCollectionSwitcherActiveScroll();
});

document.addEventListener('product:rerender', function() {
  setTimeout(bkMediaScheduleBundleBuilderInit, 150);
});

document.addEventListener('shopify:section:load', function() {
  setTimeout(function() {
    bkMediaScheduleBundleBuilderInit();
    initCollectionSwitcherScrollSelected();
    initCollectionSwitcherWishlist();
    scheduleCollectionSwitcherActiveScroll();
  }, 100);
});

/* ========================================
   BUNDLE BUILDER ANCHOR SCROLL
   ======================================== */

function initBundleBuilderHashScroll() {
  if (window.location.hash !== '#bundle-builder') return;
  var target = document.getElementById('bundle-builder');
  if (!target) return;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function run() {
    target.scrollIntoView({
      behavior: reduce ? 'auto' : 'smooth',
      block: 'start'
    });
  }
  setTimeout(run, 150);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initBundleBuilderHashScroll);
} else {
  initBundleBuilderHashScroll();
}

window.addEventListener('hashchange', initBundleBuilderHashScroll);

/* ========================================
   PRODUCT CARD CAROUSEL → PRODUCT URL
   ======================================== */

function initBkMediaProductCardCarouselProductLink() {
  if (document.documentElement.getAttribute('data-bk-product-card-carousel-link') === 'true') return;
  document.documentElement.setAttribute('data-bk-product-card-carousel-link', 'true');
  document.addEventListener(
    'click',
    function (e) {
      if (e.defaultPrevented) return;
      if (e.target.closest('.bk-media-bundle-drawer-card')) return;
      if (e.target.closest('button, a[href], [data-bundle-drawer-zoom], label')) return;
      var carousel = e.target.closest('media-carousel.product-card__carousel');
      if (!carousel) return;
      var card = carousel.closest('product-card');
      if (!card) return;
      var infoLink = card.querySelector('a.product-card__info-link[href]');
      if (!infoLink) return;
      e.preventDefault();
      e.stopPropagation();
      infoLink.click();
    },
    true
  );
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initBkMediaProductCardCarouselProductLink);
} else {
  initBkMediaProductCardCarouselProductLink();
}

function initMultiGoalFreeShippingBar() {
  customElements.whenDefined('free-shipping-bar').then(function () {
    var FreeShippingBar = customElements.get('free-shipping-bar');
    if (!FreeShippingBar) return;
    if (FreeShippingBar.prototype._bkMediaMultiGoalPatched) {
      document.querySelectorAll('free-shipping-bar[data-multi-goal]').forEach(function (el) {
        if (el._updateMessage) el._updateMessage();
      });
      return;
    }
    FreeShippingBar.prototype._bkMediaMultiGoalPatched = true;
    var originalUpdateMessage = FreeShippingBar.prototype._updateMessage;
    FreeShippingBar.prototype._updateMessage = function () {
      var messageElement = this.querySelector('span');
      if (!messageElement) return;
      if (this.hasAttribute('data-multi-goal')) {
        var prefix = this.getAttribute('data-message-prefix') || 'Nur noch';
        var goals = [
          { amount: parseFloat(this.getAttribute('data-goal-1-amount')), message: this.getAttribute('data-goal-1-message') },
          { amount: parseFloat(this.getAttribute('data-goal-2-amount')), message: this.getAttribute('data-goal-2-message') },
          { amount: parseFloat(this.getAttribute('data-goal-3-amount')), message: this.getAttribute('data-goal-3-message') },
          { amount: parseFloat(this.getAttribute('data-goal-4-amount')), message: this.getAttribute('data-goal-4-message') }
        ].filter(function (g) {
          return g.amount > 0;
        });
        var self = this;
        var nextGoal = goals.find(function (g) {
          return self.totalPrice < g.amount;
        });
        function accentGratis(str) {
          return (str || '').replace(/GRATIS/gi, '<span class="bold text-accent k7-gratis-accent">$&</span>');
        }
        function formatCompactCurrency(cents) {
          var amount = cents / 100;
          var hasFraction = Math.round(amount * 100) % 100 !== 0;
          return new Intl.NumberFormat(Shopify.locale, {
            style: 'currency',
            currency: Shopify.currency.active,
            minimumFractionDigits: hasFraction ? 2 : 0,
            maximumFractionDigits: 2
          })
            .format(amount)
            .replace(/\$/g, '$$$$');
        }
        if (!nextGoal) {
          messageElement.innerHTML = accentGratis(this.getAttribute('reached-message'));
        } else {
          var amountFormatted = formatCompactCurrency(nextGoal.amount - this.totalPrice);
          messageElement.innerHTML =
            prefix + ' <span class="bold text-accent">' + amountFormatted + '</span> ' + accentGratis(nextGoal.message || '');
        }
      } else {
        originalUpdateMessage.call(this);
      }
    };
    function refreshAllMultiGoalBars() {
      document.querySelectorAll('free-shipping-bar[data-multi-goal]').forEach(function (el) {
        if (el._updateMessage) el._updateMessage();
      });
    }
    refreshAllMultiGoalBars();
    document.addEventListener('cart:change', function () {
      setTimeout(refreshAllMultiGoalBars, 50);
    });
    document.addEventListener('shopify:section:load', function () {
      setTimeout(refreshAllMultiGoalBars, 100);
    });
  });
}
initMultiGoalFreeShippingBar();

/* ========================================
   HEADER SCROLL REVEAL
   ======================================== */

(function () {
  var HEADER_ANIM_MS = 200;
  var HEADER_ANIM_EASING = 'ease';

  var abortController = null;
  var resizeObserver = null;

  function teardownHeaderScrollReveal() {
    if (abortController) {
      abortController.abort();
      abortController = null;
    }
    if (resizeObserver) {
      resizeObserver.disconnect();
      resizeObserver = null;
    }
  }

  function notifyStickyDependentSections() {
    window.dispatchEvent(new Event('scroll'));
  }

  function initHeaderScrollReveal() {
    teardownHeaderScrollReveal();
    document.documentElement.style.setProperty('--header-scroll-reveal-active', '0');

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return;
    }

    var storeHeader = document.querySelector('store-header.header[data-bk-header-scroll-reveal]');
    if (!storeHeader) {
      return;
    }

    var section = storeHeader.closest('.shopify-section--header');
    var obs = storeHeader.closest('height-observer');
    var placeholder = section && section.querySelector('.bk-media-header-scroll-placeholder');
    if (!section || !obs || !placeholder) {
      return;
    }

    function isHeaderNavDrawerOpen() {
      var toggles = section.querySelectorAll('[aria-expanded="true"][aria-controls]');
      for (var j = 0; j < toggles.length; j++) {
        var cid = toggles[j].getAttribute('aria-controls');
        if (!cid) continue;
        var panel = document.getElementById(cid);
        if (panel && panel.localName === 'navigation-drawer') {
          return true;
        }
      }
      var drawers = document.querySelectorAll('navigation-drawer[open]');
      for (var i = 0; i < drawers.length; i++) {
        var id = drawers[i].id;
        if (id && section.querySelector('[aria-controls="' + id + '"]')) {
          return true;
        }
      }
      return false;
    }

    obs.classList.remove('bk-media-header--pin-target');
    placeholder.style.height = '0';
    storeHeader.style.transform = '';

    var lastY = window.scrollY;
    var pinned = false;
    var animating = false;
    var rafScheduled = false;
    var headerMotionAnimation = null;

    function cancelHeaderMotionAnimation() {
      if (headerMotionAnimation && typeof headerMotionAnimation.cancel === 'function') {
        try {
          headerMotionAnimation.cancel();
        } catch (e) {}
      }
      headerMotionAnimation = null;
    }

    function headerHeightApprox() {
      var raw = getComputedStyle(document.documentElement).getPropertyValue('--header-height');
      var px = parseFloat(raw);
      return !isNaN(px) && px > 0 ? px : obs.offsetHeight || 72;
    }

    function syncNaturalHeaderVisibility() {
      if (pinned || animating) {
        return;
      }
      if (isHeaderNavDrawerOpen()) {
        var prevOpen = getComputedStyle(document.documentElement).getPropertyValue('--header-is-visible').trim() || '1';
        if (prevOpen !== '1') {
          document.documentElement.style.setProperty('--header-is-visible', '1');
          notifyStickyDependentSections();
        }
        return;
      }
      var r = obs.getBoundingClientRect();
      var next = r.bottom > 0 ? '1' : '0';
      var prev = getComputedStyle(document.documentElement).getPropertyValue('--header-is-visible').trim() || '1';
      if (next === prev) {
        return;
      }
      document.documentElement.style.setProperty('--header-is-visible', next);
      notifyStickyDependentSections();
    }

    function instantUnpinNearTop() {
      cancelHeaderMotionAnimation();
      animating = true;
      storeHeader.style.transform = '';
      placeholder.style.height = '0';
      obs.classList.remove('bk-media-header--pin-target');
      document.documentElement.style.setProperty('--header-scroll-reveal-active', '0');
      pinned = false;
      animating = false;
      syncNaturalHeaderVisibility();
    }

    function syncPlaceholderWhilePinned() {
      if (!pinned) {
        return;
      }
      var h = obs.offsetHeight;
      if (h > 0) {
        placeholder.style.height = h + 'px';
      }
    }

    function slideInPinnedBar() {
      if (pinned || animating) {
        return;
      }
      animating = true;
      pinned = true;

      var h = obs.offsetHeight;
      placeholder.style.height = h + 'px';
      obs.classList.add('bk-media-header--pin-target');
      document.documentElement.style.setProperty('--header-scroll-reveal-active', '1');
      document.documentElement.style.setProperty('--header-is-visible', '1');
      notifyStickyDependentSections();

      cancelHeaderMotionAnimation();
      headerMotionAnimation = storeHeader.animate(
        [{ transform: 'translateY(-100%)' }, { transform: 'translateY(0)' }],
        { duration: HEADER_ANIM_MS, easing: HEADER_ANIM_EASING, fill: 'forwards' }
      );

      headerMotionAnimation.finished
        .then(function () {
          storeHeader.style.transform = '';
          animating = false;
          notifyStickyDependentSections();
        })
        .catch(function () {
          animating = false;
        });
    }

    function slideOutPinnedBar() {
      if (!pinned || animating) {
        return;
      }
      if (isHeaderNavDrawerOpen()) {
        return;
      }
      animating = true;

      document.documentElement.style.setProperty('--header-is-visible', '0');
      notifyStickyDependentSections();

      cancelHeaderMotionAnimation();
      headerMotionAnimation = storeHeader.animate(
        [{ transform: 'translateY(0)' }, { transform: 'translateY(-100%)' }],
        { duration: HEADER_ANIM_MS, easing: HEADER_ANIM_EASING, fill: 'forwards' }
      );

      headerMotionAnimation.finished
        .then(function () {
          storeHeader.style.transform = '';
          placeholder.style.height = '0';
          obs.classList.remove('bk-media-header--pin-target');
          document.documentElement.style.setProperty('--header-scroll-reveal-active', '0');
          pinned = false;
          animating = false;
          syncNaturalHeaderVisibility();
        })
        .catch(function () {
          animating = false;
        });
    }

    resizeObserver = new ResizeObserver(function () {
      syncPlaceholderWhilePinned();
    });
    resizeObserver.observe(obs);

    function onScroll() {
      var y = window.scrollY;
      var delta = y - lastY;
      var hh = headerHeightApprox();
      var rect = obs.getBoundingClientRect();

      if (animating) {
        lastY = y;
        return;
      }

      if (pinned) {
        if (y < hh + 24 && !isHeaderNavDrawerOpen()) {
          instantUnpinNearTop();
        } else if (delta > 2 && !isHeaderNavDrawerOpen()) {
          slideOutPinnedBar();
        }
        lastY = y;
        return;
      }

      syncNaturalHeaderVisibility();

      if (y < 8) {
        lastY = y;
        return;
      }

      if (rect.bottom > 0) {
        lastY = y;
        return;
      }

      if (delta < -2) {
        slideInPinnedBar();
      }

      lastY = y;
    }

    function scheduleScroll() {
      if (rafScheduled) {
        return;
      }
      rafScheduled = true;
      requestAnimationFrame(function () {
        rafScheduled = false;
        onScroll();
      });
    }

    abortController = new AbortController();
    var signal = abortController.signal;

    window.addEventListener('scroll', scheduleScroll, { passive: true, signal: signal });
    window.addEventListener(
      'resize',
      function () {
        syncPlaceholderWhilePinned();
        syncNaturalHeaderVisibility();
      },
      { passive: true, signal: signal }
    );

    document.addEventListener(
      'dialog:after-show',
      function (e) {
        var t = e.target;
        if (!(t instanceof Element) || t.tagName !== 'NAVIGATION-DRAWER') {
          return;
        }
        if (!t.id || !section.querySelector('[aria-controls="' + t.id + '"]')) {
          return;
        }
        document.documentElement.style.setProperty('--header-is-visible', '1');
        notifyStickyDependentSections();
        scheduleScroll();
      },
      { capture: true, signal: signal }
    );

    document.addEventListener(
      'dialog:after-hide',
      function (e) {
        var t = e.target;
        if (!(t instanceof Element) || t.tagName !== 'NAVIGATION-DRAWER') {
          return;
        }
        if (!t.id || !section.querySelector('[aria-controls="' + t.id + '"]')) {
          return;
        }
        scheduleScroll();
        notifyStickyDependentSections();
      },
      { capture: true, signal: signal }
    );

    lastY = window.scrollY;
    syncNaturalHeaderVisibility();
    notifyStickyDependentSections();
    onScroll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHeaderScrollReveal);
  } else {
    initHeaderScrollReveal();
  }

  document.addEventListener('shopify:section:load', function () {
    setTimeout(initHeaderScrollReveal, 50);
  });
})();

/* ========================================
   MOBILE NAV DRAWER TOP
   ======================================== */

(function () {
  var mobileNavTopAbort = null;
  var mobileNavTopRo = null;
  var mobileNavTopRaf = false;

  function getMainHeaderHeightObserver() {
    var headerSection = document.querySelector('.shopify-section--header');
    if (!headerSection) return null;
    return (
      headerSection.querySelector('height-observer[variable="header"]') ||
      headerSection.querySelector('height-observer')
    );
  }

  function syncMobileNavDrawerTop() {
    var obs = getMainHeaderHeightObserver();
    if (!obs) return;
    var bottom = Math.round(obs.getBoundingClientRect().bottom);
    if (bottom < 0) bottom = 0;
    document.documentElement.style.setProperty('--mobile-nav-drawer-top', bottom + 'px');
  }

  function scheduleMobileNavDrawerTop() {
    if (mobileNavTopRaf) return;
    mobileNavTopRaf = true;
    requestAnimationFrame(function () {
      mobileNavTopRaf = false;
      syncMobileNavDrawerTop();
    });
  }

  function teardownMobileNavDrawerTop() {
    if (mobileNavTopAbort) {
      mobileNavTopAbort.abort();
      mobileNavTopAbort = null;
    }
    if (mobileNavTopRo) {
      mobileNavTopRo.disconnect();
      mobileNavTopRo = null;
    }
  }

  function initMobileNavDrawerTop() {
    teardownMobileNavDrawerTop();
    mobileNavTopAbort = new AbortController();
    var signal = mobileNavTopAbort.signal;

    syncMobileNavDrawerTop();

    window.addEventListener('scroll', scheduleMobileNavDrawerTop, { passive: true, signal: signal });
    window.addEventListener('resize', scheduleMobileNavDrawerTop, { passive: true, signal: signal });
    window.addEventListener('orientationchange', scheduleMobileNavDrawerTop, { passive: true, signal: signal });

    document.addEventListener(
      'dialog:after-show',
      function (e) {
        if (e.target && e.target.id === 'header-sidebar-menu') {
          requestAnimationFrame(function () {
            requestAnimationFrame(syncMobileNavDrawerTop);
          });
        }
      },
      { capture: true, signal: signal }
    );

    document.addEventListener(
      'dialog:after-hide',
      function (e) {
        if (e.target && e.target.id === 'header-sidebar-menu') {
          scheduleMobileNavDrawerTop();
        }
      },
      { capture: true, signal: signal }
    );

    if (window.ResizeObserver) {
      mobileNavTopRo = new ResizeObserver(scheduleMobileNavDrawerTop);
      var obsEl = getMainHeaderHeightObserver();
      if (obsEl) mobileNavTopRo.observe(obsEl);
      var ann = document.querySelector('.shopify-section--announcement-bar, .shopify-section--announcement-bar-block');
      if (ann) mobileNavTopRo.observe(ann);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMobileNavDrawerTop, { once: true });
  } else {
    initMobileNavDrawerTop();
  }

  document.addEventListener('shopify:section:load', function () {
    setTimeout(initMobileNavDrawerTop, 50);
  });
})();

/* ========================================
   SEARCH DRAWER — CLOSE MOBILE NAV
   ======================================== */

(function () {
  function onSearchOpenClick(event) {
    var btn = event.target.closest('.bk-media-header-search-open');
    if (!btn) return;
    var sidebar = document.getElementById('header-sidebar-menu');
    if (!sidebar) return;
    if (typeof sidebar.hide === 'function') {
      sidebar.hide();
    } else if (sidebar.hasAttribute('open')) {
      sidebar.removeAttribute('open');
    }
  }

  document.body.addEventListener('click', onSearchOpenClick, true);
})();
